/* eslint-disable prettier/prettier */
// prettier-ignore-file
import SurveySchema from '@ax2/common/model/schemas/SurveySchema';
import ScreenerQuestionSchema from '@ax2/common/model/schemas/ScreenerQuestionSchema';
import QuestionResults from 'model/reports/QuestionResults';
import { AnswersCount } from 'model/reports/AnswersCount';

export const getMockedScreeners = (): ScreenerQuestionSchema[] => [
  {
    "purposeTitle": "Knowledgeability",
    "purposeText":
      "This question removes respondents who rate their knowledge less than 5 on a 7-pt scale.",
    "screenout": [
      "a36630f9-167c-4e23-a0d3-d407757ba15d",
      "a4d7dd42-0e36-4717-ac77-9980d2f15304",
      "72b3d1fa-ed02-4905-8672-f96f8ec2da0a",
      "0b77aa7f-d399-4d7b-8c30-0ef7d338afcf"
    ],
    "screenoutStrategy": "Match",
    "allowedPanels":["PhysicianSurvey"],
    "id": "7317e9be-535b-4496-b067-8b96a530e352",
    "questionTemplateId": null,
    "order": 0,
    "questionType": "RatingList",
    "isExclusivePerRow": null,
    "isRequired": true,
    "isLocked": true,
    "requiredOptions": {
      "strategy": "OnePerRow"
    },
    "randomizeColumn": false,
    "randomizeRow": false,
    "title": null,
    "content": {
      "template":
        "Please rate how knowledgeable you are about %%0.",
      "groups": {
        "0": {
          "placeholder":
            "insert therapeutic area/sub-specialty/topic/product",
          "text": null
        }
      }
    },
    "description": null,
    "columns": [
      {
        "id": "a36630f9-167c-4e23-a0d3-d407757ba15d",
        "order": 0,
        "label": "1",
        "content": { "template": "Not at all knowledgeable" },
        "typ": "Standard"
      },
      {
        "id": "a4d7dd42-0e36-4717-ac77-9980d2f15304",
        "order": 1,
        "label": "2",
        "content": { "template": "" },
        "typ": "Standard"
      },
      {
        "id": "72b3d1fa-ed02-4905-8672-f96f8ec2da0a",
        "order": 2,
        "label": "3",
        "content": { "template": "" },
        "typ": "Standard"
      },
      {
        "id": "0b77aa7f-d399-4d7b-8c30-0ef7d338afcf",
        "order": 3,
        "label": "4",
        "content": { "template": "" },
        "typ": "Standard"
      },
      {
        "id": "502c27f8-eb33-4cad-bab4-1e61ffdad004",
        "order": 4,
        "label": "5",
        "content": { "template": "" },
        "typ":"Standard"
      },
      {
        "id": "2b99c161-636b-40c3-ba7e-73d4a4f59f0b",
        "order": 5,
        "label": "6",
        "content": { "template": "" },
        "typ": "Standard"
      },
      {
        "id": "400bcc79-311f-4ede-b9d2-734d071f239f",
        "order": 6,
        "label": "7",
        "content": { "template": "Extremely knowledgeable" },
        "typ": "Standard"
      }
    ],
    "rows": [
      {
        "id": "d6162edd-c37d-440c-8168-c90e6c683f83",
        "order": 1,
        "label": null,
        "content": { "template": "" },
        "typ": "Standard"
      }
    ]
  },
  {
    "purposeTitle": "Knowledgeability",
    "purposeText":
      "This question removes respondents who rate their knowledge less than 5 on a 7-pt scale.",
    "screenout": [
      "a36630f9-167c-4e23-a0d3-d407757ba15d",
      "a4d7dd42-0e36-4717-ac77-9980d2f15304",
      "72b3d1fa-ed02-4905-8672-f96f8ec2da0a",
      "0b77aa7f-d399-4d7b-8c30-0ef7d338afcf"
    ],
    "screenoutStrategy": "Match",
    "allowedPanels":["HealthPlan","HealthPlanAndPbm", "HospitalNetwork", "HealthPlanAndHospitalNetwork", "OncologyCenter"],
    "id": "94fcca6c-6219-4b0d-a104-c2f2b52d7bcb",
    "questionTemplateId": null,
    "order": 0,
    "questionType": "RatingList",
    "isExclusivePerRow": null,
    "isRequired": true,
    "isLocked": true,
    "requiredOptions": {
      "strategy": "OnePerRow"
    },
    "randomizeColumn": false,
    "randomizeRow": false,
    "title": null,
    "content": {
      "template":
        "Please rate how knowledgeable you are about your organization’s management of %%0.",
      "groups": {
        "0": {
          "placeholder":
            "insert therapeutic area/topic/type of product or device",
          "text": null
        }
      }
    },
    "description": null,
    "columns": [
      {
        "id": "a36630f9-167c-4e23-a0d3-d407757ba15d",
        "order": 0,
        "label": "1",
        "content": { "template": "Not at all knowledgeable" },
        "typ": "Standard"
      },
      {
        "id": "a4d7dd42-0e36-4717-ac77-9980d2f15304",
        "order": 1,
        "label": "2",
        "content": { "template": "" },
        "typ": "Standard"
      },
      {
        "id": "72b3d1fa-ed02-4905-8672-f96f8ec2da0a",
        "order": 2,
        "label": "3",
        "content": { "template": "" },
        "typ": "Standard"
      },
      {
        "id": "0b77aa7f-d399-4d7b-8c30-0ef7d338afcf",
        "order": 3,
        "label": "4",
        "content": { "template": "" },
        "typ": "Standard"
      },
      {
        "id": "502c27f8-eb33-4cad-bab4-1e61ffdad004",
        "order": 4,
        "label": "5",
        "content": { "template": "" },
        "typ":"Standard"
      },
      {
        "id": "2b99c161-636b-40c3-ba7e-73d4a4f59f0b",
        "order": 5,
        "label": "6",
        "content": { "template": "" },
        "typ": "Standard"
      },
      {
        "id": "400bcc79-311f-4ede-b9d2-734d071f239f",
        "order": 6,
        "label": "7",
        "content": { "template": "Extremely knowledgeable" },
        "typ": "Standard"
      }
    ],
    "rows": [
      {
        "id": "d6162edd-c37d-440c-8168-c90e6c683f83",
        "order": 1,
        "label": null,
        "content": { "template": "" },
        "typ": "Standard"
      }
    ]
  },
  {
    "purposeTitle": "P&T",
    "purposeText":
      "This question removes respondents who say they are not involved in their P&T committee in these capacities.",
    "screenout": ["24d9d786-1200-464a-917f-282264977af9"],
    "screenoutStrategy": "Match",
    "allowedPanels":["HealthPlan","HealthPlanAndPbm", "HospitalNetwork", "HealthPlanAndHospitalNetwork", "PhysicianSurvey"],
    "id": "60b3e3f3-42b5-4201-937a-ea4fda64ba8d",
    "questionTemplateId": null,
    "order": 1,
    "questionType": "CheckboxList",
    "isRequired": true,
    "isLocked": true,
    "randomize": true,
    "requiredOptions": null,
    "title": null,
    "content": {
      "template":
        "Please select the statements that describe your P&T involvement."
    },
    "description": null,
    "answerOptions": [
      {
        "id": "1cb5c6ae-06a3-48dd-a8ed-6ed803b89ad6",
        "order": 0,
        "label": null,
        "content": {
          "template":
            "I am a member of my organization’s P&T formulary committee"
        },
        "typ": "Standard"
      },
      {
        "id": "3f314ea7-4c48-4af5-b44a-670090a407b6",
        "order": 1,
        "label": null,
        "content": {
          "template":
            "I provide economic or clinical input to my P&T committee"
        },
        "typ": "Standard"
      },
      {
        "id": "fd2795d8-1dd4-4c31-9770-262de3879b25",
        "order": 2,
        "label": null,
        "content": { "template": "I prepare/present drug reviews for P&T committee review" },
        "typ": "Standard"
      },
      {
        "id": "086ebba4-ffc9-4fd2-9dfa-ee2d2c3c0d3d",
        "order": 3,
        "label": null,
        "content": { "template": "I review contracting/rebate offers by manufacturers for P&T committee" },
        "typ": "Standard"
      },
      {
        "id": "24d9d786-1200-464a-917f-282264977af9",
        "order": 4,
        "label": null,
        "content": { "template": "I am not involved with my P&T committee in the capacities outlined above" },
        "typ": "NA"
      }
    ]
  },
  {
    "purposeTitle": "Interaction with biopharma",
    "purposeText":
      "This question removes respondents who say they have not met with a biopharmaceutical company in the past year, indicating they are not appropriate for a customer relationship assessment survey.",
    "screenout": ["f68b31fe-bb64-404f-968f-064594de147f"],
    "screenoutStrategy": "Match",
    "allowedPanels":["HealthPlan","HealthPlanAndPbm", "HospitalNetwork", "HealthPlanAndHospitalNetwork", "OncologyCenter", "PhysicianSurvey"],
    "id": "f83dbe86-0133-4491-a459-b66a0fd333c7",
    "questionTemplateId": null,
    "order": 2,
    "questionType": "RadioButtonList",
    "isRequired": true,
    "isLocked": true,
    "randomize": false,
    "requiredOptions": null,
    "title": null,
    "content": {
      "template":
        "In the past 12 months, have you met with an account management professional or representative of a biopharmaceutical company?"
    },
    "description": null,
    "answerOptions": [
      {
        "id": "a1f16be8-2252-4f03-bc6c-366061826d22",
        "order": 0,
        "label": null,
        "content": { "template": "Yes" },
        "typ": "Standard"
      },
      {
        "id": "f68b31fe-bb64-404f-968f-064594de147f",
        "order": 1,
        "label": null,
        "content": { "template": "No" },
        "typ": "Standard"
      }
    ]
  },
  {
    "purposeTitle": "Adverse Event Consent to Contact",
    "purposeText":
      "This question captures a respondent’s willingness to be contacted in the case of an adverse event.",
    "screenout": ["eb30fbf5-f504-4cb7-a932-58aa0b62315d"],
    "screenoutStrategy": "Match",
    "allowedPanels":["HealthPlan","HealthPlanAndPbm", "HospitalNetwork", "HealthPlanAndHospitalNetwork", "OncologyCenter", "PhysicianSurvey"],
    "id": "d3477661-92db-4f53-9b63-3d7390543100",
    "questionTemplateId": null,
    "order": 3,
    "questionType": "RadioButtonList",
    "isRequired": true,
    "isLocked": true,
    "randomize": false,
    "requiredOptions": null,
    "title": null,
    "content": {
      "template":
        "In the interest of protecting the public health, any possible medication side effects and other adverse events (AEs) will receive in-depth review by the manufacturer and the FDA. This information helps manufacturers learn more about the safety of their medicines and products.\n\nAll personal information you share about yourself or others will be handled confidentially. You will also be able to remain anonymous, should you choose, and your name will not be linked with any other of your survey responses."
    },
    "description": null,
    "answerOptions": [
      {
        "id": "c0788785-346a-49e5-8930-6fafb46600c9",
        "order": 0,
        "label": null,
        "content": {
          "template":
            "I want to continue with the survey, and I consent to having my contact information sent to the client if I mention an adverse event"
        },
        "typ": "Standard"
      },
      {
        "id": "da5f204a-50d2-4d22-b8b2-bd08f0be1598",
        "order": 1,
        "label": null,
        "content": {
          "template":
            "I want to continue with the survey, but I do NOT consent to having my contact information shared with the client if I mention an adverse event"
        },
        "typ": "Standard"
      },
      {
        "id": "eb30fbf5-f504-4cb7-a932-58aa0b62315d",
        "order": 2,
        "label": null,
        "content": { "template": "I do not want to continue with the survey" },
        "typ": "Standard"
      }
    ]
  },
  {
    "purposeTitle": "Commercial respondent",
    "purposeText":
      "This question removes respondents who say they do not make decisions for commercial/private insurance plans.",
    "screenout": ["6ff3d183-50f5-44b1-857b-f4ae67ace03e"],
    "screenoutStrategy": "NotMatch",
    "allowedPanels":["HealthPlan","HealthPlanAndPbm"],
    "id": "e0e6726e-ab02-4c7f-b10a-490a218fd2a8",
    "questionTemplateId": null,
    "order": 4,
    "questionType": "CheckboxList",
    "isRequired": true,
    "isLocked": true,
    "randomize": true,
    "requiredOptions": null,
    "title": null,
    "content": {
      "template":
        "For which of the following business lines do you have decision-making responsibilities?"
    },
    "description": null,
    "answerOptions": [
      {
        "id": "6ff3d183-50f5-44b1-857b-f4ae67ace03e",
        "order": 0,
        "label": null,
        "content": { "template": "Commercial/private" },
        "typ": "Standard"
      },
      {
        "id": "939c2c5e-2ec8-4490-a524-3d95ab92556e",
        "order": 1,
        "label": null,
        "content": { "template": "Medicare Part D" },
        "typ": "Standard"
      },
      {
        "id": "add8748d-84c0-4ff0-a9f7-6e861d306b3a",
        "order": 2,
        "label": null,
        "content": { "template": "Managed Medicaid" },
        "typ": "Standard"
      },
      {
        "id": "7f7ce2c3-d923-4cd9-b308-878a548e7880",
        "order": 3,
        "label": null,
        "content": { "template": "None of the above" },
        "typ": "NA"
      }
    ]
  },
  {
    "purposeTitle": "Medicare Part D respondent",
    "purposeText":
      "This question removes respondents who say they do not make decisions for Medicare Part D insurance plans.",
    "screenout": ["5cbb7f6b-45bb-49d6-96ea-81c4f5b9c1cd"],
    "screenoutStrategy": "NotMatch",
    "allowedPanels":["HealthPlan","HealthPlanAndPbm"],
    "id": "98539dda-4308-4c56-a01e-4b31818d8117",
    "questionTemplateId": null,
    "order": 5,
    "questionType": "CheckboxList",
    "isRequired": true,
    "isLocked": true,
    "randomize": true,
    "requiredOptions": null,
    "title": null,
    "content": {
      "template":
        "For which of the following business lines do you have decision-making responsibilities?"
    },
    "description": null,
    "answerOptions": [
      {
        "id": "46cb82de-7089-4dd2-afad-ed11ddc081c0",
        "order": 0,
        "label": null,
        "content": { "template": "Commercial/private" },
        "typ": "Standard"
      },
      {
        "id": "5cbb7f6b-45bb-49d6-96ea-81c4f5b9c1cd",
        "order": 1,
        "label": null,
        "content": { "template": "Medicare Part D" },
        "typ": "Standard"
      },
      {
        "id": "1274108e-10f0-4f70-b82d-ce3972a63d38",
        "order": 2,
        "label": null,
        "content": { "template": "Managed Medicaid" },
        "typ": "Standard"
      },
      {
        "id": "3c3e94e7-fe31-4e3b-85ae-e64f3f9e223f",
        "order": 3,
        "label": null,
        "content": { "template": "None of the above" },
        "typ": "NA"
      }
    ]
  },
  {
    "purposeTitle": "Managed Medicaid respondent",
    "purposeText":
      "This question removes respondents who say they do not make decisions for managed Medicaid insurance plans.",
    "screenout": ["95c602e0-a384-47cf-ac23-9cddc3f07209"],
    "screenoutStrategy": "NotMatch",
    "allowedPanels":["HealthPlan","HealthPlanAndPbm"],
    "id": "9435a4d3-f592-409a-b510-59cef4188282",
    "questionTemplateId": null,
    "order": 6,
    "questionType": "CheckboxList",
    "isRequired": true,
    "isLocked": true,
    "randomize": true,
    "requiredOptions": null,
    "title": null,
    "content": {
      "template":
        "For which of the following business lines do you have decision-making responsibilities?"
    },
    "description": null,
    "answerOptions": [
      {
        "id": "e7d34a1c-6644-40e7-9117-3e7454e4bdea",
        "order": 0,
        "label": null,
        "content": { "template": "Commercial/private" },
        "typ": "Standard"
      },
      {
        "id": "40ff4e13-3f8a-43e0-a58d-16789f811fb1",
        "order": 1,
        "label": null,
        "content": { "template": "Medicare Part D" },
        "typ": "Standard"
      },
      {
        "id": "95c602e0-a384-47cf-ac23-9cddc3f07209",
        "order": 2,
        "label": null,
        "content": { "template": "Managed Medicaid" },
        "typ": "Standard"
      },
      {
        "id": "4cefa7f3-114e-4ef3-bf2b-36f80bb33f9d",
        "order": 3,
        "label": null,
        "content": { "template": "None of the above" },
        "typ": "NA"
      }
    ]
  },
  {
    "purposeTitle": "Decision-making involvement",
    "purposeText":
      "This question removes respondents who say they are not involved in these types of activities for their institution.",
    "screenout": ["402c7626-be44-4014-8b79-3193b3e782b3"],
    "screenoutStrategy": "Match",
    "allowedPanels":["HospitalNetwork", "OncologyCenter", "HealthPlanAndHospitalNetwork"],
    "id": "23fa09d2-dd9c-4bbb-b25f-aa7f9d9a6efb",
    "questionTemplateId": null,
    "order": 7,
    "questionType": "CheckboxList",
    "isRequired": true,
    "isLocked": true,
    "randomize": true,
    "requiredOptions": null,
    "title": null,
    "content": {
      "template":
        "Which of the following are you actively involved in for your organization?"
    },
    "description": null,
    "answerOptions": [
      {
        "id": "44ccee3f-4644-49ee-9468-f2ccbacb759b",
        "order": 0,
        "label": null,
        "content": { "template": "Strategic initiatives to enhance patient quality of care" },
        "typ": "Standard"
      },
      {
        "id": "7bed0489-298f-4675-b63e-3a42500f35b5",
        "order": 1,
        "label": null,
        "content": { "template": "Clinical pathway decisions" },
        "typ": "Standard"
      },
      {
        "id": "9edbe0c2-4599-484e-adbb-248fc3133484",
        "order": 2,
        "label": null,
        "content": { "template": "Formulary decision-making for products" },
        "typ": "Standard"
      },
      {
        "id": "e960a9fc-8f56-4c58-9658-7ed4030bab16",
        "order": 3,
        "label": null,
        "content": { "template": "Contracting decision-making for products" },
        "typ": "Standard"
      },
      {
        "id": "402c7626-be44-4014-8b79-3193b3e782b3",
        "order": 4,
        "label": null,
        "content": { "template": "None of the above" },
        "typ": "NA"
      }
    ]
  },
  {
    "purposeTitle": "Inpatient responsibility",
    "purposeText":
      "This question removes respondents who say they spend less than 30% of their working time in the inpatient hospital setting.",
    "screenout": ["f5cb4a2a-6fa6-46e9-97e9-81b82496c2e5"],
    "screenoutValue": 30,
    "screenoutStrategy": "Less",
    "allowedPanels":["HospitalNetwork"],
    "id": "2c99d5e9-f85c-4dab-bf7e-a09e1ea04ca3",
    "questionTemplateId": null,
    "order": 8,
    "questionType": "ContinuousSumList",
    "isRequired": true,
    "isLocked": true,
    "randomize": true,
    "requiredOptions": null,
    "title": null,
    "content": {
      "template":
        "What proportion of your working time is spent in the following areas?"
    },
    "description": null,
    "answerOptions": [
      {
        "id": "f5cb4a2a-6fa6-46e9-97e9-81b82496c2e5",
        "order": 0,
        "label": null,
        "content": { "template": "Inpatient hospital setting" },
        "typ": "Standard"
      },
      {
        "id": "ae5821e5-0aa9-499d-b0aa-d0166e6f4e92",
        "order": 1,
        "label": null,
        "content": { "template": "Outpatient setting" },
        "typ": "Standard"
      }
    ]
  },
  {
    "purposeTitle": "Outpatient responsibility",
    "purposeText":
      "This question removes respondents who say they spend less than 30% of their working time in the outpatient setting.",
    "screenout": ["b1f6dc9c-dcbd-44b6-ba96-8942f88ecb0d"],
    "screenoutValue": 30,
    "screenoutStrategy": "Less",
    "allowedPanels":["HospitalNetwork"],
    "id": "63910a04-086e-40c1-a217-8bec456972b9",
    "questionTemplateId": null,
    "order": 9,
    "questionType": "ContinuousSumList",
    "isRequired": true,
    "isLocked": true,
    "randomize": true,
    "requiredOptions": null,
    "title": null,
    "content": {
      "template":
        "What proportion of your working time is spent in the following areas?"
    },
    "description": null,
    "answerOptions": [
      {
        "id": "5cef9abc-1bf2-4f40-bd5c-701a3acff9dd",
        "order": 0,
        "label": null,
        "content": { "template": "Inpatient hospital setting" },
        "typ": "Standard"
      },
      {
        "id": "b1f6dc9c-dcbd-44b6-ba96-8942f88ecb0d",
        "order": 1,
        "label": null,
        "content": { "template": "Outpatient setting" },
        "typ": "Standard"
      }
    ]
  }
] as unknown as ScreenerQuestionSchema[];

export const getMockedSurveyTemplates = (): SurveySchema[] => [
  {
    "id": "d0e2ce89-68d7-4322-ba31-1e993600603b",
    "title": "Formulary receptivity and potential restrictions",
    "sourceTitle": null,
    "panel": "HealthPlan",
    "status": "Draft",
    "description": null,
    "questions": [
      {
        "id": "ecec5d79-b034-4fd4-8d78-5adfa49b8c11",
        "questionTemplateId": null,
        "order": 0,
        "questionType": "RatingList",
        "isExclusivePerRow": null,
        "isRequired": true,
        "isLocked": true,
        "requiredOptions": {
          "strategy": "OnePerRow"
        },
        "randomizeColumn": false,
        "randomizeRow": true,
        "title": null,
        "content": {
          "template": "Please rate each of the following needs as they apply to the treatment of %%0.",
          "groups": {
            "0": {
              "placeholder": "Insert therapeutic area",
              "text": null
            }
          }
        },
        "description": null,
        "columns": [
          {
            "id": "117ef226-3144-44d7-8b9a-45c79d0ac5ec",
            "order": 0,
            "label": "1",
            "content": {
              "template": "Very Low"
            },
            "typ": "Standard"
          },
          {
            "id": "ef79f86a-f97b-43c2-8556-efc338486cef",
            "order": 1,
            "label": "2",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "6628d700-edda-464b-847e-7e98920ca419",
            "order": 2,
            "label": "3",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "05c6df66-bae8-4006-a5e3-dae9d9f3978a",
            "order": 3,
            "label": "4",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "96646fe7-a2bf-41c8-8320-b4633b074868",
            "order": 4,
            "label": "5",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "29962fd0-6082-4d6b-af00-d901263100cf",
            "order": 5,
            "label": "6",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "70219833-b86f-4107-ac9e-8b5cfa29960b",
            "order": 6,
            "label": "7",
            "content": {
              "template": "Very high need"
            },
            "typ": "Standard"
          }
        ],
        "rows": [
          {
            "id": "825ac92c-5f30-4c41-aec9-4e18c96d7213",
            "order": 0,
            "label": null,
            "content": {
              "template": "Improved clinical efficacy or outcomes compared to standard of care"
            },
            "typ": "Standard"
          },
          {
            "id": "c54a30bc-60b4-44b1-b875-4ba6a1f0c102",
            "order": 1,
            "label": null,
            "content": {
              "template": "Increased patient compliance with therapy"
            },
            "typ": "Standard"
          },
          {
            "id": "08811eab-2c04-47b1-aea0-150e99d0c5cd",
            "order": 3,
            "label": null,
            "content": {
              "template": "Reduced adverse events"
            },
            "typ": "Standard"
          },
          {
            "id": "4a19e1d7-454a-4d72-b941-546ac49d21e4",
            "order": 4,
            "label": null,
            "content": {
              "template": "Reduced healthcare resource utilization compared to standard of care"
            },
            "typ": "Standard"
          }
        ]
      },
      {
        "id": "aff5c25e-359e-4584-a870-f22d4b302041",
        "questionTemplateId": null,
        "order": 1,
        "questionType": "RadioButtonGrid",
        "isExclusivePerRow": false,
        "isRequired": true,
        "isLocked": true,
        "requiredOptions": {
          "strategy": "OnePerColumn"
        },
        "randomizeRow": false,
        "randomizeColumn": true,
        "title": null,
        "content": {
          "template": "How is your organization covering the products below on your organization’s most common formulary (e.g., commercial, Medicare/Part D, Medicaid)? "
        },
        "description": null,
        "columns": [
          {
            "id": "e5dd3fcb-ed2f-46cc-99f5-38debb0d2a21",
            "order": 0,
            "label": null,
            "content": {
              "template": "%%0",
              "groups": {
                "0": {
                  "placeholder": "Insert product",
                  "text": null
                }
              }
            },
            "typ": "Standard"
          }
        ],
        "rows": [
          {
            "id": "3316d325-cc3f-4d4b-8190-83a7087fa577",
            "order": 0,
            "label": null,
            "content": {
              "template": "Preferred tier"
            },
            "typ": "Standard"
          },
          {
            "id": "d83b4fc9-571c-4296-89b9-fcd02620bc5b",
            "order": 1,
            "label": null,
            "content": {
              "template": "Non-preferred tier"
            },
            "typ": "Standard"
          },
          {
            "id": "e3ae62c5-d0e3-4e95-ac8b-4e1df0ad6324",
            "order": 2,
            "label": null,
            "content": {
              "template": "Specialty tier"
            },
            "typ": "Standard"
          },
          {
            "id": "b29577ba-c520-4a7d-b2ed-60315a5db23b",
            "order": 3,
            "label": null,
            "content": {
              "template": "Not covered"
            },
            "typ": "Standard"
          },
          {
            "id": "9575b67f-96e6-4011-b68b-16e45e80c755",
            "order": 4,
            "label": null,
            "content": {
              "template": "Don’t know"
            },
            "typ": "NA"
          }
        ]
      },
      {
        "id": "f65f5f36-4444-4490-b4d4-c9e1114b5b5a",
        "questionTemplateId": null,
        "order": 2,
        "questionType": "CheckboxGrid",
        "isExclusivePerRow": false,
        "isRequired": true,
        "isLocked": true,
        "requiredOptions": {
          "strategy": "AtLeastOnePerColumn"
        },
        "randomizeRow": true,
        "randomizeColumn": true,
        "title": null,
        "content": {
          "template": "What restrictions, if any, does your organization place on these products on your most common formulary (e.g., commercial, Medicare/Part D, Medicaid)?"
        },
        "description": null,
        "columns": [
          {
            "id": "5bf84d94-2e2e-42bb-a9de-5c58e25aaae0",
            "order": 0,
            "label": null,
            "content": {
              "template": "%%0",
              "groups": {
                "0": {
                  "placeholder": "Insert product",
                  "text": null
                }
              }
            },
            "typ": "Standard"
          }
        ],
        "rows": [
          {
            "id": "7d2e439a-2d21-491e-9dce-32dd6b5ba73c",
            "order": 0,
            "label": null,
            "content": {
              "template": "Prior authorization"
            },
            "typ": "Standard"
          },
          {
            "id": "56e961b3-5512-45b4-83ca-e49ae90ee00f",
            "order": 1,
            "label": null,
            "content": {
              "template": "Step through generic"
            },
            "typ": "Standard"
          },
          {
            "id": "4199e2b4-a081-4704-94e6-24032046aa60",
            "order": 2,
            "label": null,
            "content": {
              "template": "Step through preferred brand"
            },
            "typ": "Standard"
          },
          {
            "id": "a8bc126c-e32b-496c-b0a4-5f1585640592",
            "order": 3,
            "label": null,
            "content": {
              "template": "Quantity limit"
            },
            "typ": "Standard"
          },
          {
            "id": "9035611b-14a6-4d92-9361-d9dec6006766",
            "order": 4,
            "label": null,
            "content": {
              "template": "Other: [Specify]"
            },
            "typ": "ParticipantDefined"
          },
          {
            "id": "04840396-83fe-4816-9713-c6149cc868c0",
            "order": 5,
            "label": null,
            "content": {
              "template": "No restrictions"
            },
            "typ": "NA"
          }
        ]
      },
      {
        "id": "e2c5c4e8-8f70-4aa8-9e15-7f00f94766b8",
        "questionTemplateId": null,
        "order": 3,
        "questionType": "ContinuousSumList",
        "isRequired": true,
        "isLocked": true,
        "randomize": true,
        "requiredOptions": null,
        "title": null,
        "content": {
          "template": "What factors will most impact your organization’s decision to provide favorable access to new-to-market or existing %%0 agents over the next year?\n\nPlease distribute 100 points across the factors below to assign value to each in your organization’s decision-making process (the higher the number, the more important the factor is considered).",
          "groups": {
            "0": {
              "placeholder": "Insert therapeutic area",
              "text": null
            }
          }
        },
        "description": null,
        "answerOptions": [
          {
            "id": "734068e6-ef4f-4feb-9774-f962b6cb7d5c",
            "order": 0,
            "label": null,
            "content": {
              "template": "Easier dosing or administration"
            },
            "typ": "Standard"
          },
          {
            "id": "ebba7a51-c8da-4f70-9ab1-6cc7e69fb918",
            "order": 1,
            "label": null,
            "content": {
              "template": "Indication breadth"
            },
            "typ": "Standard"
          },
          {
            "id": "4572fcc1-1b3c-44cc-a168-7a315cb4140f",
            "order": 2,
            "label": null,
            "content": {
              "template": "Comparative data documenting higher efficacy versus competitors"
            },
            "typ": "Standard"
          },
          {
            "id": "c2b7981f-c38d-4867-9bcb-8d612ef96c29",
            "order": 3,
            "label": null,
            "content": {
              "template": "Comparative data documenting fewer safety risks versus competitors"
            },
            "typ": "Standard"
          },
          {
            "id": "4a19a308-39fb-4bde-958f-7ac7ed71a2eb",
            "order": 4,
            "label": null,
            "content": {
              "template": "Experience/comfort with product (length of time on market)"
            },
            "typ": "Standard"
          },
          {
            "id": "a313ebd4-6893-42c1-af6c-856b1165206c",
            "order": 5,
            "label": null,
            "content": {
              "template": "Net cost differential between brands"
            },
            "typ": "Standard"
          },
          {
            "id": "ffcca954-a991-4bf4-ba15-0eea9e9dd779",
            "order": 6,
            "label": null,
            "content": {
              "template": "Considerable demand from KOLs, members, and providers"
            },
            "typ": "Standard"
          },
          {
            "id": "f9e24751-f829-410c-88ca-b39cb0f9174a",
            "order": 7,
            "label": null,
            "content": {
              "template": "Health economic outcomes research (HEOR) data"
            },
            "typ": "Standard"
          }
        ]
      },
      {
        "id": "72516fb9-eeae-46b2-96d2-5408687ecf57",
        "questionTemplateId": null,
        "order": 4,
        "questionType": "OpenEndedText",
        "isRequired": true,
        "isLocked": true,
        "title": null,
        "content": {
          "template": "Here is a description of a treatment currently in development. Please take a moment to review the profile.\n%%0\nWhat is your initial reaction to this product profile?",
          "groups": {
            "0": {
              "placeholder": "Insert product profile",
              "text": null
            }
          }
        },
        "description": null
      },
      {
        "id": "5d5fbdab-4d09-4b14-9d7d-331022862aa8",
        "questionTemplateId": null,
        "order": 5,
        "questionType": "RatingList",
        "isExclusivePerRow": null,
        "isRequired": true,
        "isLocked": true,
        "requiredOptions": {
          "strategy": "OnePerRow"
        },
        "randomizeColumn": false,
        "randomizeRow": true,
        "title": null,
        "content": {
          "template": "%%0\nPlease rate each of the following attributes from the profile as they compare to other existing treatments with this indication.",
          "groups": {
            "0": {
              "placeholder": "Insert product profile",
              "text": null
            }
          }
        },
        "description": null,
        "columns": [
          {
            "id": "117ef226-3144-44d7-8b9a-45c79d0ac5ec",
            "order": 0,
            "label": "1",
            "content": {
              "template": "Highly inferior to existing treatments"
            },
            "typ": "Standard"
          },
          {
            "id": "5e86c8ac-d8ae-45f6-988b-308eaa6e5156",
            "order": 1,
            "label": "2",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "a74848b9-6d4b-4ea7-bd67-6394edb9131b",
            "order": 2,
            "label": "3",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "90c05265-7e27-4962-a90d-10051c5bbc11",
            "order": 3,
            "label": "4",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "6e92e280-9961-4886-b87f-d6ef33aff1c6",
            "order": 4,
            "label": "5",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "ebf0a6b6-eb6b-42c6-892d-6944e8a88f1b",
            "order": 5,
            "label": "6",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "ded4367f-cd3c-4d08-8819-8806de8829fe",
            "order": 6,
            "label": "7",
            "content": {
              "template": "Highly superior to existing treatments"
            },
            "typ": "Standard"
          }
        ],
        "rows": [
          {
            "id": "b9a08ca7-e010-4ddb-aa2d-ad3ce957fa7f",
            "order": 0,
            "label": null,
            "content": {
              "template": "Efficacy"
            },
            "typ": "Standard"
          },
          {
            "id": "6bfd0467-bfbb-433a-8b60-91d194d31ade",
            "order": 1,
            "label": null,
            "content": {
              "template": "Safety"
            },
            "typ": "Standard"
          },
          {
            "id": "6fb1a43e-caca-49cc-b77b-e6d5c84970c3",
            "order": 3,
            "label": null,
            "content": {
              "template": "Adverse events"
            },
            "typ": "Standard"
          },
          {
            "id": "39dadbf8-ebfb-4844-956e-8cf42f4b1761",
            "order": 3,
            "label": null,
            "content": {
              "template": "Dosing"
            },
            "typ": "Standard"
          },
          {
            "id": "08b5f90e-f1d3-467a-a7b9-b206cc6353a1",
            "order": 3,
            "label": null,
            "content": {
              "template": "Mode of administration"
            },
            "typ": "Standard"
          }
        ]
      },
      {
        "id": "970b49e5-59ac-409e-b527-a5c7a6143fe9",
        "questionTemplateId": null,
        "order": 6,
        "questionType": "RadioButtonList",
        "isRequired": true,
        "isLocked": true,
        "randomize": false,
        "requiredOptions": null,
        "title": null,
        "content": {
          "template": "%%0\nHow long after this product is approved by the FDA will you make a coverage decision?",
          "groups": {
            "0": {
              "placeholder": "Insert product profile",
              "text": null
            }
          }
        },
        "description": null,
        "answerOptions": [
          {
            "id": "ea9c52bb-c9e3-418d-8458-3646ed80d197",
            "order": 0,
            "label": null,
            "content": {
              "template": "As soon as possible - Product review would be triggered by FDA approval"
            },
            "typ": "Standard"
          },
          {
            "id": "dcf7a11f-ee88-4feb-980d-fabe5aa0b5f4",
            "order": 1,
            "label": null,
            "content": {
              "template": "Not immediately but within 3 months"
            },
            "typ": "Standard"
          },
          {
            "id": "9e577da2-35ec-4562-a540-446a88d66e59",
            "order": 2,
            "label": null,
            "content": {
              "template": "More than 3 months but within 6 months"
            },
            "typ": "Standard"
          },
          {
            "id": "5db90297-1c33-4a6f-9f9b-eb5b2d3fbfd3",
            "order": 3,
            "label": null,
            "content": {
              "template": "More than 6 months but within a year"
            },
            "typ": "Standard"
          },
          {
            "id": "ef57e721-8d03-4fef-854e-f3aedd4b1cae",
            "order": 4,
            "label": null,
            "content": {
              "template": "More than a year after approval"
            },
            "typ": "Standard"
          },
          {
            "id": "34173afc-0244-40b6-ad3c-a1914abd4d27",
            "order": 5,
            "label": null,
            "content": {
              "template": "Other: [Specify]"
            },
            "typ": "ParticipantDefined"
          }
        ]
      },
      {
        "id": "0590652a-7572-46e9-a956-5044c16c2f68",
        "questionTemplateId": null,
        "order": 7,
        "questionType": "RadioButtonList",
        "isRequired": true,
        "isLocked": true,
        "randomize": false,
        "requiredOptions": null,
        "title": null,
        "content": {
          "template": "How is your organization likely to cover this product on your organization’s most common formulary (e.g., commercial, Medicare/Part D, Medicaid)?"
        },
        "description": null,
        "answerOptions": [
          {
            "id": "5a4b3e00-0cd6-4ee9-aac7-20db8f734bff",
            "order": 0,
            "label": null,
            "content": {
              "template": "Preferred tier"
            },
            "typ": "Standard"
          },
          {
            "id": "b5aafc1f-eaa6-40f4-9f4c-43cc4fb90dd9",
            "order": 1,
            "label": null,
            "content": {
              "template": "Non-preferred tier"
            },
            "typ": "Standard"
          },
          {
            "id": "350e661f-4bdd-4bb6-9cef-a8d9ec582828",
            "order": 2,
            "label": null,
            "content": {
              "template": "Specialty tier"
            },
            "typ": "Standard"
          },
          {
            "id": "1cabd902-8e16-48a1-95a7-555ab47d213b",
            "order": 3,
            "label": null,
            "content": {
              "template": "Not covered"
            },
            "typ": "Standard"
          },
          {
            "id": "d0ffd0e7-b0b5-4cf3-821c-6c4491d009bb",
            "order": 4,
            "label": null,
            "content": {
              "template": "Don’t know"
            },
            "typ": "NA"
          }
        ]
      },
      {
        "id": "a923a546-9e4d-419e-9972-9d7cb3648c00",
        "questionTemplateId": null,
        "order": 8,
        "questionType": "OpenEndedText",
        "isRequired": true,
        "isLocked": true,
        "title": null,
        "content": {
          "template": "%%0\nWhat additional information or data would you need to see for this product to make it a preferred product?",
          "groups": {
            "0": {
              "placeholder": "Insert product profile",
              "text": null
            }
          }
        },
        "description": null
      },
      {
        "id": "b880b4b3-e902-4497-af3e-e59c1dc2e14c",
        "questionTemplateId": null,
        "order": 9,
        "questionType": "CheckboxList",
        "isRequired": true,
        "isLocked": true,
        "randomize": true,
        "requiredOptions": null,
        "title": null,
        "content": {
          "template": "What restrictions, if any, is your organization likely to place on this product on your most common formulary (e.g., commercial, Medicare/Part D, Medicaid)?"
        },
        "description": null,
        "answerOptions": [
          {
            "id": "9c026938-5331-4437-9a8c-31dc1bb9f6fe",
            "order": 0,
            "label": null,
            "content": {
              "template": "Prior authorization"
            },
            "typ": "Standard"
          },
          {
            "id": "9619af70-6ae5-4bf9-a5d5-b3ad1e1b11ef",
            "order": 1,
            "label": null,
            "content": {
              "template": "Step through generic"
            },
            "typ": "Standard"
          },
          {
            "id": "deab0c22-82d9-4a10-a038-9a470bf16ce7",
            "order": 2,
            "label": null,
            "content": {
              "template": "Step through preferred brand"
            },
            "typ": "Standard"
          },
          {
            "id": "6c121bcd-f6ef-4b6b-a99b-e892451d007e",
            "order": 3,
            "label": null,
            "content": {
              "template": "Quantity limit"
            },
            "typ": "Standard"
          },
          {
            "id": "447e4c33-e926-4a85-952a-491fbf6af617",
            "order": 4,
            "label": null,
            "content": {
              "template": "Other: [Specify]"
            },
            "typ": "ParticipantDefined"
          },
          {
            "id": "c5d423fa-e302-40e7-86be-8dc3ec18fdcf",
            "order": 5,
            "label": null,
            "content": {
              "template": "No restrictions"
            },
            "typ": "NA"
          }
        ]
      }
    ],
    "screeners": [],
    "deleted": []
  },
  {
    "id": "c6af7219-fb50-42ce-9e6e-6f0fabf1c994",
    "title": "Customer relationship assessment",
    "sourceTitle": null,
    "panel": "HealthPlan",
    "status": "Draft",
    "description": null,
    "questions": [
      {
        "id": "c6af7219-fb50-42ce-9e6e-6f0fabf1c994",
        "questionTemplateId": null,
        "order": 0,
        "questionType": "RadioButtonGrid",
        "isExclusivePerRow": true,
        "isRequired": true,
        "isLocked": true,
        "requiredOptions": {
          "strategy": "OnePerRow"
        },
        "randomizeRow": true,
        "randomizeColumn": false,
        "title": null,
        "content": {
          "template": "Please indicate, on average, how often you meet with a pharmaceutical sales representative for each of the following products."
        },
        "description": null,
        "columns": [
          {
            "id": "a8683c99-41c9-4662-b98f-3b7975d73187",
            "order": 0,
            "label": null,
            "content": {
              "template": "More than once per week"
            },
            "typ": "Standard"
          },
          {
            "id": "52fc33fd-4ef9-4ba6-b21c-45277a95df39",
            "order": 1,
            "label": null,
            "content": {
              "template": "Once per week"
            },
            "typ": "Standard"
          },
          {
            "id": "2b47a2d3-139d-46ee-a2b4-795658e3f015",
            "order": 2,
            "label": null,
            "content": {
              "template": "Once per month"
            },
            "typ": "Standard"
          },
          {
            "id": "222d77cf-76c0-4464-926f-ffc4c64058c8",
            "order": 3,
            "label": null,
            "content": {
              "template": "Once per quarter"
            },
            "typ": "Standard"
          },
          {
            "id": "e55500e8-0d6e-4d00-9487-2ec99d7025f4",
            "order": 4,
            "label": null,
            "content": {
              "template": "Once every six months+"
            },
            "typ": "Standard"
          }
        ],
        "rows": [
          {
            "id": "aeabfae6-a715-4a4e-921b-e3c1f670a4c4",
            "order": 0,
            "label": null,
            "content": {
              "template": "%%0",
              "groups": {
                "0": {
                  "placeholder": "Product (Company)",
                  "text": null
                }
              }
            },
            "typ": "Standard"
          }
        ]
      },
      {
        "id": "811e3452-d3dc-44a9-a763-b242cf33a678",
        "questionTemplateId": null,
        "order": 1,
        "questionType": "RadioButtonGrid",
        "isExclusivePerRow": true,
        "isRequired": true,
        "isLocked": true,
        "requiredOptions": {
          "strategy": "OnePerRow"
        },
        "randomizeRow": true,
        "randomizeColumn": false,
        "title": null,
        "content": {
          "template": "Using descriptions below, please select which best describes the relationship between your organization and each company with whom you interact.\n\n-Partner: Multiple, productive interactions occur between the company and my organization. The relationship is consistently well-managed, and resources and support offered are valuable and timely. My organization views this company as a high-quality provider support. The company is trusted by my organization.\n\n-Collaborative: Interactions are less frequent but productive when they occur. Although the relationship is well managed, room for improvement exists. My organization views this company as a quality provider of support. We would consider opportunities to collaborate shared initiatives.\n\n-Transactional: Few interactions with this company have occurred within the previous year. The relationship is mostly limited to indirect communication. We have other sources of support and information we value more, but we welcome opportunities to work more closely with this company.\n\n-Stressed: Most interactions with this company are non-productive. Our relationship is strained due to recent or past interactions. The process for me to interact with this company is difficult and confrontational. The goals of this company seems to be in direct conflict with my organization."
        },
        "description": null,
        "columns": [
          {
            "id": "92c7b1f4-dc98-4ea0-ac16-c5584b228bec",
            "order": 0,
            "label": null,
            "content": {
              "template": "Partner"
            },
            "typ": "Standard"
          },
          {
            "id": "db4ad2e9-4954-41c9-9b70-79c3873f4646",
            "order": 1,
            "label": null,
            "content": {
              "template": "Collaborative"
            },
            "typ": "Standard"
          },
          {
            "id": "b8c3f255-b932-40d1-b9e8-79b2e6a8556b",
            "order": 2,
            "label": null,
            "content": {
              "template": "Transactional"
            },
            "typ": "Standard"
          },
          {
            "id": "3fb6327a-64ad-4e9e-ab55-36f9afe87f00",
            "order": 3,
            "label": null,
            "content": {
              "template": "Stressed"
            },
            "typ": "Standard"
          },
          {
            "id": "66730242-ac81-4903-9972-68de622aaa3f",
            "order": 4,
            "label": null,
            "content": {
              "template": "NA – No relationship"
            },
            "typ": "Standard"
          }
        ],
        "rows": [
          {
            "id": "aeabfae6-a715-4a4e-921b-e3c1f670a4c4",
            "order": 0,
            "label": null,
            "content": {
              "template": "%%0",
              "groups": {
                "0": {
                  "placeholder": "Product (Company)",
                  "text": null
                }
              }
            },
            "typ": "Standard"
          }
        ]
      },
      {
        "id": "1404a849-1c00-4a23-875e-338dc207f32c",
        "questionTemplateId": null,
        "order": 2,
        "questionType": "RatingList",
        "isExclusivePerRow": null,
        "isRequired": true,
        "isLocked": true,
        "requiredOptions": {
          "strategy": "OnePerRow"
        },
        "randomizeColumn": false,
        "randomizeRow": true,
        "title": null,
        "content": {
          "template": "Please rate how well the subsequent statements describe each pharmaceutical sales representative from %%0.",
          "groups": {
            "0": {
              "placeholder": "Insert Product (Company) 1",
              "text": null
            }
          }
        },
        "description": null,
        "columns": [
          {
            "id": "ef5cd48c-74af-4373-9a12-a42feee8c009",
            "order": 0,
            "label": "1",
            "content": {
              "template": "Does not describe representative at all"
            },
            "typ": "Standard"
          },
          {
            "id": "c33a6367-a388-444f-9526-7964273462d1",
            "order": 1,
            "label": "2",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "34f65ef9-ad59-49d5-9ad2-540496124893",
            "order": 2,
            "label": "3",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "cc28265d-c1ea-4905-bb59-bed966ce5981",
            "order": 3,
            "label": "4",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "71741b49-71d4-4cff-9c49-70ea85361aa6",
            "order": 4,
            "label": "5",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "619a57b9-20bf-46ed-b7b8-17f48312f342",
            "order": 5,
            "label": "6",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "49cdfb13-5df9-4d8c-9039-7d1814cf39a8",
            "order": 6,
            "label": "7",
            "content": {
              "template": "Describes representative perfectly"
            },
            "typ": "Standard"
          }
        ],
        "rows": [
          {
            "id": "5e4aa921-c429-4f29-b94e-69a670ba3a0b",
            "order": 0,
            "label": null,
            "content": {
              "template": "Is an expert on the disease state/treatment area for which the product is indicated"
            },
            "typ": "Standard"
          },
          {
            "id": "bb3884e5-5a1a-41ef-bd49-c0c89d23e688",
            "order": 1,
            "label": null,
            "content": {
              "template": "Describes both the efficacy and adverse effects about the product they are promoting"
            },
            "typ": "Standard"
          },
          {
            "id": "80540977-b8ae-4efb-b02a-ace771639b0f",
            "order": 2,
            "label": null,
            "content": {
              "template": "Is an expert on the appropriate use and role of their product relative to other treatment options"
            },
            "typ": "Standard"
          },
          {
            "id": "b1d1a236-5822-4ec2-bf93-acc4780267d7",
            "order": 3,
            "label": null,
            "content": {
              "template": "Is knowledgeable about and can discuss treatment guidelines and/or pathways"
            },
            "typ": "Standard"
          },
          {
            "id": "61ebe547-748e-4685-bb60-890f1217d729",
            "order": 4,
            "label": null,
            "content": {
              "template": "Keeps me up to date on the incidence, treatment, and management of adverse effects with the product"
            },
            "typ": "Standard"
          },
          {
            "id": "d7a40567-086d-4d33-b424-56b9f3c5a41e",
            "order": 5,
            "label": null,
            "content": {
              "template": "Notifies me of restrictions I may experience when prescribing the product"
            },
            "typ": "Standard"
          }
        ]
      },
      {
        "id": "95288f86-ca4e-43c3-a9c1-c92d9d35e4bd",
        "questionTemplateId": null,
        "order": 3,
        "questionType": "RatingList",
        "isExclusivePerRow": null,
        "isRequired": true,
        "isLocked": true,
        "requiredOptions": {
          "strategy": "OnePerRow"
        },
        "randomizeColumn": false,
        "randomizeRow": true,
        "title": null,
        "content": {
          "template": "Please rate how well the subsequent statements describe each pharmaceutical sales representative from %%0.",
          "groups": {
            "0": {
              "placeholder": "Insert Product (Company) 2",
              "text": null
            }
          }
        },
        "description": null,
        "columns": [
          {
            "id": "cfdcbe1d-6a65-4060-b295-a41dc7fedcfc",
            "order": 0,
            "label": "1",
            "content": {
              "template": "Does not describe representative at all"
            },
            "typ": "Standard"
          },
          {
            "id": "989a56d6-1681-49e8-8be2-8041ad1dc3d1",
            "order": 1,
            "label": "2",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "9aeda1b4-4e8c-4fdd-801a-0e437d41c325",
            "order": 2,
            "label": "3",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "f5a809cd-6bff-4a87-9a75-7098963d383d",
            "order": 3,
            "label": "4",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "1c7d4b29-516a-4de4-8066-c3387c4f266b",
            "order": 4,
            "label": "5",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "316d4661-ed80-461a-8b16-00b6d4aad902",
            "order": 5,
            "label": "6",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "0e8788c0-1e10-4ae3-b561-4ea428533637",
            "order": 6,
            "label": "7",
            "content": {
              "template": "Describes representative perfectly"
            },
            "typ": "Standard"
          }
        ],
        "rows": [
          {
            "id": "3eeca906-318a-43b8-8e4d-7acb4abf2879",
            "order": 0,
            "label": null,
            "content": {
              "template": "Is an expert on the disease state/treatment area for which the product is indicated"
            },
            "typ": "Standard"
          },
          {
            "id": "18d39879-1861-4350-964f-a03b4fa74743",
            "order": 1,
            "label": null,
            "content": {
              "template": "Describes both the efficacy and adverse effects about the product they are promoting"
            },
            "typ": "Standard"
          },
          {
            "id": "3641b874-fa36-4709-ae52-6730cb0210ec",
            "order": 2,
            "label": null,
            "content": {
              "template": "Is an expert on the appropriate use and role of their product relative to other treatment options"
            },
            "typ": "Standard"
          },
          {
            "id": "d1f0463e-0844-41cb-9843-27aaf5347962",
            "order": 3,
            "label": null,
            "content": {
              "template": "Is knowledgeable about and can discuss treatment guidelines and/or pathways"
            },
            "typ": "Standard"
          },
          {
            "id": "befb0ba1-53b2-4b97-8b39-2c7f1f821db5",
            "order": 4,
            "label": null,
            "content": {
              "template": "Keeps me up to date on the incidence, treatment, and management of adverse effects with the product"
            },
            "typ": "Standard"
          },
          {
            "id": "782d9d5c-de0f-4ceb-a20c-21c851042504",
            "order": 5,
            "label": null,
            "content": {
              "template": "Notifies me of restrictions I may experience when prescribing the product"
            },
            "typ": "Standard"
          }
        ]
      },
      {
        "id": "9d38a732-0841-4701-b0cf-bffc99b51fae",
        "questionTemplateId": null,
        "order": 4,
        "questionType": "RatingList",
        "isExclusivePerRow": null,
        "isRequired": true,
        "isLocked": true,
        "requiredOptions": {
          "strategy": "OnePerRow"
        },
        "randomizeColumn": false,
        "randomizeRow": true,
        "title": null,
        "content": {
          "template": "Please rate how well the subsequent statements describe each pharmaceutical sales representative from %%0.",
          "groups": {
            "0": {
              "placeholder": "Insert Product (Company) 1",
              "text": null
            }
          }
        },
        "description": null,
        "columns": [
          {
            "id": "8d6f3024-97b0-48cd-911b-16dd58737a09",
            "order": 0,
            "label": "1",
            "content": {
              "template": "Does not describe representative at all"
            },
            "typ": "Standard"
          },
          {
            "id": "dba34ef2-cb8f-4796-9f57-7feb34356326",
            "order": 1,
            "label": "2",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "57748a88-ab91-4b2f-9dab-6e7ec18b910d",
            "order": 2,
            "label": "3",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "969551fb-831f-40f2-9077-c1c326bcca7e",
            "order": 3,
            "label": "4",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "b5dd009f-955e-4d64-8b29-b3d5a9661ca2",
            "order": 4,
            "label": "5",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "35501308-9d1b-40ec-b25a-db5047a02cf9",
            "order": 5,
            "label": "6",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "74aa47f5-ecb3-4b1a-8d39-6714e441ee1c",
            "order": 6,
            "label": "7",
            "content": {
              "template": "Describes representative perfectly"
            },
            "typ": "Standard"
          }
        ],
        "rows": [
          {
            "id": "4b199c2f-a226-4c01-bc3b-2cf66d6a719b",
            "order": 0,
            "label": null,
            "content": {
              "template": "Effectively communicates patient out of pocket costs (e.g., copay, coinsurance) for the product for major health plans in my office"
            },
            "typ": "Standard"
          },
          {
            "id": "73f81391-39b2-42d3-9ad4-bb2be88a5ff9",
            "order": 1,
            "label": null,
            "content": {
              "template": "Expresses an understanding of my practice and the kinds of patients I treat"
            },
            "typ": "Standard"
          },
          {
            "id": "943e6e6d-deba-45dc-a7eb-1b3459841709",
            "order": 2,
            "label": null,
            "content": {
              "template": "Listens to what I say and allows me to express my information needs before detailing me"
            },
            "typ": "Standard"
          },
          {
            "id": "2be61565-3e58-48de-98e7-38e9e319cced",
            "order": 3,
            "label": null,
            "content": {
              "template": "Understands the issues and concerns I have and responds appropriately"
            },
            "typ": "Standard"
          },
          {
            "id": "e44d3c03-7532-4495-b880-79bbf45dff85",
            "order": 4,
            "label": null,
            "content": {
              "template": "Respectful of my time and responds appropriately when I am busy with patients"
            },
            "typ": "Standard"
          },
          {
            "id": "7e50db60-2c99-4151-a935-735ae6ca66f7",
            "order": 5,
            "label": null,
            "content": {
              "template": "Understands the business side of my practice, including the goals of my practice"
            },
            "typ": "Standard"
          }
        ]
      },
      {
        "id": "db16809a-1a03-44ce-b1b5-a92afe7f9687",
        "questionTemplateId": null,
        "order": 5,
        "questionType": "RatingList",
        "isExclusivePerRow": null,
        "isRequired": true,
        "isLocked": true,
        "requiredOptions": {
          "strategy": "OnePerRow"
        },
        "randomizeColumn": false,
        "randomizeRow": true,
        "title": null,
        "content": {
          "template": "Please rate how well the subsequent statements describe each pharmaceutical sales representative from %%0.",
          "groups": {
            "0": {
              "placeholder": "Insert Product (Company) 2",
              "text": null
            }
          }
        },
        "description": null,
        "columns": [
          {
            "id": "8ec4d655-02b0-4dd5-80e4-c3b061966106",
            "order": 0,
            "label": "1",
            "content": {
              "template": "Does not describe representative at all"
            },
            "typ": "Standard"
          },
          {
            "id": "e536e7e4-be6c-469b-a275-86c610803f81",
            "order": 1,
            "label": "2",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "0bb43176-0198-4d43-a967-995fb8bc9eea",
            "order": 2,
            "label": "3",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "816cdde7-5f06-40b2-83d4-96cff1e4459d",
            "order": 3,
            "label": "4",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "94d02289-c80a-4cfc-a029-b31469c4db67",
            "order": 4,
            "label": "5",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "b2f4f285-22ee-4298-87a4-4333ed4f4785",
            "order": 5,
            "label": "6",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "feacd98d-2a5d-49ee-b4f5-91989330686a",
            "order": 6,
            "label": "7",
            "content": {
              "template": "Describes representative perfectly"
            },
            "typ": "Standard"
          }
        ],
        "rows": [
          {
            "id": "7c7b4c7b-f813-4bc4-b782-c14f1c182338",
            "order": 0,
            "label": null,
            "content": {
              "template": "Effectively communicates patient out of pocket costs (e.g., copay, coinsurance) for the product for major health plans in my office"
            },
            "typ": "Standard"
          },
          {
            "id": "f82eec56-6920-4493-81bd-dc2378e0f725",
            "order": 1,
            "label": null,
            "content": {
              "template": "Expresses an understanding of my practice and the kinds of patients I treat"
            },
            "typ": "Standard"
          },
          {
            "id": "e97b1866-aba0-402b-a306-193c68db16bc",
            "order": 2,
            "label": null,
            "content": {
              "template": "Listens to what I say and allows me to express my information needs before detailing me"
            },
            "typ": "Standard"
          },
          {
            "id": "48579d69-d052-4d65-ba5a-97fd5be0fc0a",
            "order": 3,
            "label": null,
            "content": {
              "template": "Understands the issues and concerns I have and responds appropriately"
            },
            "typ": "Standard"
          },
          {
            "id": "2b26d761-1d27-404e-a083-e4ec639a2fcc",
            "order": 4,
            "label": null,
            "content": {
              "template": "Respectful of my time and responds appropriately when I am busy with patients"
            },
            "typ": "Standard"
          },
          {
            "id": "4ee79d22-10e5-48f2-8826-7158afb0bc7a",
            "order": 5,
            "label": null,
            "content": {
              "template": "Understands the business side of my practice, including the goals of my practice"
            },
            "typ": "Standard"
          }
        ]
      },
      {
        "id": "3dcc5995-731e-4473-b255-c5f00ee1c77a",
        "questionTemplateId": null,
        "order": 6,
        "questionType": "RatingList",
        "isExclusivePerRow": null,
        "isRequired": true,
        "isLocked": true,
        "requiredOptions": {
          "strategy": "OnePerRow"
        },
        "randomizeColumn": false,
        "randomizeRow": true,
        "title": null,
        "content": {
          "template": "Please rate how well the subsequent statements describe each pharmaceutical sales representative from %%0.",
          "groups": {
            "0": {
              "placeholder": "Insert Product (Company) 1",
              "text": null
            }
          }
        },
        "description": null,
        "columns": [
          {
            "id": "ef466faa-77a0-46e3-8553-b6ac2516030f",
            "order": 0,
            "label": "1",
            "content": {
              "template": "Does not describe representative at all"
            },
            "typ": "Standard"
          },
          {
            "id": "16b4d2f5-7a76-49fa-b88b-600e52c2bd73",
            "order": 1,
            "label": "2",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "e108f0d9-da37-44c1-ab9c-bf2579dbdcf4",
            "order": 2,
            "label": "3",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "8b54303e-5245-4971-94c2-d67b0ae3be1f",
            "order": 3,
            "label": "4",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "c9e0688c-71bb-4817-9c87-760f9ecc507f",
            "order": 4,
            "label": "5",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "982d99e2-d0b4-473b-9070-53d280c8590a",
            "order": 5,
            "label": "6",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "27894813-e4eb-4552-9b69-a53bde1ec51f",
            "order": 6,
            "label": "7",
            "content": {
              "template": "Describes representative perfectly"
            },
            "typ": "Standard"
          }
        ],
        "rows": [
          {
            "id": "bc22b319-5760-42f1-b465-f60087d4577b",
            "order": 0,
            "label": null,
            "content": {
              "template": "Understands the role of my office staff"
            },
            "typ": "Standard"
          },
          {
            "id": "b662dca5-fb3a-4a19-8690-dff5ae9327f9",
            "order": 1,
            "label": null,
            "content": {
              "template": "Provides solutions to help me and my patients gain access to the products"
            },
            "typ": "Standard"
          },
          {
            "id": "b1fb58bb-1f96-460b-9945-fd0bb32db2f4",
            "order": 2,
            "label": null,
            "content": {
              "template": "Helps me identify appropriate patients who will benefit most from the product"
            },
            "typ": "Standard"
          },
          {
            "id": "20cf0133-e6c8-4ae2-9358-16ec8ea0243c",
            "order": 3,
            "label": null,
            "content": {
              "template": "Knowledgeable about patient advocacy groups and resources (i.e., community and national)"
            },
            "typ": "Standard"
          },
          {
            "id": "887771c8-4b7e-4292-ac3f-324bd547801a",
            "order": 4,
            "label": null,
            "content": {
              "template": "Respects and educates my office staff"
            },
            "typ": "Standard"
          },
          {
            "id": "a5db1707-c696-4136-ad9a-919149fc40d0",
            "order": 5,
            "label": null,
            "content": {
              "template": "Asks intelligent, meaningful questions"
            },
            "typ": "Standard"
          }
        ]
      },
      {
        "id": "b5e53d7e-106b-4df3-b2e2-3bcad5988033",
        "questionTemplateId": null,
        "order": 7,
        "questionType": "RatingList",
        "isExclusivePerRow": null,
        "isRequired": true,
        "isLocked": true,
        "requiredOptions": {
          "strategy": "OnePerRow"
        },
        "randomizeColumn": false,
        "randomizeRow": true,
        "title": null,
        "content": {
          "template": "Please rate how well the subsequent statements describe each pharmaceutical sales representative from %%0.",
          "groups": {
            "0": {
              "placeholder": "Insert Product (Company) 2",
              "text": null
            }
          }
        },
        "description": null,
        "columns": [
          {
            "id": "9dbe1a9c-ef1e-4d7a-a6c8-5b62ab6be1f0",
            "order": 0,
            "label": "1",
            "content": {
              "template": "Does not describe representative at all"
            },
            "typ": "Standard"
          },
          {
            "id": "0e236f58-63e7-44e3-8266-3939eb37ae03",
            "order": 1,
            "label": "2",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "c7e89da5-dd8f-4a69-b9bc-0941ef38fdc3",
            "order": 2,
            "label": "3",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "bf585694-4c83-47fc-9e8e-6559899330b2",
            "order": 3,
            "label": "4",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "59fe48ed-0553-4048-9697-e35dde53fa6b",
            "order": 4,
            "label": "5",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "d61fc0b3-0e1e-4ac1-abb9-f5f47913add5",
            "order": 5,
            "label": "6",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "fa240a6f-a8cb-4a22-bc7a-d783bb91b9cd",
            "order": 6,
            "label": "7",
            "content": {
              "template": "Describes representative perfectly"
            },
            "typ": "Standard"
          }
        ],
        "rows": [
          {
            "id": "62dcaea8-a534-49ff-bb97-2a5133f5375c",
            "order": 0,
            "label": null,
            "content": {
              "template": "Understands the role of my office staff"
            },
            "typ": "Standard"
          },
          {
            "id": "a7de9656-445f-4b2a-a5cd-48de5fdf7f00",
            "order": 1,
            "label": null,
            "content": {
              "template": "Provides solutions to help me and my patients gain access to the products"
            },
            "typ": "Standard"
          },
          {
            "id": "635f0b1d-11aa-492e-ab82-072c552ec8ce",
            "order": 2,
            "label": null,
            "content": {
              "template": "Helps me identify appropriate patients who will benefit most from the product"
            },
            "typ": "Standard"
          },
          {
            "id": "f6cfd1ac-8653-4a2b-aa63-5fe4e3b97e25",
            "order": 3,
            "label": null,
            "content": {
              "template": "Knowledgeable about patient advocacy groups and resources (i.e., community and national)"
            },
            "typ": "Standard"
          },
          {
            "id": "a5015649-e96b-4828-ba3f-67da0158a04a",
            "order": 4,
            "label": null,
            "content": {
              "template": "Respects and educates my office staff"
            },
            "typ": "Standard"
          },
          {
            "id": "bd092943-6b17-41d7-b3a0-5dd6e30bbafc",
            "order": 5,
            "label": null,
            "content": {
              "template": "Asks intelligent, meaningful questions"
            },
            "typ": "Standard"
          }
        ]
      },
      {
        "id": "9be194b1-44ba-44c5-8cd2-5fa371fee44a",
        "questionTemplateId": null,
        "order": 8,
        "questionType": "RatingList",
        "isExclusivePerRow": null,
        "isRequired": true,
        "isLocked": true,
        "requiredOptions": {
          "strategy": "OnePerRow"
        },
        "randomizeColumn": false,
        "randomizeRow": true,
        "title": null,
        "content": {
          "template": "Please rate how well the subsequent statements describe each pharmaceutical sales representative from %%0.",
          "groups": {
            "0": {
              "placeholder": "Insert Product (Company) 1",
              "text": null
            }
          }
        },
        "description": null,
        "columns": [
          {
            "id": "f59545a0-1f6c-4a6b-a0c5-8831c0b02444",
            "order": 0,
            "label": "1",
            "content": {
              "template": "Does not describe representative at all"
            },
            "typ": "Standard"
          },
          {
            "id": "86bd59e1-3fd7-4b67-8de6-92a3a07af06c",
            "order": 1,
            "label": "2",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "3fda248a-d8ea-4522-97a2-0ecd52ef9019",
            "order": 2,
            "label": "3",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "804f63aa-b5aa-4b79-bae2-a5392bcdeccd",
            "order": 3,
            "label": "4",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "599a13d6-f4fa-4efb-9088-491b56742419",
            "order": 4,
            "label": "5",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "7acb8415-d0a3-4d9f-a9b3-ac78de3f69b2",
            "order": 5,
            "label": "6",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "a9e42862-924e-48f3-9e79-d85dd96a23ae",
            "order": 6,
            "label": "7",
            "content": {
              "template": "Describes representative perfectly"
            },
            "typ": "Standard"
          }
        ],
        "rows": [
          {
            "id": "22978255-09f5-452a-939b-9353efe00018",
            "order": 0,
            "label": null,
            "content": {
              "template": "Supports suggestions to change my prescribing with logical reasons"
            },
            "typ": "Standard"
          },
          {
            "id": "7afe0e14-ee5c-4483-9035-048e27b03f84",
            "order": 1,
            "label": null,
            "content": {
              "template": "Promptly follows up on issues from previous discussions"
            },
            "typ": "Standard"
          },
          {
            "id": "1cfb7727-45ca-4b23-b3bd-8b63b42ba770",
            "order": 2,
            "label": null,
            "content": {
              "template": "Presents information clearly and succinctly"
            },
            "typ": "Standard"
          },
          {
            "id": "ffe2b2b6-f5b2-45cc-9b77-077172184fdc",
            "order": 3,
            "label": null,
            "content": {
              "template": "Provides me with information/materials regarding patient copay assistance programs"
            },
            "typ": "Standard"
          },
          {
            "id": "4aca8e9e-7647-4fe7-a761-257e34d07a9f",
            "order": 4,
            "label": null,
            "content": {
              "template": "Communicates value of company’s online reimbursement/patient access support"
            },
            "typ": "Standard"
          },
          {
            "id": "925762d4-5802-4b8f-a0cf-ed6368722e3f",
            "order": 5,
            "label": null,
            "content": {
              "template": "Facilitates access to their company’s Medical Science Liaisons and additional information from medical education/affairs"
            },
            "typ": "Standard"
          }
        ]
      },
      {
        "id": "fe0e7975-28e2-4af8-a7a5-db70338e9ce0",
        "questionTemplateId": null,
        "order": 9,
        "questionType": "RatingList",
        "isExclusivePerRow": null,
        "isRequired": true,
        "isLocked": true,
        "requiredOptions": {
          "strategy": "OnePerRow"
        },
        "randomizeColumn": false,
        "randomizeRow": true,
        "title": null,
        "content": {
          "template": "Please rate how well the subsequent statements describe each pharmaceutical sales representative from %%0.",
          "groups": {
            "0": {
              "placeholder": "Insert Product (Company) 2",
              "text": null
            }
          }
        },
        "description": null,
        "columns": [
          {
            "id": "7af4de69-94d7-4e9d-af62-e1055fac49b5",
            "order": 0,
            "label": "1",
            "content": {
              "template": "Does not describe representative at all"
            },
            "typ": "Standard"
          },
          {
            "id": "2c6b5069-2fa1-486d-a316-34c9046d78ac",
            "order": 1,
            "label": "2",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "d4697e94-fe8e-4573-86cd-e3cff874f37f",
            "order": 2,
            "label": "3",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "b617675d-6c54-4fd0-b153-e34a034458a8",
            "order": 3,
            "label": "4",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "59cbe82c-974f-4e79-bd18-8a4d3356e47f",
            "order": 4,
            "label": "5",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "4e1883fc-0adc-4c44-8342-e5fdc0f9368a",
            "order": 5,
            "label": "6",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "8667061b-8a1e-4626-9bde-a7064e4e9b48",
            "order": 6,
            "label": "7",
            "content": {
              "template": "Describes representative perfectly"
            },
            "typ": "Standard"
          }
        ],
        "rows": [
          {
            "id": "789c67bc-f4e7-41f7-8f60-00c54234d298",
            "order": 0,
            "label": null,
            "content": {
              "template": "Supports suggestions to change my prescribing with logical reasons"
            },
            "typ": "Standard"
          },
          {
            "id": "d307205e-660d-4d18-912f-74a2764bf624",
            "order": 1,
            "label": null,
            "content": {
              "template": "Promptly follows up on issues from previous discussions"
            },
            "typ": "Standard"
          },
          {
            "id": "391aa6f1-6a80-4c48-bbbd-a1ba0ef83349",
            "order": 2,
            "label": null,
            "content": {
              "template": "Presents information clearly and succinctly"
            },
            "typ": "Standard"
          },
          {
            "id": "eef06d61-1372-43e2-b656-c7337a2f95f2",
            "order": 3,
            "label": null,
            "content": {
              "template": "Provides me with information/materials regarding patient copay assistance programs"
            },
            "typ": "Standard"
          },
          {
            "id": "ff39bea0-d9fb-4231-88d8-b0b0e1dcf70c",
            "order": 4,
            "label": null,
            "content": {
              "template": "Communicates value of company’s online reimbursement/patient access support"
            },
            "typ": "Standard"
          },
          {
            "id": "19d6f046-f317-4365-a5c2-68dfda02ad81",
            "order": 5,
            "label": null,
            "content": {
              "template": "Facilitates access to their company’s Medical Science Liaisons and additional information from medical education/affairs"
            },
            "typ": "Standard"
          }
        ]
      },
      
    ],
    "screeners": [],
    "deleted": []
  },
  {
    "id": "d007f140-5e4f-4d44-871b-70c84ee983af",
    "title": "Change to competitive set - new data, new indication, new product, loss of exclusivity, biosimilar",
    "sourceTitle": null,
    "panel": "HealthPlan",
    "status": "Draft",
    "description": null,
    "questions": [
      {
        "id": "4a2d5688-b993-4c74-9316-c75cb1b4bb20",
        "questionTemplateId": null,
        "order": 0,
        "questionType": "RadioButtonGrid",
        "isExclusivePerRow": false,
        "isRequired": true,
        "isLocked": true,
        "requiredOptions": {
          "strategy": "OnePerColumn"
        },
        "randomizeRow": false,
        "randomizeColumn": true,
        "title": null,
        "content": {
          "template": "How is your organization covering the products below on your organization’s most common formulary (e.g., commercial, Medicare/Part D, Medicaid)? "
        },
        "description": null,
        "columns": [
          {
            "id": "3705de25-fe39-4430-978e-fb18a5f8ce34",
            "order": 0,
            "label": null,
            "content": {
              "template": "%%0",
              "groups": {
                "0": {
                  "placeholder": "Insert product",
                  "text": null
                }
              }
            },
            "typ": "Standard"
          }
        ],
        "rows": [
          {
            "id": "718eddd4-3901-4a46-bbe2-a80e6fe8067a",
            "order": 0,
            "label": null,
            "content": {
              "template": "Preferred tier"
            },
            "typ": "Standard"
          },
          {
            "id": "019d4f57-9251-4c44-a3a8-40de3c330adb",
            "order": 1,
            "label": null,
            "content": {
              "template": "Non-preferred tier"
            },
            "typ": "Standard"
          },
          {
            "id": "f0607da7-4f35-4253-99e5-5b77824e1caa",
            "order": 2,
            "label": null,
            "content": {
              "template": "Specialty tier"
            },
            "typ": "Standard"
          },
          {
            "id": "7d890713-6e0a-4174-b43b-f4e8bb4388a0",
            "order": 3,
            "label": null,
            "content": {
              "template": "Not covered"
            },
            "typ": "Standard"
          },
          {
            "id": "1b1bbf83-def0-446d-9872-e5d0caeb27b5",
            "order": 4,
            "label": null,
            "content": {
              "template": "Don’t know"
            },
            "typ": "NA"
          }
        ]
      },
      {
        "id": "31f94c21-6942-4df5-81e0-ad6400dd125c",
        "questionTemplateId": null,
        "order": 1,
        "questionType": "CheckboxGrid",
        "isExclusivePerRow": false,
        "isRequired": true,
        "isLocked": true,
        "requiredOptions": {
          "strategy": "AtLeastOnePerColumn"
        },
        "randomizeRow": true,
        "randomizeColumn": true,
        "title": null,
        "content": {
          "template": "What restrictions, if any, does your organization place on these products on your most common formulary (e.g., commercial, Medicare/Part D, Medicaid)?"
        },
        "description": null,
        "columns": [
          {
            "id": "6d9c928d-945d-40fa-bda0-4e4546a23742",
            "order": 0,
            "label": null,
            "content": {
              "template": "%%0",
              "groups": {
                "0": {
                  "placeholder": "Insert product",
                  "text": null
                }
              }
            },
            "typ": "Standard"
          }
        ],
        "rows": [
          {
            "id": "fcc289b0-c33b-4cd6-80c9-98d55c02ff2e",
            "order": 0,
            "label": null,
            "content": {
              "template": "Prior authorization"
            },
            "typ": "Standard"
          },
          {
            "id": "34677d09-b295-4fd8-a648-73dfb5c225cb",
            "order": 1,
            "label": null,
            "content": {
              "template": "Step through generic"
            },
            "typ": "Standard"
          },
          {
            "id": "79611fb6-11b9-416c-a617-a3b5788b0a3f",
            "order": 2,
            "label": null,
            "content": {
              "template": "Step through preferred brand"
            },
            "typ": "Standard"
          },
          {
            "id": "378c0914-ee4b-45b1-8bfa-706dce143794",
            "order": 3,
            "label": null,
            "content": {
              "template": "Quantity limit"
            },
            "typ": "Standard"
          },
          {
            "id": "05f10c91-d2f9-4bb5-a4fa-9d5ebb35a4a0",
            "order": 4,
            "label": null,
            "content": {
              "template": "Other: [Specify]"
            },
            "typ": "ParticipantDefined"
          },
          {
            "id": "70537853-9d24-4a8e-923e-a0193ba688a5",
            "order": 5,
            "label": null,
            "content": {
              "template": "No restrictions"
            },
            "typ": "NA"
          }
        ]
      },
      {
        "id": "f6528a47-b3c7-4b38-9690-3668e41f5c87",
        "questionTemplateId": null,
        "order": 2,
        "questionType": "OpenEndedText",
        "isRequired": true,
        "isLocked": true,
        "title": null,
        "content": {
          "template": "What are your organization’s top goals for managing %%0?",
          "groups": {
            "0": {
              "placeholder": "Insert therapeutic area",
              "text": null
            }
          }
        },
        "description": null
      },
      {
        "id": "57edfa18-42d1-4cd6-b5bc-dacf980d734e",
        "questionTemplateId": null,
        "order": 3,
        "questionType": "RatingList",
        "isExclusivePerRow": null,
        "isRequired": true,
        "isLocked": true,
        "requiredOptions": {
          "strategy": "OnePerRow"
        },
        "randomizeColumn": false,
        "randomizeRow": false,
        "title": null,
        "content": {
          "template": "How likely is it that the following events—were they to occur—would change your organization’s management of %%0?",
          "groups": {
            "0": {
              "placeholder": "Insert therapeutic area",
              "text": null
            }
          }
        },
        "description": null,
        "columns": [
          {
            "id": "a3d14e1b-77b8-4d0d-adc1-4b9f92c72333",
            "order": 0,
            "label": "1",
            "content": {
              "template": "Not at all likely "
            },
            "typ": "Standard"
          },
          {
            "id": "4517d585-173b-4e0a-a643-ab7aa6af9b7d",
            "order": 1,
            "label": "2",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "e2999b36-adcb-4d84-a1a7-6f420476e74a",
            "order": 2,
            "label": "3",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "17629959-7dbf-4260-97e3-fafd12ffa978",
            "order": 3,
            "label": "4",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "11d9b958-905a-4161-a345-0cb154a61987",
            "order": 4,
            "label": "5",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "e947e982-27b3-43fb-beb3-519e9869cead",
            "order": 5,
            "label": "6",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "409da86c-c960-4f54-a2be-c1be2958f932",
            "order": 6,
            "label": "7",
            "content": {
              "template": "Extremely likely"
            },
            "typ": "Standard"
          }
        ],
        "rows": [
          {
            "id": "7dfdef0c-53ca-4578-87de-5fc1c487e731",
            "order": 0,
            "label": null,
            "content": {
              "template": "New market entrant with similar MOA as an existing product"
            },
            "typ": "Standard"
          },
          {
            "id": "3b33bc1c-4f20-4ebd-b221-fd3e1914cc16",
            "order": 1,
            "label": null,
            "content": {
              "template": "New market entrant with a novel MOA"
            },
            "typ": "Standard"
          },
          {
            "id": "ae202186-75e7-4bc5-9030-1124c5a94a9d",
            "order": 3,
            "label": null,
            "content": {
              "template": "Approval of biosimilar in the category"
            },
            "typ": "Standard"
          },
          {
            "id": "75fd24c1-e93a-4284-957b-ca8c54dafeb0",
            "order": 4,
            "label": null,
            "content": {
              "template": "Approval of generic version of an existing product"
            },
            "typ": "Standard"
          },
          {
            "id": "3dcc5b64-d708-473d-858a-ad33cb2c7cc9",
            "order": 4,
            "label": null,
            "content": {
              "template": "Existing product obtains FDA approval for new indication"
            },
            "typ": "Standard"
          }
        ]
      },
      {
        "id": "ca7eb481-87e0-49e8-af64-5303ee312b25",
        "questionTemplateId": null,
        "order": 4,
        "questionType": "RadioButtonGrid",
        "isExclusivePerRow": false,
        "isRequired": true,
        "isLocked": true,
        "requiredOptions": {
          "strategy": "OnePerColumn"
        },
        "randomizeRow": false,
        "randomizeColumn": true,
        "title": null,
        "content": {
          "template": "Please assume the following event occurs in %%0:\n\n%%1\n\nAssuming this scenario, how would your organization likely to cover the products below on your organization’s most common formulary (e.g., commercial, Medicare/Part D, Medicaid)?",
          "groups": {
            "0": {
              "placeholder": "insert year",
              "text": null
            },
            "1": {
              "placeholder": "Insert description of event. Product X obtains clinically significant evidence of efficacy in X population. Product X obtains FDA approval for a new indication in X. Product X loses exclusivity and a generic version becomes available. A biosimilar is approved by the FDA and considered interchangeable with Product X",
              "text": null
            }
          }
        },
        "description": null,
        "columns": [
          {
            "id": "20bea35f-2ccc-4cc1-bb31-6ae6bf2de1b0",
            "order": 0,
            "label": null,
            "content": {
              "template": "%%0",
              "groups": {
                "0": {
                  "placeholder": "Insert product",
                  "text": null
                }
              }
            },
            "typ": "Standard"
          }
        ],
        "rows": [
          {
            "id": "40066008-4e36-42d5-9795-82e765191c74",
            "order": 0,
            "label": null,
            "content": {
              "template": "Preferred tier"
            },
            "typ": "Standard"
          },
          {
            "id": "dd72515e-cc8f-4f84-bff7-7623f100b5cf",
            "order": 1,
            "label": null,
            "content": {
              "template": "Non-preferred tier"
            },
            "typ": "Standard"
          },
          {
            "id": "b9613c11-4a14-459c-b7cc-7a9fa568c2e7",
            "order": 2,
            "label": null,
            "content": {
              "template": "Specialty tier"
            },
            "typ": "Standard"
          },
          {
            "id": "13ee70f2-d4e2-4fa6-9578-ddfe10947f62",
            "order": 3,
            "label": null,
            "content": {
              "template": "Not covered"
            },
            "typ": "Standard"
          },
          {
            "id": "bc8c4ff5-b23e-483f-99fe-aaf07cab526d",
            "order": 4,
            "label": null,
            "content": {
              "template": "Don’t know"
            },
            "typ": "NA"
          }
        ]
      },
      {
        "id": "79deb969-a7f5-4c04-93bc-8d7b224ae425",
        "questionTemplateId": null,
        "order": 5,
        "questionType": "RadioButtonGrid",
        "isExclusivePerRow": false,
        "isRequired": true,
        "isLocked": true,
        "requiredOptions": {
          "strategy": "OnePerColumn"
        },
        "randomizeRow": false,
        "randomizeColumn": true,
        "title": null,
        "content": {
          "template": "Please assume the following event occurs in %%0:\n\n%%1\n\nAssuming this scenario, what restrictions, if any, would your organization place on these products on your most common formulary (e.g., commercial, Medicare/Part D, Medicaid)?",
          "groups": {
            "0": {
              "placeholder": "insert year",
              "text": null
            },
            "1": {
              "placeholder": "Insert description of event. Product X obtains clinically significant evidence of efficacy in X population. Product X obtains FDA approval for a new indication in X. Product X loses exclusivity and a generic version becomes available. A biosimilar is approved by the FDA and considered interchangeable with Product X",
              "text": null
            }
          }
        },
        "description": null,
        "columns": [
          {
            "id": "34bd2260-69b6-4aa5-93a9-d6c40e8499db",
            "order": 0,
            "label": null,
            "content": {
              "template": "%%0",
              "groups": {
                "0": {
                  "placeholder": "Insert product",
                  "text": null
                }
              }
            },
            "typ": "Standard"
          }
        ],
        "rows": [
          {
            "id": "004fd5a9-24fc-433a-9400-8a365ab2e25b",
            "order": 0,
            "label": null,
            "content": {
              "template": "Prior authorization"
            },
            "typ": "Standard"
          },
          {
            "id": "8f227bc4-2517-472c-a58c-188d5133f20b",
            "order": 1,
            "label": null,
            "content": {
              "template": "Step through generic"
            },
            "typ": "Standard"
          },
          {
            "id": "271ee0a4-6850-4e86-a202-3977a3d65a68",
            "order": 2,
            "label": null,
            "content": {
              "template": "Step through preferred brand"
            },
            "typ": "Standard"
          },
          {
            "id": "c02b8ffc-56fc-4945-abf2-f26f52296a10",
            "order": 3,
            "label": null,
            "content": {
              "template": "Quantity limit"
            },
            "typ": "Standard"
          },
          {
            "id": "f2637e22-2c76-494d-a65f-3fe030dfe085",
            "order": 4,
            "label": null,
            "content": {
              "template": "Other: [Specify]"
            },
            "typ": "ParticipantDefined"
          },
          {
            "id": "a1a0d3a9-8166-404e-8e62-a2bcd3cec4f7",
            "order": 5,
            "label": null,
            "content": {
              "template": "No restrictions"
            },
            "typ": "NA"
          }
        ]
      },
      {
        "id": "9bea81c6-77f8-4fe0-8062-20ade7495b92",
        "questionTemplateId": null,
        "order": 6,
        "questionType": "RadioButtonGrid",
        "isExclusivePerRow": false,
        "isRequired": true,
        "isLocked": true,
        "requiredOptions": {
          "strategy": "OnePerColumn"
        },
        "randomizeRow": false,
        "randomizeColumn": true,
        "title": null,
        "content": {
          "template": "Please assume the following event occurs in %%0:\n\n%%1\n\nAssuming this scenario, what restrictions, if any, would your organization place on these products on your most common formulary (e.g., commercial, Medicare/Part D, Medicaid)?",
          "groups": {
            "0": {
              "placeholder": "insert year",
              "text": null
            },
            "1": {
              "placeholder": "Insert description of event. Product X obtains clinically significant evidence of efficacy in X population. Product X obtains FDA approval for a new indication in X. Product X loses exclusivity and a generic version becomes available. A biosimilar is approved by the FDA and considered interchangeable with Product X",
              "text": null
            }
          }
        },
        "description": null,
        "columns": [
          {
            "id": "2295d64c-50c4-43fa-8444-ecb1a29750b2",
            "order": 0,
            "label": null,
            "content": {
              "template": "%%0",
              "groups": {
                "0": {
                  "placeholder": "Insert product",
                  "text": null
                }
              }
            },
            "typ": "Standard"
          }
        ],
        "rows": [
          {
            "id": "2e47281b-7691-49e9-96b9-50eeef270a1c",
            "order": 0,
            "label": null,
            "content": {
              "template": "Prior authorization"
            },
            "typ": "Standard"
          },
          {
            "id": "c013daa2-9bfc-491b-9bf9-4a9777202be3",
            "order": 1,
            "label": null,
            "content": {
              "template": "Step through generic"
            },
            "typ": "Standard"
          },
          {
            "id": "4b1850d0-9554-4621-9c9f-c450fbc75624",
            "order": 2,
            "label": null,
            "content": {
              "template": "Step through preferred brand"
            },
            "typ": "Standard"
          },
          {
            "id": "d637f145-b00a-42e1-8dd4-6fe2ff004b8a",
            "order": 3,
            "label": null,
            "content": {
              "template": "Quantity limit"
            },
            "typ": "Standard"
          },
          {
            "id": "d8747a6c-e98d-4ca2-b76c-758066db49dd",
            "order": 4,
            "label": null,
            "content": {
              "template": "Other: [Specify]"
            },
            "typ": "ParticipantDefined"
          },
          {
            "id": "672c583c-0080-437d-8da2-2b77050b5fe2",
            "order": 5,
            "label": null,
            "content": {
              "template": "No restrictions"
            },
            "typ": "NA"
          }
        ]
      },
      {
        "id": "a78a2d96-9569-4124-9c8d-31521ce27d33",
        "questionTemplateId": null,
        "order": 7,
        "questionType": "RadioButtonList",
        "isRequired": true,
        "isLocked": true,
        "randomize": false,
        "requiredOptions": null,
        "title": null,
        "content": {
          "template": "Please assume the following event occurs in %%0:\n\n%%1\n\nHow long after this event occurs would your organization make a coverage decision?",
          "groups": {
            "0": {
              "placeholder": "insert year",
              "text": null
            },
            "1": {
              "placeholder": "Insert description of event. Product X obtains clinically significant evidence of efficacy in X population. Product X obtains FDA approval for a new indication in X. Product X loses exclusivity and a generic version becomes available. A biosimilar is approved by the FDA and considered interchangeable with Product X",
              "text": null
            }
          }
        },
        "description": null,
        "answerOptions": [
          {
            "id": "96297910-bec1-4c91-a6a2-71b6a268ece2",
            "order": 0,
            "label": null,
            "content": {
              "template": "As soon as possible - Product review would be triggered by event"
            },
            "typ": "Standard"
          },
          {
            "id": "970e2928-8bda-45ad-b526-ae7d167c7463",
            "order": 1,
            "label": null,
            "content": {
              "template": "Not immediately but within 3 months"
            },
            "typ": "Standard"
          },
          {
            "id": "e4453313-5b58-4596-890e-bf96935c6fff",
            "order": 2,
            "label": null,
            "content": {
              "template": "More than 3 months but within 6 months"
            },
            "typ": "Standard"
          },
          {
            "id": "94886e7d-a7bc-4135-81a0-02aaf3490b63",
            "order": 3,
            "label": null,
            "content": {
              "template": "More than 6 months but within a year"
            },
            "typ": "Standard"
          },
          {
            "id": "200de0bf-d9b7-4ab8-9618-9441be335d6f",
            "order": 4,
            "label": null,
            "content": {
              "template": "More than a year after approval"
            },
            "typ": "Standard"
          },
          {
            "id": "1af278bc-62e1-4bef-9e37-f4b28317db2d",
            "order": 5,
            "label": null,
            "content": {
              "template": "Other: [Specify]"
            },
            "typ": "ParticipantDefined"
          }
        ]
      },
      {
        "id": "ede446d0-bbe6-4001-b67b-0631730ccc81",
        "questionTemplateId": null,
        "order": 8,
        "questionType": "CheckboxList",
        "isRequired": true,
        "isLocked": true,
        "randomize": false,
        "requiredOptions": null,
        "title": null,
        "content": {
          "template": "%%0\n\nWhich of the following price points would warrant a preferred formulary status for %%1?",
          "groups": {
            "0": {
              "placeholder": "Insert product profile",
              "text": null
            },
            "1": {
              "placeholder": "Insert new product/biosimilar/ product with new indication",
              "text": null
            }
          }
        },
        "description": null,
        "answerOptions": [
          {
            "id": "e7bcad45-3c15-4606-a48f-1ba47965bc11",
            "order": 0,
            "label": null,
            "content": {
              "template": "20% premium to standard of care"
            },
            "typ": "Standard"
          },
          {
            "id": "db766a9d-eec8-4ebd-a8d4-20ec3b093eb7",
            "order": 1,
            "label": null,
            "content": {
              "template": "10% premium to standard of care"
            },
            "typ": "Standard"
          },
          {
            "id": "c8aa0617-f823-44bd-aa06-00fc5dccca7a",
            "order": 2,
            "label": null,
            "content": {
              "template": "Parity with standard of care"
            },
            "typ": "Standard"
          },
          {
            "id": "52c3cbf9-566d-4aba-a8ce-c64474f8f313",
            "order": 3,
            "label": null,
            "content": {
              "template": "10% discount below standard of care"
            },
            "typ": "Standard"
          },
          {
            "id": "81ef9039-d98f-43df-ac3f-6e3211641f98",
            "order": 4,
            "label": null,
            "content": {
              "template": "20% discount below standard of care"
            },
            "typ": "Standard"
          },
          {
            "id": "2cd3ab30-d640-4342-a93d-ac5c3a6fb1cb",
            "order": 5,
            "label": null,
            "content": {
              "template": "Other: [Specify]"
            },
            "typ": "ParticipantDefined"
          },
          {
            "id": "186ea54e-4738-49ed-9751-287dd1af1954",
            "order": 6,
            "label": null,
            "content": {
              "template": "NA – Would not have preferred status at any price point"
            },
            "typ": "NA"
          }
        ]
      },
      {
        "id": "35a43f7a-9031-4891-bf7b-34c720a107d8",
        "questionTemplateId": null,
        "order": 9,
        "questionType": "OpenEndedText",
        "isRequired": true,
        "isLocked": true,
        "title": null,
        "content": {
          "template": "Please explain your rationale for your previous response."
        },
        "description": null
      },
    ],
    "screeners": [],
    "deleted": []
  },
  {
    "id": "8ec147ca-b2d6-4622-a047-d5ccb0630911",
    "title": "Assess impact of policy changes (e.g., legislation, CMS changes)",
    "sourceTitle": null,
    "panel": "HealthPlan",
    "status": "Draft",
    "description": null,
    "questions": [
      {
        "id": "bdfd7798-13ff-437a-846f-82fded4ca303",
        "questionTemplateId": null,
        "order": 0,
        "questionType": "RatingList",
        "isExclusivePerRow": null,
        "isRequired": true,
        "isLocked": true,
        "requiredOptions": {
          "strategy": "OnePerRow"
        },
        "randomizeColumn": false,
        "randomizeRow": false,
        "title": null,
        "content": {
          "template": "%%0\n\nIf this policy were implemented, how much of an impact in terms of staffing resources would this change require from your organization?",
          "groups": {
            "0": {
              "placeholder": "Insert description of policy change, e.g., CMS recently announced proposed changes to Medicare Advantage and Part D programs. The following questions will reference these proposed changes. One proposed rule would require…",
              "text": null
            }
          }
        },
        "description": null,
        "columns": [
          {
            "id": "c29e6429-c1bc-41b0-ab34-a6ca3170b604",
            "order": 0,
            "label": "1",
            "content": {
              "template": "Little to no resources"
            },
            "typ": "Standard"
          },
          {
            "id": "200583aa-d363-4e7d-a63f-4c9cc703ecca",
            "order": 1,
            "label": "2",
            "content": { "template": "" },
            "typ": "Standard"
          },
          {
            "id": "b7fbdfad-8f6a-4862-96b0-2de947f65953",
            "order": 2,
            "label": "3",
            "content": { "template": "" },
            "typ": "Standard"
          },
          {
            "id": "e2a4f563-786b-4885-b1cd-094f1ab85672",
            "order": 3,
            "label": "4",
            "content": { "template": "" },
            "typ": "Standard"
          },
          {
            "id": "4d29d7a6-521f-47cc-b9f7-30d936bb7032",
            "order": 4,
            "label": "5",
            "content": { "template": "" },
            "typ": "Standard"
          },
          {
            "id": "17d21c5f-4ed8-40ee-b476-341b08505a09",
            "order": 5,
            "label": "6",
            "content": { "template": "" },
            "typ": "Standard"
          },
          {
            "id": "20dfcaeb-0fbf-48cf-a1e0-53f2090cad76",
            "order": 6,
            "label": "7",
            "content": { "template": "Significant resources" },
            "typ": "Standard"
          }
        ],
        "rows": [
          {
            "id": "949f8d15-007b-4c3f-882b-5ed31b04d01e",
            "order": 0,
            "label": null,
            "content": { "template": "" },
            "typ": "Standard"
          }
        ]
      },
      {
        "id": "0ceb9171-44a4-467d-a579-7d3f3230692c",
        "questionTemplateId": null,
        "order": 1,
        "questionType": "RatingList",
        "isExclusivePerRow": null,
        "isRequired": true,
        "isLocked": true,
        "requiredOptions": {
          "strategy": "OnePerRow"
        },
        "randomizeColumn": false,
        "randomizeRow": false,
        "title": null,
        "content": {
          "template": "%%0\n\nIf this policy were implemented, how costly, in terms of monetary value, would this change be for your organization?",
          "groups": {
            "0": {
              "placeholder": "Insert description of policy change, e.g., CMS recently announced proposed changes to Medicare Advantage and Part D programs. The following questions will reference these proposed changes. One proposed rule would require…",
              "text": null
            }
          }
        },
        "description": null,
        "columns": [
          {
            "id": "f7f97227-018f-423c-862d-f970ade80c23",
            "order": 0,
            "label": "1",
            "content": {
              "template": "Not costly at all"
            },
            "typ": "Standard"
          },
          {
            "id": "c457dfd2-7911-48b2-9742-67571bb6e808",
            "order": 1,
            "label": "2",
            "content": { "template": "" },
            "typ": "Standard"
          },
          {
            "id": "27d6c120-2c4a-483c-aced-0679517c9449",
            "order": 2,
            "label": "3",
            "content": { "template": "" },
            "typ": "Standard"
          },
          {
            "id": "1fb61246-bb01-4df7-b0bb-24ea310678b7",
            "order": 3,
            "label": "4",
            "content": { "template": "" },
            "typ": "Standard"
          },
          {
            "id": "b9031bea-bc4b-40c3-8086-d50f703db3e4",
            "order": 4,
            "label": "5",
            "content": { "template": "" },
            "typ": "Standard"
          },
          {
            "id": "af59732c-3b83-4287-ba8a-33776b74c6a1",
            "order": 5,
            "label": "6",
            "content": { "template": "" },
            "typ": "Standard"
          },
          {
            "id": "8a15f89e-16ba-4f89-806d-be1faccc5767",
            "order": 6,
            "label": "7",
            "content": { "template": "Extremely costly" },
            "typ": "Standard"
          }
        ],
        "rows": [
          {
            "id": "01cedb03-7600-48b1-bc49-24d376f6f42a",
            "order": 0,
            "label": null,
            "content": { "template": "" },
            "typ": "Standard"
          }
        ]
      },
      {
        "id": "c66bc225-e2f3-4b6b-b22b-1db7911a9e03",
        "questionTemplateId": null,
        "order": 2,
        "questionType": "OpenEndedText",
        "isRequired": true,
        "isLocked": true,
        "title": null,
        "content": {
          "template": "What specifically would be the costliest change your organization would need to make based on this policy change?"
        },
        "description": null
      },
      {
        "id": "0aea389a-db02-4653-8a06-3978841e7f33",
        "questionTemplateId": null,
        "order": 3,
        "questionType": "RadioButtonList",
        "isRequired": true,
        "isLocked": true,
        "randomize": false,
        "requiredOptions": null,
        "title": null,
        "content": {
          "template": "%%0\n\nHow long would it take your organization to make the necessary changes to be compliant with this policy?",
          "groups": {
            "0": {
              "placeholder": "Insert description of policy change, e.g., CMS recently announced proposed changes to Medicare Advantage and Part D programs. The following questions will reference these proposed changes. One proposed rule would require…",
              "text": null
            }
          }
        },
        "description": null,
        "answerOptions": [
          {
            "id": "83117b30-25c2-42f9-b34e-2fff97496cf0",
            "order": 0,
            "label": null,
            "content": {
              "template": "No time – We are already compliant"
            },
            "typ": "Standard"
          },
          {
            "id": "a89cca49-baf2-4bd8-9c87-cf635ae6b9ae",
            "order": 1,
            "label": null,
            "content": {
              "template": "3 months or less"
            },
            "typ": "Standard"
          },
          {
            "id": "9ff973ff-ec1b-4f66-bf3b-cb86750444db",
            "order": 2,
            "label": null,
            "content": {
              "template": "More than 3 months but within 6 months"
            },
            "typ": "Standard"
          },
          {
            "id": "a525341b-3797-479e-8470-c74dbadc150f",
            "order": 3,
            "label": null,
            "content": {
              "template": "More than 6 months but within one year"
            },
            "typ": "Standard"
          },
          {
            "id": "659283d1-4b7f-437b-ae5f-03dc467817e0",
            "order": 4,
            "label": null,
            "content": {
              "template": "More than one year"
            },
            "typ": "Standard"
          },
          {
            "id": "fce354af-72ab-471a-ab2a-140b7c607780",
            "order": 5,
            "label": null,
            "content": {
              "template": "Do not plan to implement these changes"
            },
            "typ": "NA"
          }
        ]
      },
      {
        "id": "cf202840-2ab6-4b97-adc6-f5df5a19eeb0",
        "questionTemplateId": null,
        "order": 4,
        "questionType": "CheckboxList",
        "isRequired": true,
        "isLocked": true,
        "randomize": true,
        "requiredOptions": null,
        "title": null,
        "content": {
          "template": "%%0\n\nWhat barriers, if any, does this change pose to your organization?",
          "groups": {
            "0": {
              "placeholder": "Insert description of policy change, e.g., CMS recently announced proposed changes to Medicare Advantage and Part D programs. The following questions will reference these proposed changes. One proposed rule would require…",
              "text": null
            }
          }
        },
        "description": null,
        "answerOptions": [
          {
            "id": "8015fca6-f4dc-49f4-9a7c-0c08ab69c5c1",
            "order": 0,
            "label": null,
            "content": {
              "template": "Not in line with our business goals"
            },
            "typ": "Standard"
          },
          {
            "id": "52903848-5702-46fd-87d6-e2f1dab1c60e",
            "order": 1,
            "label": null,
            "content": {
              "template": "Not enough staffing resources to implement"
            },
            "typ": "Standard"
          },
          {
            "id": "e7b8c123-2db9-4e60-8d62-0a8a64a47857",
            "order": 2,
            "label": null,
            "content": {
              "template": "Too costly to implement"
            },
            "typ": "Standard"
          },
          {
            "id": "9d88d366-ea9b-4dd6-afb9-d77243b8a8b2",
            "order": 3,
            "label": null,
            "content": {
              "template": "Internal leadership disagreement with these changes"
            },
            "typ": "Standard"
          },
          {
            "id": "54445d3a-1f6e-4222-b7f4-f234abad6ab6",
            "order": 4,
            "label": null,
            "content": {
              "template": "Not clear what my organization needs to do in response to this change"
            },
            "typ": "Standard"
          }
        ]
      },
      {
        "id": "57033072-8f18-4852-b97f-f356b228f68b",
        "questionTemplateId": null,
        "order": 5,
        "questionType": "OpenEndedText",
        "isRequired": true,
        "isLocked": true,
        "title": null,
        "content": {
          "template": "Once implemented, what positives, if any, would this change provide for your organization or the population you serve?"
        },
        "description": null
      },
      {
        "id": "f846dc8f-e6d7-4720-a176-843a31f7e6cb",
        "questionTemplateId": null,
        "order": 6,
        "questionType": "OpenEndedText",
        "isRequired": true,
        "isLocked": true,
        "title": null,
        "content": {
          "template": "Once implemented, what negatives, if any, would this change bring to your organization or the population you serve?"
        },
        "description": null
      },
      {
        "id": "bb18a8bb-1ad1-4b90-9cb3-48f41b4d098c",
        "questionTemplateId": null,
        "order": 7,
        "questionType": "RadioButtonList",
        "isRequired": true,
        "isLocked": true,
        "randomize": false,
        "requiredOptions": null,
        "title": null,
        "content": {
          "template": "%%0\n\nAs a whole, how does this change compare to previous policy changes from this organization in the past, thinking in terms of staffing resources your organization would need to dedicate to become compliant?",
          "groups": {
            "0": {
              "placeholder": "Insert description of policy change, e.g., CMS recently announced proposed changes to Medicare Advantage and Part D programs. The following questions will reference these proposed changes. One proposed rule would require…",
              "text": null
            }
          }
        },
        "description": null,
        "answerOptions": [
          {
            "id": "558a560d-1c55-4ba2-943c-f56d698a27a4",
            "order": 0,
            "label": null,
            "content": {
              "template": "Fewer resources"
            },
            "typ": "Standard"
          },
          {
            "id": "b2555eab-ef93-4efb-81e7-9cffa3914d11",
            "order": 1,
            "label": null,
            "content": {
              "template": "About the same"
            },
            "typ": "Standard"
          },
          {
            "id": "7bafe763-21c1-4329-b9b6-1acb5b51cc89",
            "order": 2,
            "label": null,
            "content": {
              "template": "More resources"
            },
            "typ": "Standard"
          }
        ]
      },
      {
        "id": "a24880bb-1c62-4854-9350-f31f3689854b",
        "questionTemplateId": null,
        "order": 8,
        "questionType": "RadioButtonList",
        "isRequired": true,
        "isLocked": true,
        "randomize": false,
        "requiredOptions": null,
        "title": null,
        "content": {
          "template": "%%0\n\nAs a whole, how does this change compare to previous policy changes from this organization in the past, thinking in terms of cost to your organization to become compliant?",
          "groups": {
            "0": {
              "placeholder": "Insert description of policy change, e.g., CMS recently announced proposed changes to Medicare Advantage and Part D programs. The following questions will reference these proposed changes. One proposed rule would require…",
              "text": null
            }
          }
        },
        "description": null,
        "answerOptions": [
          {
            "id": "5f16046e-fa4b-4d29-ba1e-cdb4867c59c7",
            "order": 0,
            "label": null,
            "content": {
              "template": "Less costly"
            },
            "typ": "Standard"
          },
          {
            "id": "25123543-dfc4-4b95-9b45-dc09f3d08ed6",
            "order": 1,
            "label": null,
            "content": {
              "template": "About the same"
            },
            "typ": "Standard"
          },
          {
            "id": "b0600227-4ad5-4852-8fad-fa884d180247",
            "order": 2,
            "label": null,
            "content": {
              "template": "More costly"
            },
            "typ": "Standard"
          }
        ]
      },
      {
        "id": "15918e69-d311-4760-8283-6b5f631f9f5f",
        "questionTemplateId": null,
        "order": 9,
        "questionType": "RatingList",
        "isExclusivePerRow": null,
        "isRequired": true,
        "isLocked": true,
        "requiredOptions": {
          "strategy": "OnePerRow"
        },
        "randomizeColumn": false,
        "randomizeRow": false,
        "title": null,
        "content": {
          "template": "%%0\n\nHow interested would your organization be in partnering with or receiving support from a biopharmaceutical company to make the necessary changes in your organization based on this policy change?",
          "groups": {
            "0": {
              "placeholder": "Insert description of policy change, e.g., CMS recently announced proposed changes to Medicare Advantage and Part D programs. The following questions will reference these proposed changes. One proposed rule would require…",
              "text": null
            }
          }
        },
        "description": null,
        "columns": [
          {
            "id": "47c7b868-adac-410f-954b-ef53908d9fdc",
            "order": 0,
            "label": "1",
            "content": {
              "template": "Not at all interested"
            },
            "typ": "Standard"
          },
          {
            "id": "b29e54da-f583-43ee-add6-33f7443e3d81",
            "order": 1,
            "label": "2",
            "content": { "template": "" },
            "typ": "Standard"
          },
          {
            "id": "1e293667-4a92-4b10-977b-1ab8d16545a1",
            "order": 2,
            "label": "3",
            "content": { "template": "" },
            "typ": "Standard"
          },
          {
            "id": "c268180c-50fa-457c-b3d5-03ab03dabfda",
            "order": 3,
            "label": "4",
            "content": { "template": "" },
            "typ": "Standard"
          },
          {
            "id": "d8010243-ebab-466e-8502-2dde326420a3",
            "order": 4,
            "label": "5",
            "content": { "template": "" },
            "typ": "Standard"
          },
          {
            "id": "8657374f-8890-43e8-adc0-5d80d5b11ed6",
            "order": 5,
            "label": "6",
            "content": { "template": "" },
            "typ": "Standard"
          },
          {
            "id": "f50639c4-cf9f-4dee-a88c-5a6b7b01cfe3",
            "order": 6,
            "label": "7",
            "content": { "template": "Extremely interested" },
            "typ": "Standard"
          }
        ],
        "rows": [
          {
            "id": "7e5d1f32-0488-4937-afdf-368831b6d749",
            "order": 0,
            "label": null,
            "content": { "template": "" },
            "typ": "Standard"
          }
        ]
      }
    ],
    "screeners": [],
    "deleted": []
  },
  {
    "id": "2ddd2218-c4f3-42ee-a531-09948031e0bb",
    "title": "Reaction to value proposition or product messaging",
    "sourceTitle": null,
    "panel": "HealthPlan",
    "status": "Draft",
    "description": null,
    "questions": [
      {
        "id": "3fc6d1df-692e-48af-9041-ddcfc726d443",
        "questionTemplateId": null,
        "order": 0,
        "questionType": "RatingList",
        "isExclusivePerRow": null,
        "isRequired": true,
        "isLocked": true,
        "requiredOptions": {
          "strategy": "OnePerRow"
        },
        "randomizeColumn": false,
        "randomizeRow": true,
        "title": null,
        "content": {
          "template": "Please rate each of the following needs as they apply to the treatment of %%0.",
          "groups": {
            "0": {
              "placeholder": "Insert therapeutic area",
              "text": null
            }
          }
        },
        "description": null,
        "columns": [
          {
            "id": "22d19dc7-9f69-4301-945f-97d32a7b671f",
            "order": 0,
            "label": "1",
            "content": {
              "template": "Very low need"
            },
            "typ": "Standard"
          },
          {
            "id": "0aa69624-cfb0-4245-9ee3-c559f78db25c",
            "order": 1,
            "label": "2",
            "content": { "template": "" },
            "typ": "Standard"
          },
          {
            "id": "f937808a-8986-4d91-b34a-55b47c559150",
            "order": 2,
            "label": "3",
            "content": { "template": "" },
            "typ": "Standard"
          },
          {
            "id": "599632be-543c-4b16-bc1d-f5b6472822fe",
            "order": 3,
            "label": "4",
            "content": { "template": "" },
            "typ": "Standard"
          },
          {
            "id": "256e18b0-3ab4-4bbe-bba3-1c1d08a6f764",
            "order": 4,
            "label": "5",
            "content": { "template": "" },
            "typ": "Standard"
          },
          {
            "id": "066b2600-0f16-4764-9736-1aea7617a677",
            "order": 5,
            "label": "6",
            "content": { "template": "" },
            "typ": "Standard"
          },
          {
            "id": "c46dc058-acf6-4374-bb10-5db011534cc3",
            "order": 6,
            "label": "7",
            "content": { "template": "Very high need" },
            "typ": "Standard"
          }
        ],
        "rows": [
          {
            "id": "7cf99417-d527-4afa-a785-474666bedbca",
            "order": 0,
            "label": null,
            "content": { "template": "Improved clinical efficacy or outcomes compared to standard of care" },
            "typ": "Standard"
          },
          {
            "id": "24e5f6ce-b9e4-40ef-b283-f36b20837eb6",
            "order": 1,
            "label": null,
            "content": { "template": "Increased patient compliance with therapy" },
            "typ": "Standard"
          },
          {
            "id": "8b41c384-5ddb-4d86-a3a4-cb2937a60bfb",
            "order": 2,
            "label": null,
            "content": { "template": "Reduced adverse events" },
            "typ": "Standard"
          },
          {
            "id": "34c4c3a2-5196-4fe3-965e-8f147924c363",
            "order": 3,
            "label": null,
            "content": { "template": "Reduced healthcare resource utilization compared to standard of care" },
            "typ": "Standard"
          }
        ]
      },
      {
        "id": "1012061d-bf84-4dbe-bf5f-54ded5586514",
        "questionTemplateId": null,
        "order": 1,
        "questionType": "RatingList",
        "isExclusivePerRow": null,
        "isRequired": true,
        "isLocked": true,
        "requiredOptions": {
          "strategy": "OnePerRow"
        },
        "randomizeColumn": false,
        "randomizeRow": true,
        "title": null,
        "content": {
          "template": "Throughout this survey, you will be asked to assess a series of product messages for a biopharmaceutical product.\n\nPlease review the messages below and rate how believable each message is."
        },
        "description": null,
        "columns": [
          {
            "id": "efc08f27-f0ae-4f23-a245-f036a03984d2",
            "order": 0,
            "label": "1",
            "content": {
              "template": "Not at all believable "
            },
            "typ": "Standard"
          },
          {
            "id": "3ab7e460-67b8-4d62-b446-f3e918498051",
            "order": 1,
            "label": "2",
            "content": { "template": "" },
            "typ": "Standard"
          },
          {
            "id": "38d00137-f59c-4b9d-99ea-0eff6208b4fc",
            "order": 2,
            "label": "3",
            "content": { "template": "" },
            "typ": "Standard"
          },
          {
            "id": "a277158e-3ec9-4190-b630-d0e33e398f29",
            "order": 3,
            "label": "4",
            "content": { "template": "" },
            "typ": "Standard"
          },
          {
            "id": "8a5c9ea5-82c7-4a13-8fe3-9bfaf662f06c",
            "order": 4,
            "label": "5",
            "content": { "template": "" },
            "typ": "Standard"
          },
          {
            "id": "483ce8df-fa03-4376-9ec8-e1cf0f95c91c",
            "order": 5,
            "label": "6",
            "content": { "template": "" },
            "typ": "Standard"
          },
          {
            "id": "d0e53f8f-ad5a-4cf6-8c2f-54ccd6017151",
            "order": 6,
            "label": "7",
            "content": { "template": "Extremely believable" },
            "typ": "Standard"
          }
        ],
        "rows": [
          {
            "id": "f191cf6d-e659-4de6-84da-f6c2d5dbe931",
            "order": 0,
            "label": null,
            "content": { 
              "template": "%%0",
              "groups": {
                "0": {
                  "placeholder": "Insert message",
                  "text": null
                }
              }
             },
            "typ": "Standard"
          }
        ]
      },
      {
        "id": "52ba7e90-dc49-42e5-b6e8-bb7d8e8ed315",
        "questionTemplateId": null,
        "order": 2,
        "questionType": "RatingList",
        "isExclusivePerRow": null,
        "isRequired": true,
        "isLocked": true,
        "requiredOptions": {
          "strategy": "OnePerRow"
        },
        "randomizeColumn": false,
        "randomizeRow": true,
        "title": null,
        "content": {
          "template": "How much differentiation does each message offer compared to currently available %%0 products?",
          "0": {
            "placeholder": "insert therapeutic area",
            "text": null
          }
        },
        "description": null,
        "columns": [
          {
            "id": "25aec83f-530a-4edb-9e28-cc32e2737d5b",
            "order": 0,
            "label": "1",
            "content": {
              "template": "Not at all differentiating"
            },
            "typ": "Standard"
          },
          {
            "id": "97e678bb-ca51-4a48-8e64-6fa4416ade70",
            "order": 1,
            "label": "2",
            "content": { "template": "" },
            "typ": "Standard"
          },
          {
            "id": "62db51d4-d8f4-4a28-91f7-fab0d39ee903",
            "order": 2,
            "label": "3",
            "content": { "template": "" },
            "typ": "Standard"
          },
          {
            "id": "d05ec6c1-822e-4a69-9549-9aaafd7db5e9",
            "order": 3,
            "label": "4",
            "content": { "template": "" },
            "typ": "Standard"
          },
          {
            "id": "dcb6cfcc-7241-4b36-885b-865779854091",
            "order": 4,
            "label": "5",
            "content": { "template": "" },
            "typ": "Standard"
          },
          {
            "id": "64c4053c-df58-4a25-856c-aa22a39ecf8e",
            "order": 5,
            "label": "6",
            "content": { "template": "" },
            "typ": "Standard"
          },
          {
            "id": "5206246a-b153-4290-9e22-21f1c55d4e99",
            "order": 6,
            "label": "7",
            "content": { "template": "Extremely differentiating" },
            "typ": "Standard"
          }
        ],
        "rows": [
          {
            "id": "11c339ea-5e37-4f80-9e3b-6a3abd76ee07",
            "order": 0,
            "label": null,
            "content": { 
              "template": "%%0",
              "groups": {
                "0": {
                  "placeholder": "Insert message",
                  "text": null
                }
              }
             },
            "typ": "Standard"
          }
        ]
      },
      {
        "id": "4ae6ca69-e77e-4d34-a6a7-f0253725098a",
        "questionTemplateId": null,
        "order": 3,
        "questionType": "CheckboxList",
        "isRequired": true,
        "isLocked": true,
        "randomize": true,
        "requiredOptions": null,
        "title": null,
        "content": {
          "template": "If you were to be presented with these messages by an account manager or representative from a biopharmaceutical company and there was only one of these messages that could be shared with you, which message would you most want to hear?"
        },
        "description": null,
        "answerOptions": [
          {
            "id": "7070e2c1-03dc-4ba3-a5ed-2856a55f25b2",
            "order": 0,
            "label": null,
            "content": {
              "template": "%%0",
              "groups": {
                "0": {
                  "placeholder": "Insert message",
                  "text": null
                }
              }
            },
            "typ": "Standard"
          }
        ]
      },
      {
        "id": "7090a4d9-eb5c-493b-a91d-a0420ae8999d",
        "questionTemplateId": null,
        "order": 4,
        "questionType": "RatingList",
        "isExclusivePerRow": null,
        "isRequired": true,
        "isLocked": true,
        "requiredOptions": {
          "strategy": "OnePerRow"
        },
        "randomizeColumn": false,
        "randomizeRow": false,
        "title": null,
        "content": {
          "template": "How often do a set of product messages factor into the initial formulary placement of a new product and how often do they factor into changing the formulary status of an existing product to get improved access?"
        },
        "description": null,
        "columns": [
          {
            "id": "b3e08707-e2b1-463e-a075-98fccecf0916",
            "order": 0,
            "label": "1",
            "content": {
              "template": "Never"
            },
            "typ": "Standard"
          },
          {
            "id": "47bd0042-edae-4c70-859b-950375ad388a",
            "order": 1,
            "label": "2",
            "content": { "template": "" },
            "typ": "Standard"
          },
          {
            "id": "176945db-c195-48b2-8839-da037de22851",
            "order": 2,
            "label": "3",
            "content": { "template": "" },
            "typ": "Standard"
          },
          {
            "id": "8dc6054a-ed5e-4299-b2b9-319faf6ea46d",
            "order": 3,
            "label": "4",
            "content": { "template": "" },
            "typ": "Standard"
          },
          {
            "id": "1082a8f8-acd3-4f10-bdef-89231de4ae03",
            "order": 4,
            "label": "5",
            "content": { "template": "" },
            "typ": "Standard"
          },
          {
            "id": "ebad83d5-68cb-4212-8a58-ab4b2f7a539e",
            "order": 5,
            "label": "6",
            "content": { "template": "" },
            "typ": "Standard"
          },
          {
            "id": "049f37cb-2316-4546-af2c-593efc3f8c1e",
            "order": 6,
            "label": "7",
            "content": { "template": "Always" },
            "typ": "Standard"
          }
        ],
        "rows": [
          {
            "id": "807248c5-c133-4255-b37c-1fd8f8298c53",
            "order": 0,
            "label": null,
            "content": { 
              "template": "Placement of new product"
             },
            "typ": "Standard"
          },
          {
            "id": "1630ad4c-7251-4a29-bc7a-0514a2dd217b",
            "order": 0,
            "label": null,
            "content": { 
              "template": "Changing formulary status of an existing product to get improved access"
             },
            "typ": "Standard"
          }
        ]
      },
      {
        "id": "e698cb1c-e89f-4509-91d8-1aaf48efb92b",
        "questionTemplateId": null,
        "order": 5,
        "questionType": "OpenEndedText",
        "isRequired": true,
        "isLocked": true,
        "title": null,
        "content": {
          "template": "How are product value props/messages like these typically referenced or discussed in P&T committees?"
        },
        "description": null
      },
      {
        "id": "6d305b47-f438-46e6-8808-405bde9bb583",
        "questionTemplateId": null,
        "order": 6,
        "questionType": "RatingList",
        "isExclusivePerRow": null,
        "isRequired": true,
        "isLocked": true,
        "requiredOptions": {
          "strategy": "OnePerRow"
        },
        "randomizeColumn": false,
        "randomizeRow": true,
        "title": null,
        "content": {
          "template": "In a pharmacy & therapeutics committee (P&T) setting, how persuasive would each message be in warranting more favorable formulary access?"
        },
        "description": null,
        "columns": [
          {
            "id": "b3b324e0-c7a7-47bc-95f6-0fe3e9be14e3",
            "order": 0,
            "label": "1",
            "content": {
              "template": "Not at all persuasive"
            },
            "typ": "Standard"
          },
          {
            "id": "6dc33d52-d2e1-431f-860b-fc7b0317cfd4",
            "order": 1,
            "label": "2",
            "content": { "template": "" },
            "typ": "Standard"
          },
          {
            "id": "b17b80b8-8069-47dd-bcf0-89c9e0c140e1",
            "order": 2,
            "label": "3",
            "content": { "template": "" },
            "typ": "Standard"
          },
          {
            "id": "4a2907d7-9dd7-4564-b83d-620cf9bb110a",
            "order": 3,
            "label": "4",
            "content": { "template": "" },
            "typ": "Standard"
          },
          {
            "id": "793e32fb-f43c-4ffe-9538-8a6ba77b128d",
            "order": 4,
            "label": "5",
            "content": { "template": "" },
            "typ": "Standard"
          },
          {
            "id": "66158acb-8f10-456b-b8f2-c960d14e10a9",
            "order": 5,
            "label": "6",
            "content": { "template": "" },
            "typ": "Standard"
          },
          {
            "id": "96651ce8-3d84-4259-898b-635a556a687a",
            "order": 6,
            "label": "7",
            "content": { "template": "Extremely persuasive" },
            "typ": "Standard"
          }
        ],
        "rows": [
          {
            "id": "fcd69aad-2bc8-46fc-be11-f7d0db7da7ac",
            "order": 0,
            "label": null,
            "content": { 
              "template": "%%0",
              "groups": {
                "0": {
                  "placeholder": "Insert message",
                  "text": null
                }
              }
             },
            "typ": "Standard"
          }
        ]
      },
      {
        "id": "8d74cbc5-acfb-4cb2-8dd5-9e6cd9f1e4f4",
        "questionTemplateId": null,
        "order": 7,
        "questionType": "RadioButtonList",
        "isRequired": true,
        "isLocked": true,
        "randomize": true,
        "requiredOptions": null,
        "title": null,
        "content": {
          "template": "Which of these messages, if any, might actually warrant less favorable access rather than favorable access?"
        },
        "description": null,
        "answerOptions": [
          {
            "id": "83b355b0-9844-4604-879e-68fde775e36c",
            "order": 0,
            "label": null,
            "content": { 
              "template": "%%0",
              "groups": {
                "0": {
                  "placeholder": "Insert message",
                  "text": null
                }
              }
             },
            "typ": "Standard"
          },
          {
            "id": "2e36c8b9-cd6c-4877-9c5e-48d325556b4c",
            "order": 1,
            "label": null,
            "content": { 
              "template": "%%0",
              "groups": {
                "0": {
                  "placeholder": "Insert message",
                  "text": null
                }
              }
             },
            "typ": "Standard"
          },
          {
            "id": "ca7aeadc-e41b-4e02-9a4a-91395c8c5cf4",
            "order": 2,
            "label": null,
            "content": { 
              "template": "%%0",
              "groups": {
                "0": {
                  "placeholder": "Insert message",
                  "text": null
                }
              }
             },
            "typ": "Standard"
          },
          {
            "id": "7cfe1398-aaac-455b-a2f1-c06acb8c2f93",
            "order": 3,
            "label": null,
            "content": { 
              "template": "%%0",
              "groups": {
                "0": {
                  "placeholder": "Insert message",
                  "text": null
                }
              }
             },
            "typ": "Standard"
          },
          {
            "id": "9b921e7e-c8eb-4059-8a6b-d6ee211e23a8",
            "order": 4,
            "label": null,
            "content": {
              "template": "None of the above"
            },
            "typ": "NA"
          }
        ]
      },
      {
        "id": "0467ab11-a23f-4eae-a3f0-35ee002749f0",
        "questionTemplateId": null,
        "order": 8,
        "questionType": "RatingList",
        "isExclusivePerRow": null,
        "isRequired": true,
        "isLocked": true,
        "requiredOptions": {
          "strategy": "OnePerRow"
        },
        "randomizeColumn": false,
        "randomizeRow": false,
        "title": null,
        "content": {
          "template": "If these messages all applied to the same product, how persuasive would this set of messages by in a P&T setting to warrant more favorable formulary access for this product?"
        },
        "description": null,
        "columns": [
          {
            "id": "c45ec79a-4ef4-454e-b18c-03ea8e300850",
            "order": 0,
            "label": "1",
            "content": {
              "template": "Not at all persuasive"
            },
            "typ": "Standard"
          },
          {
            "id": "10c9b6df-228c-4b75-a87b-5c070b5cd3b4",
            "order": 1,
            "label": "2",
            "content": { "template": "" },
            "typ": "Standard"
          },
          {
            "id": "81e9ffea-a86b-4602-af7d-34bd29e56b94",
            "order": 2,
            "label": "3",
            "content": { "template": "" },
            "typ": "Standard"
          },
          {
            "id": "3561fae7-0dbd-4da9-944d-4c4e71cb1932",
            "order": 3,
            "label": "4",
            "content": { "template": "" },
            "typ": "Standard"
          },
          {
            "id": "141c3506-a458-45a2-bc61-413ab61a3fef",
            "order": 4,
            "label": "5",
            "content": { "template": "" },
            "typ": "Standard"
          },
          {
            "id": "54d6bcaf-c76c-44d1-a6fc-b49005cd7980",
            "order": 5,
            "label": "6",
            "content": { "template": "" },
            "typ": "Standard"
          },
          {
            "id": "6a676e6f-d6b2-48ab-89b1-9f2221231947",
            "order": 6,
            "label": "7",
            "content": { "template": "Extremely persuasive" },
            "typ": "Standard"
          }
        ],
        "rows": [
          {
            "id": "460c43f7-4c8c-4420-b23d-60d535473f9b",
            "order": 0,
            "label": null,
            "content": { 
              "template": ""
             },
            "typ": "Standard"
          }
        ]
      },
      {
        "id": "c6d02f9d-dca0-4d39-bbff-4090bacaf701",
        "questionTemplateId": null,
        "order": 9,
        "questionType": "OpenEndedText",
        "isRequired": true,
        "isLocked": true,
        "title": null,
        "content": {
          "template": "After the messages you’ve reviewed in this survey, what is your main takeaway about this product?"
        },
        "description": null
      },
    ],
    "screeners": [],
    "deleted": []
  },
  {
    "id": "f6bb06a7-c517-4b07-8f59-5cf4a252dfa5",
    "title": "Brand Messaging and Access",
    "status": "Draft",
    "panel": "PhysicianSurvey",
    "description": null,
    "questions":
    [
        {
            "id": "c9505344-33fb-4afa-b950-060e2929c3e6",
            "questionTemplateId": null,
            "order": 0,
            "questionType": "RatingList",
            "isExclusivePerRow": null,
            "isRequired": true,
            "requiredOptions":
            {
                "strategy": "OnePerRow"
            },
            "isLocked": true,
            "randomizeColumn": false,
            "randomizeRow": true,
            "title": null,
            "content":
            {
                "template": "Please rate the influence that the following product attributes have on your drug treatment selection decisions for %%0",
                "groups":
                {
                    "0":
                    {
                        "placeholder": "Insert disease state",
                        "text": null
                    }
                }
            },
            "description": null,
            "columns":
            [
                {
                    "id": "3f422cc4-9197-4780-8e4f-c87f509a64a7",
                    "order": 0,                    
                    "label": "1",
                    "content":
                    {
                        "template": "Not influential"
                    },
                    "typ": "Standard"
                },
                {
                    "id": "e4aea598-d3cd-4ca5-b882-2b1e2847a544",
                    "label": "2",
                    "content":
                    {
                        "template": ""          
                    },
                    "order": 1,
                    "typ": "Standard"
                },
                {
                    "id": "8dad362d-c6c0-43f8-8e22-b979c62cc20b",
                    "label": "3",
                    "content":
                    {
                        "template": ""                        
                    },
                    "order": 2,
                    "typ": "Standard"
                },
                {
                    "id": "47d690b5-a85d-4bc9-b137-7f78cf4c9090",
                    "label": "4",
                    "content":
                    {
                        "template": ""                        
                    },
                    "order": 3,
                    "typ": "Standard"
                },
                {
                    "id": "d8a45fdc-8b45-49a5-a0af-59c7af00a6dd",
                    "label": "5",
                    "content":
                    {
                        "template": ""                        
                    },
                    "order": 4,
                    "typ": "Standard"
                },
                {
                    "id": "d2952b26-a548-454d-a507-0472b8b79fdc",
                    "label": "6",
                    "content":
                    {
                        "template": ""                        
                    },
                    "order": 5,
                    "typ": "Standard"
                },
                {
                    "id": "ee23fc6a-e971-463f-9a42-f4b1d04c66d3",
                    "label": "7",
                    "content":
                    {
                        "template": "Extremely influential"                        
                    },
                    "order": 6,
                    "typ": "Standard"
                }
            ],
            "rows":
            [
                {
                    "id": "87b27eea-d1f3-4071-8ee1-73b06c9372fd",
                    "label": null,
                    "content":
                    {
                        "template": "Efficacy"                        
                    },
                    "order": 0,
                    "typ": "Standard"
                },
                {
                    "id": "88df8877-785a-44bb-b70d-2dc0bb950934",
                    "label": null,
                    "content":
                    {
                        "template": "Safety profile (i.e., side effects and adverse events)"                        
                    },
                    "order": 1,
                    "typ": "Standard"
                },
                {
                    "id": "0f40884f-a753-401b-b6c8-d0f3a6df98cf",
                    "label": null,
                    "content":
                    {
                        "template": "Route of administration (i.e., orals vs. self-injected vs. office-administered)"                        
                    },
                    "order": 2,
                    "typ": "Standard"
                },
                {
                    "id": "df4d6591-0734-46fc-bb90-df3fd75e7e69",
                    "label": null,
                    "content":
                    {
                        "template": "Patient out-of-pocket costs"                        
                    },
                    "order": 3,
                    "typ": "Standard"
                },
                {
                    "id": "47d2e9ce-b766-4047-b919-e99372b3193e",
                    "label": null,
                    "content":
                    {
                        "template": "Insurance coverage requirements"                        
                    },
                    "order": 4,
                    "typ": "Standard"
                }
            ]
        },
        {
            "id": "583e3c21-c536-4930-a20e-b4f9e9857b73",
            "questionTemplateId": null,
            "order": 1,
            "questionType": "CheckboxList",
            "isRequired": true,
            "requiredOptions": null,
            "isLocked": true,
            "randomize": true,
            "title": null,
            "content":
            {
                "template": "Please identify the top three external sources that have the most significant influence on your preferred drug treatment for %%0.",
                "groups":
                {
                    "0":
                    {
                        "placeholder": "Insert disease state",
                        "text": null
                    }
                }
            },
            "description": null,
            "answerOptions":
            [
                {
                    "id": "8fafa01a-a2ad-4a96-aee9-09df740aee66",
                    "label": null,
                    "content":
                    {
                        "template": "Perspectives from leading specialists local to your organization (not national KOLs)"                        
                    },
                    "order": 0,
                    "typ": "Standard"
                },
                {
                    "id": "c07863a8-0010-4e24-a733-c8d70f2e7935",
                    "label": null,
                    "content":
                    {
                        "template": "Clinical trial data provided by pharmaceutical companies"                      
                    },
                    "order": 1,
                    "typ": "Standard"
                },
                {
                    "id": "dd823bac-d15e-4a83-999a-da6a183ef80e",
                    "label": null,
                    "content":
                    {
                        "template": "Quality organizations and metrics (e.g., HEDIS)"                        
                    },
                    "order": 2,
                    "typ": "Standard"
                },
                {
                    "id": "dfb2eef5-ad82-492e-b2e8-a1e9ed4752fe",
                    "label": null,
                    "content":
                    {
                        "template": "ICER Value Assessment Framework"                        
                    },
                    "order": 3,
                    "typ": "Standard"
                },
                {
                    "id": "1401f915-aea8-4d9e-a78b-2d93abde0f90",
                    "label": null,
                    "content":
                    {
                        "template": "Other: [Specify]"
                    },
                    "order": 4,
                    "typ": "ParticipantDefined"
                }
            ]
        },
        {
            "id": "1b677ebc-e0ad-4afc-a325-4847e54ca935",
            "questionTemplateId": null,
            "order": 2,
            "questionType": "RatingList",
            "isExclusivePerRow": null,
            "isRequired": true,
            "requiredOptions":
            {
                "strategy": "OnePerRow"
            },
            "isLocked": true,
            "randomizeColumn": false,
            "randomizeRow": true,
            "title": null,
            "content":
            {
                "template": "Please rate each brand based on its efficacy (e.g., delaying disease progression, improving signs and symptoms)"                
            },
            "description": null,
            "columns":
            [
                {
                    "id": "eb45bd92-2aca-41dc-abdc-59bb72c5de67",
                    "label": "1",
                    "content":
                    {
                        "template": "Somewhat effective"                        
                    },
                    "order": 0,
                    "typ": "Standard"
                },
                {
                    "id": "4cbd6e58-0560-4154-a6a4-8e886355a715",
                    "label": "2",
                    "content":
                    {
                        "template": ""                        
                    },
                    "order": 1,
                    "typ": "Standard"
                },
                {
                    "id": "0e3e2d76-bc31-4bd1-ae82-ce960cf772ce",
                    "label": "3",
                    "content":
                    {
                        "template": ""                        
                    },
                    "order": 2,
                    "typ": "Standard"
                },
                {
                    "id": "45a97b1e-e8b2-41eb-90c9-e0caafc77896",
                    "label": "4",
                    "content":
                    {
                        "template": ""                        
                    },
                    "order": 3,
                    "typ": "Standard"
                },
                {
                    "id": "dec65864-aa84-4235-bcb4-9b3274ecec33",
                    "label": "5",
                    "content":
                    {
                        "template": ""                        
                    },
                    "order": 4,
                    "typ": "Standard"
                },
                {
                    "id": "79af3251-f0ad-48b8-be6d-74064a0910f5",
                    "label": "6",
                    "content":
                    {
                        "template": ""                        
                    },
                    "order": 5,
                    "typ": "Standard"
                },
                {
                    "id": "ff19b91a-2429-471f-a7c3-3dc368f9d2c6",
                    "label": "7",
                    "content":
                    {
                        "template": "Extremely effective"                        
                    },
                    "order": 6,
                    "typ": "Standard"
                }
            ],
            "rows":
            [
                {
                    "id": "402f7234-0ef2-4abb-a5f7-aa29a36486c2",
                    "label": null,
                    "content":
                    {
                        "template": "%%0",
                        "groups":
                        {
                            "0":
                            {
                                "placeholder": "Insert product",
                                "text": null
                            }
                        }
                    },
                    "order": 0,
                    "typ": "Standard"
                },
                {
                    "id": "9c809057-f476-49d3-b601-b3c89f6ef015",
                    "label": null,
                    "content":
                    {
                        "template": "%%0",
                        "groups":
                        {
                            "0":
                            {
                                "placeholder": "Insert product",
                                "text": null
                            }
                        }
                    },
                    "order": 1,
                    "typ": "Standard"
                },
                {
                    "id": "a6e2e8ed-230f-4b7f-98f3-fa467ecff3d2",
                    "label": null,
                    "content":
                    {
                        "template": "%%0",
                        "groups":
                        {
                            "0":
                            {
                                "placeholder": "Insert product",
                                "text": null
                            }
                        }
                    },
                    "order": 2,
                    "typ": "Standard"
                },
                {
                    "id": "e7815929-37c3-4232-b1cb-28aa8d4bda15",
                    "label": null,
                    "content":
                    {
                        "template": "%%0",
                        "groups":
                        {
                            "0":
                            {
                                "placeholder": "Insert product",
                                "text": null
                            }
                        }
                    },
                    "order": 3,
                    "typ": "Standard"
                },
                {
                    "id": "6dd59e8c-b4ad-4e13-934c-978b4c8ee5ee",
                    "label": null,
                    "content":
                    {
                        "template": "%%0",
                        "groups":
                        {
                            "0":
                            {
                                "placeholder": "Insert product",
                                "text": null
                            }
                        }
                    },
                    "order": 4,
                    "typ": "Standard"
                }
            ]
        },
        {
            "id": "a7ba4045-7ade-4bc4-8b24-e6273097d4fd",
            "questionTemplateId": null,
            "order": 3,
            "questionType": "RatingList",
            "isExclusivePerRow": null,
            "isRequired": true,
            "requiredOptions":
            {
                "strategy": "OnePerRow"
            },
            "isLocked": true,
            "randomizeColumn": false,
            "randomizeRow": true,
            "title": null,
            "content":
            {
                "template": "Please rate each brand based on its safety profile (i.e., risk of side-effects and adverse events)"                
            },
            "description": null,
            "columns":
            [
                {
                    "id": "b9744ee1-51f6-4e98-8700-05554d23d2ae",
                    "label": "1",
                    "content":
                    {
                        "template": "Very unfavorable safety profile"                        
                    },
                    "order": 0,
                    "typ": "Standard"
                },
                {
                    "id": "9f4a9912-fe98-4fb4-a668-421bf244ac9b",
                    "label": "2",
                    "content":
                    {
                        "template": ""                        
                    },
                    "order": 1,
                    "typ": "Standard"
                },
                {
                    "id": "1f7a768b-98d4-4b63-bd56-d87dced10d3e",
                    "label": "3",
                    "content":
                    {
                        "template": ""
                        
                    },
                    "order": 2,
                    "typ": "Standard"
                },
                {
                    "id": "c5f0fb8a-36b8-47f1-8efc-ecfb04bc9932",
                    "label": "4",
                    "content":
                    {
                        "template": ""                      
                    },
                    "order": 3,
                    "typ": "Standard"
                },
                {
                    "id": "10f1e1b4-2243-4dd1-a309-05325ba52ad7",
                    "label": "5",
                    "content":
                    {
                        "template": ""                        
                    },
                    "order": 4,
                    "typ": "Standard"
                },
                {
                    "id": "b4ed413b-40cc-403b-9290-2ef00facf4d9",
                    "label": "6",
                    "content":
                    {
                        "template": ""                        
                    },
                    "order": 5,
                    "typ": "Standard"
                },
                {
                    "id": "57edbc76-fe7e-477d-b64c-3b227d258aaa",
                    "label": "7",
                    "content":
                    {
                        "template": "Very favorable safety profile"                        
                    },
                    "order": 6,
                    "typ": "Standard"
                }
            ],
            "rows":
            [
                {
                    "id": "9c67c66b-0f82-4439-ab18-89c5175a8e72",
                    "label": null,
                    "content":
                    {
                        "template": "%%0",
                        "groups":
                        {
                            "0":
                            {
                                "placeholder": "Insert product",
                                "text": null
                            }
                        }
                    },
                    "order": 0,
                    "typ": "Standard"
                },
                {
                    "id": "7e5ae913-a9f2-4955-9f7b-67f7cc07f292",
                    "label": null,
                    "content":
                    {
                        "template": "%%0",
                        "groups":
                        {
                            "0":
                            {
                                "placeholder": "Insert product",
                                "text": null
                            }
                        }
                    },
                    "order": 1,
                    "typ": "Standard"
                },
                {
                    "id": "df72dcb1-7083-463f-8f8a-9e8f4fdfbcd8",
                    "label": null,
                    "content":
                    {
                        "template": "%%0",
                        "groups":
                        {
                            "0":
                            {
                                "placeholder": "Insert product",
                                "text": null
                            }
                        }
                    },
                    "order": 2,
                    "typ": "Standard"
                },
                {
                    "id": "247935da-3aa1-4422-bd5c-d3d52d2cbf43",
                    "label": null,
                    "content":
                    {
                        "template": "%%0",
                        "groups":
                        {
                            "0":
                            {
                                "placeholder": "Insert product",
                                "text": null
                            }
                        }
                    },
                    "order": 3,
                    "typ": "Standard"
                },
                {
                    "id": "477ce352-be02-45c9-9b34-38265849dc4a",
                    "label": null,
                    "content":
                    {
                        "template": "%%0",
                        "groups":
                        {
                            "0":
                            {
                                "placeholder": "Insert product",
                                "text": null
                            }
                        }
                    },
                    "order": 4,
                    "typ": "Standard"
                }
            ]
        },
        {
            "id": "387282be-a608-4dca-971e-2e4412bbb563",
            "questionTemplateId": null,
            "order": 4,
            "questionType": "RatingList",
            "isExclusivePerRow": null,
            "isRequired": true,
            "requiredOptions":
            {
                "strategy": "OnePerRow"
            },
            "isLocked": true,
            "randomizeColumn": false,
            "randomizeRow": true,
            "title": null,
            "content":
            {
                "template": "Please rate each brand based on its impact on the total cost of care for treating %%0.",
                "groups":
                {
                    "0":
                    {
                        "placeholder": "Insert disease state",
                        "text":null
                    }
                }
            },
            "description": null,
            "columns":
            [
                {
                    "id": "0689c2f7-46c4-4b76-830e-d9e59a335124",
                    "label": "1",
                    "content":
                    {
                        "template": "Extremely high net pricing (not favorable)"                        
                    },
                    "order": 0,
                    "typ": "Standard"
                },
                {
                    "id": "3eb6e73c-1686-463d-a0e4-1dad376e2fee",
                    "label": "2",
                    "content":
                    {
                        "template": ""                     
                    },
                    "order": 1,
                    "typ": "Standard"
                },
                {
                    "id": "5b033dbf-a221-40e2-afa2-aa1412ab572d",
                    "label": "3",
                    "content":
                    {
                        "template": ""
                    },
                    "order": 2,
                    "typ": "Standard"
                },
                {
                    "id": "dde3b879-3591-433a-b9bb-ffe6bdb71a02",
                    "label": "4",
                    "content":
                    {
                        "template": ""
                    },
                    "order": 3,
                    "typ": "Standard"
                },
                {
                    "id": "f137c788-4a78-4677-979d-902bf35fd67e",
                    "label": "5",
                    "content":
                    {
                        "template": ""
                    },
                    "order": 4,
                    "typ": "Standard"
                },
                {
                    "id": "36471e05-78b4-42d7-be5c-06cc33c8869a",
                    "label": "6",
                    "content":
                    {
                        "template": ""
                    },
                    "order": 5,
                    "typ": "Standard"
                },
                {
                    "id": "136a68c5-e4d1-415c-923d-cdd85647eedf",
                    "label": "7",
                    "content":
                    {
                        "template": "Extremely low net pricing (highly favorable)"
                    },
                    "order": 6,
                    "typ": "Standard"
                }
            ],
            "rows":
            [
                {
                    "id": "e37cf881-8fcf-469d-a98f-fc74b5e112c3",
                    "label": null,
                    "content":
                    {
                        "template": "%%0",
                        "groups":
                        {
                            "0":
                            {
                                "placeholder": "Insert product",
                                "text": null
                            }
                        }
                    },
                    "order": 0,
                    "typ": "Standard"
                },
                {
                    "id": "366143b4-63ea-4296-85a8-f7c4f69f5c4c",
                    "label": null,
                    "content":
                    {
                        "template": "%%0",
                        "groups":
                        {
                            "0":
                            {
                                "placeholder": "Insert product",
                                "text": null
                            }
                        }
                    },
                    "order": 1,
                    "typ": "Standard"
                },
                {
                    "id": "50590ddd-5680-4256-a201-b532aaa1470f",
                    "label": null,
                    "content":
                    {
                        "template": "%%0",
                        "groups":
                        {
                            "0":
                            {
                                "placeholder": "Insert product",
                                "text": null
                            }
                        }
                    },
                    "order": 2,
                    "typ": "Standard"
                },
                {
                    "id": "40e5357c-d97e-4d01-aed6-011c50c08dce",
                    "label": null,
                    "content":
                    {
                        "template": "%%0",
                        "groups":
                        {
                            "0":
                            {
                                "placeholder": "Insert product",
                                "text": null
                            }
                        }
                    },
                    "order": 3,
                    "typ": "Standard"
                },
                {
                    "id": "34d6679d-7915-426b-b484-a004b356c39f",
                    "label": null,
                    "content":
                    {
                        "template": "%%0",
                        "groups":
                        {
                            "0":
                            {
                                "placeholder": "Insert product",
                                "text": null
                            }
                        }
                    },
                    "order": 4,
                    "typ": "Standard"
                }
            ]
        },
        {
            "id": "c88af777-0301-4e2d-8a5a-b25d7b7118c8",
            "questionTemplateId": null,
            "order": 5,
            "questionType": "CheckboxGrid",
            "isExclusivePerRow": false,
            "isRequired": true,
            "requiredOptions":
            {
                "strategy": "AtLeastOnePerColumn"
            },
            "isLocked": true,
            "randomizeColumn": true,
            "randomizeRow": true,
            "title": null,
            "content":
            {
                "template": "Thinking of the requirements implemented by the most common third-party insurance plan in your area, which of the following management tactic(s) does the plan enforce on each brand?"
            },
            "description": null,
            "columns":
            [
                {
                    "id": "7dabed85-148f-44f5-8e4a-d29b27ab46b8",
                    "label": null,
                    "content":
                    {
                        "template": "%%0",
                        "groups":
                        {
                            "0":
                            {
                                "placeholder": "Insert product",
                                "text": null
                            }
                        }
                    },
                    "order": 0,
                    "typ": "Standard"
                },
                {
                    "id": "a68d30a9-f6ea-448c-b642-af07a3807325",
                    "label": null,
                    "content":
                    {
                        "template": "%%0",
                        "groups":
                        {
                            "0":
                            {
                                "placeholder": "Insert product",
                                "text": null
                            }
                        }
                    },
                    "order": 1,
                    "typ": "Standard"
                },
                {
                    "id": "b78c1452-36ad-4126-b210-b4f1630e73d8",
                    "label": null,
                    "content":
                    {
                        "template": "%%0",
                        "groups":
                        {
                            "0":
                            {
                                "placeholder": "Insert product",
                                "text": null
                            }
                        }
                    },
                    "order": 2,
                    "typ": "Standard"
                },
                {
                    "id": "74a79386-b09a-45ce-a3c4-8bbb690b605f",
                    "label": null,
                    "content":
                    {
                        "template": "%%0",
                        "groups":
                        {
                            "0":
                            {
                                "placeholder": "Insert product",
                                "text": null
                            }
                        }
                    },
                    "order": 3,
                    "typ": "Standard"
                },
                {
                    "id": "346120fe-dc70-4f1a-b274-7193648bd386",
                    "label": null,
                    "content":
                    {
                        "template": "%%0",
                        "groups":
                        {
                            "0":
                            {
                                "placeholder": "Insert product",
                                "text": null
                            }
                        }
                    },
                    "order": 4,
                    "typ": "Standard"
                }
            ],
            "rows":
            [
                {
                    "id": "4fa59049-4941-4574-a475-f4df63fa55d8",
                    "label": null,
                    "content":
                    {
                        "template": "Step edit requirements"
                    },
                    "order": 0,
                    "typ": "Standard"
                },
                {
                    "id": "ed287fd4-140c-4248-ba8a-df69247a61a8",
                    "label": null,
                    "content":
                    {
                        "template": "Prior authorization requirements"
                    },
                    "order": 1,
                    "typ": "Standard"
                },
                {
                    "id": "67ed3f99-8750-4c6b-b0c2-be48ba5f1710",
                    "label": null,
                    "content":
                    {
                        "template": "Preferred Drug Lists (PDLs)"
                    },
                    "order": 2,
                    "typ": "Standard"
                },
                {
                    "id": "ac074985-604b-40b2-baa3-448025296594",
                    "label": null,
                    "content":
                    {
                        "template": "Preferred site of care policies"
                    },
                    "order": 3,
                    "typ": "Standard"
                },
                {
                    "id": "5bffecd8-e5e6-4b27-9aeb-04283a76a6bd",
                    "label": null,
                    "content":
                    {
                        "template": "Other: [Specify]"
                    },
                    "order": 4,
                    "typ": "ParticipantDefined"
                }                
            ]
        },
        {
            "id": "54aea447-e8e1-4f13-84c7-8d262e5acdae",
            "questionTemplateId": null,
            "order": 6,
            "questionType": "RadioButtonGrid",
            "isExclusivePerRow": false,
            "isRequired": true,
            "requiredOptions":
            {
                "strategy": "OnePerColumn"
            },
            "isLocked": true,
            "randomizeColumn": true,
            "randomizeRow": false,
            "title": null,
            "content":
            {
                "template": "Select the narrative below that best describes your perception of the preferred formulary status for each brand."
            },
            "description": null,
            "columns":
            [
                {
                    "id": "1ea9de39-3810-4e6e-925d-33db12311c8c",
                    "label": null,
                    "content":
                    {
                        "template": "%%0",
                        "groups":
                        {
                            "0":
                            {
                                "placeholder": "Insert product",
                                "text": null
                            }
                        }
                    },
                    "order": 0,
                    "typ": "Standard"
                },
                {
                    "id": "6d1ce6f9-add7-46ff-855c-7d66f7e31fe5",
                    "label": null,
                    "content":
                    {
                        "template": "%%0",
                        "groups":
                        {
                            "0":
                            {
                                "placeholder": "Insert product",
                                "text": null
                            }
                        }
                    },
                    "order": 1,
                    "typ": "Standard"
                },
                {
                    "id": "ba6e8979-9be6-4e37-a36c-542599583c9b",
                    "label": null,
                    "content":
                    {
                        "template": "%%0",
                        "groups":
                        {
                            "0":
                            {
                                "placeholder": "Insert product",
                                "text": null
                            }
                        }
                    },
                    "order": 2,
                    "typ": "Standard"
                },
                {
                    "id": "87565f58-ef55-4418-90bb-44e21168f9f4",
                    "label": null,
                    "content":
                    {
                        "template": "%%0",
                        "groups":
                        {
                            "0":
                            {
                                "placeholder": "Insert product",
                                "text": null
                            }
                        }
                    },
                    "order": 3,
                    "typ": "Standard"
                },
                {
                    "id": "c2a362cd-96b6-4b8e-9a38-58b55072f347",
                    "label": null,
                    "content":
                    {
                        "template": "%%0",
                        "groups":
                        {
                            "0":
                            {
                                "placeholder": "Insert product",
                                "text": null
                            }
                        }
                    },
                    "order": 4,
                    "typ": "Standard"
                }
            ],
            "rows":
            [
                {
                    "id": "e964277f-ac98-41ba-a2e3-e1c03885afb2",
                    "label": null,
                    "content":
                    {
                        "template": "Has preferred formulary status, so I am more willing to prescribe"                        
                    },
                    "order": 0,
                    "typ": "Standard"
                },
                {
                    "id": "0642b294-b8ae-4c40-a9fc-31112e4a6dc2",
                    "label": null,
                    "content":
                    {
                        "template": "Formulary status does not impact prescribing decisions"                        
                    },
                    "order": 1,
                    "typ": "Standard"
                },
                {
                    "id": "0294cf64-9838-41f9-beb7-3e5c3308ad6e",
                    "label": null,
                    "content":
                    {
                        "template": "Does NOT have preferred formulary status, so I am less willing to prescribe"                        
                    },
                    "order": 2,
                    "typ": "Standard"
                }
            ]
        },
        {
            "id": "a3d0148e-56ac-4b16-9f81-0eb701dddb58",
            "questionTemplateId": null,
            "order": 7,
            "questionType": "RadioButtonGrid",
            "isExclusivePerRow": false,
            "isRequired": true,
            "requiredOptions":
            {
                "strategy": "OnePerColumn"
            },
            "isLocked": true,
            "randomizeColumn": false,
            "randomizeRow": true,
            "title": null,
            "content":
            {
                "template": "Considering cost-sharing differentials, PAs, protocols, or other management tactics, what is the treatment order recommended by your system or medical group for the following brands? \n\nDesignate each regimen as first-line, second-line, third-line therapy and so on for patients."           
            },
            "description": null,
            "rows":
            [
                {
                    "id": "40db80b1-95d3-4589-bf2c-6001a531547b",
                    "label": null,
                    "content":
                    {
                        "template": "1st-line"
                    },
                    "order": 0,
                    "typ": "Standard"
                },
                {
                    "id": "8401239a-812d-4b3b-83cc-3751e0c3b4e3",
                    "label": null,
                    "content":
                    {
                        "template": "2nd-line"
                    },
                    "order": 1,
                    "typ": "Standard"
                },
                {
                    "id": "53cbcfb8-58b9-4a6e-9eb4-12d628e8ca28",
                    "label": null,
                    "content":
                    {
                        "template": "3rd-line"

                    },
                    "order": 2,
                    "typ": "Standard"
                },
                {
                    "id": "5c66dc6a-0402-44c6-84c2-9064b24b8f60",
                    "label": null,
                    "content":
                    {
                        "template": "4th-line or later"
                    },
                    "order": 3,
                    "typ": "Standard"
                },
                {
                    "id": "da8608a5-0b55-4ad6-952f-9ce0ff48d78c",
                    "label": null,
                    "content":
                    {
                        "template": "Class not listed by specific line of therapy in system’s or medical group’s criteria at this time."                        
                    },
                    "order": 4,
                    "typ": "Standard"
                }
            ],
            "columns":
            [
                {
                    "id": "4a0994f1-87ac-404a-bc69-2200cb0e2ee6",
                    "label": null,
                    "content":
                    {
                        "template": "%%0",
                        "groups":
                        {
                            "0":
                            {
                                "placeholder": "Insert product",
                                "text": null
                            }
                        }
                    },
                    "order": 0,
                    "typ": "Standard"
                },
                {
                    "id": "f16da267-415e-41c9-8f66-575981e5912b",
                    "label": null,
                    "content":
                    {
                        "template": "%%0",
                        "groups":
                        {
                            "0":
                            {
                                "placeholder": "Insert product",
                                "text": null
                            }
                        }
                    },
                    "order": 1,
                    "typ": "Standard"
                },
                {
                    "id": "6e03cc2b-5f2f-4ceb-95bb-c067447bccfa",
                    "label": null,
                    "content":
                    {
                        "template": "%%0",
                        "groups":
                        {
                            "0":
                            {
                                "placeholder": "Insert product",
                                "text": null
                            }
                        }
                    },
                    "order": 2,
                    "typ": "Standard"
                },
                {
                    "id": "5d44bf2f-f693-4ec5-8b25-afe5c19ffff3",
                    "label": null,
                    "content":
                    {
                        "template": "%%0",
                        "groups":
                        {
                            "0":
                            {
                                "placeholder": "Insert product",
                                "text": null
                            }
                        }
                    },
                    "order": 3,
                    "typ": "Standard"
                },
                {
                    "id": "f08ddce1-ec0d-4460-8b2b-6430254fa55d",
                    "label": null,
                    "content":
                    {
                        "template": "%%0",
                        "groups":
                        {
                            "0":
                            {
                                "placeholder": "Insert product",
                                "text": null
                            }
                        }
                    },
                    "order": 4,
                    "typ": "Standard"
                }
            ]
        },
        {
            "id": "1e538431-3187-4401-8ef9-5ed2f9f400f2",
            "questionTemplateId": null,
            "order": 8,
            "questionType": "RatingList",
            "isExclusivePerRow": null,
            "isRequired": true,
            "requiredOptions":
            {
                "strategy": "OnePerRow"
            },
            "isLocked": true,
            "randomizeColumn": false,
            "randomizeRow": false,
            "title": null,
            "content":
            {
                "template": "Please rate the level of impact each biopharma company’s patient copay cards and other copay assistance have on the patient’s ability to afford each brands."                
            },
            "description": null,
            "columns":
            [
                {
                    "id": "b86c3b12-ae7e-4591-9cb8-d7a20b4b9f91",
                    "label": "1",
                    "content":
                    {
                        "template": "No impact"
                    },
                    "order": 0,
                    "typ": "Standard"
                },
                {
                    "id": "33d7aa9f-7cba-4752-8aef-c580fde651de",
                    "label": "2",
                    "content":
                    {
                        "template": ""
                    },
                    "order": 1,
                    "typ": "Standard"
                },
                {
                    "id": "3a26ef5a-db32-486c-a284-854937b2a520",
                    "label": "3",
                    "content":
                    {
                        "template": ""
                    },
                    "order": 2,
                    "typ": "Standard"
                },
                {
                    "id": "68377b37-d392-46c5-b436-ebc36c3ced67",
                    "label": "4",
                    "content":
                    {
                        "template": ""
                    },
                    "order": 3,
                    "typ": "Standard"
                },
                {
                    "id": "1c7f9af2-32e5-42f1-9776-0308593b6d23",
                    "label": "5",
                    "content":
                    {
                        "template": ""
                    },
                    "order": 4,
                    "typ": "Standard"
                },
                {
                    "id": "4af9a9ff-ce6f-4eab-8cf3-c7ba6b77928a",
                    "label": "6",
                    "content":
                    {
                        "template": ""
                    },
                    "order": 5,
                    "typ": "Standard"
                },
                {
                    "id": "00cd540f-e7ed-4110-8b24-69ecd0c252fa",
                    "label": "7",
                    "content":
                    {
                        "template": "Very high impact"                        
                    },
                    "order": 6,
                    "typ": "Standard"
                }
            ],
            "rows":
            [
                {
                    "id": "b1a079f0-975d-416e-8069-15fcdf8efb29",
                    "label": null,
                    "content":
                    {
                        "template": "%%0",
                        "groups":
                        {
                            "0":
                            {
                                "placeholder": "Insert product",
                                "text": null
                            }
                        }
                    },
                    "order": 0,
                    "typ": "Standard"
                },
                {
                    "id": "c2b0fcd1-1246-4ca7-a33d-8bf8ac9ba115",
                    "label": null,
                    "content":
                    {
                        "template": "%%0",
                        "groups":
                        {
                            "0":
                            {
                                "placeholder": "Insert product",
                                "text": null
                            }
                        }
                    },
                    "order": 1,
                    "typ": "Standard"
                },
                {
                    "id": "2ce00bf7-0db0-4c4d-9b58-59e59eba07a3",
                    "label": null,
                    "content":
                    {
                        "template": "%%0",
                        "groups":
                        {
                            "0":
                            {
                                "placeholder": "Insert product",
                                "text": null
                            }
                        }
                    },
                    "order": 2,
                    "typ": "Standard"
                },
                {
                    "id": "f161b285-f9ce-43da-8c31-9a0a42bcca62",
                    "label": null,
                    "content":
                    {
                        "template": "%%0",
                        "groups":
                        {
                            "0":
                            {
                                "placeholder": "Insert product",
                                "text": null
                            }
                        }
                    },
                    "order": 3,
                    "typ": "Standard"
                },
                {
                    "id": "e69c69a0-79ab-4207-a010-e285283de4e4",
                    "label": null,
                    "content":
                    {
                        "template": "%%0",
                        "groups":
                        {
                            "0":
                            {
                                "placeholder": "Insert product",
                                "text": null
                            }
                        }
                    },
                    "order": 4,
                    "typ": "Standard"
                }
            ]
        },
        {
            "id": "215ab2b2-c2cf-432c-9e5f-a86eae5955e5",
            "questionTemplateId": null,
            "order": 9,
            "questionType": "RatingList",
            "isExclusivePerRow": null,
            "isRequired": true,
            "requiredOptions":
            {
                "strategy": "OnePerRow"
            },
            "isLocked": true,
            "randomizeColumn": false,
            "randomizeRow": false,
            "title": null,
            "content":
            {
                "template": "Please rate the level of impact patient copay cards and other copay assistance has on your decision to prescribe each brand."
            },
            "description": null,
            "columns":
            [
                {
                    "id": "0f782de1-4ff1-43fa-aa3b-9bb4a1b2fa78",
                    "label": "1",
                    "content":
                    {
                        "template": "No impact"
                    },
                    "order": 0,
                    "typ": "Standard"
                },
                {
                    "id": "fd1b07a0-0428-4068-bce6-64bcdd39406f",
                    "label": "2",
                    "content": {
                      "template": ""
                    },
                    "order": 1,
                    "typ": "Standard"
                },
                {
                    "id": "450f3dac-80c8-4440-9c8f-be2e2e9ee13a",
                    "label": "3",
                    "content": {
                      "template": ""
                    },
                    "order": 2,
                    "typ": "Standard"
                },
                {
                    "id": "35c93753-cac1-4ddd-aa97-1029afcbc653",
                    "label": "4",
                    "content": {
                      "template": ""
                    },
                    "order": 3,
                    "typ": "Standard"
                },
                {
                    "id": "af01f4e3-e2bd-4828-9b42-e416ba60b967",
                    "label": "5",
                    "content": {
                      "template": ""
                    },
                    "order": 4,
                    "typ": "Standard"
                },
                {
                    "id": "62180496-01ce-4293-a3e2-66aa850b40ed",
                    "label": "6",
                    "content": {
                      "template": ""
                    },
                    "order": 5,
                    "typ": "Standard"
                },
                {
                    "id": "26cd2e6a-3ce5-4da7-b527-7f7f05eab354",
                    "label": "7",
                    "content":
                    {
                        "template": "Very high impact"                        
                    },
                    "order": 6,
                    "typ": "Standard"
                }
            ],
            "rows":
            [
                {
                    "id": "860aafc5-4532-4993-9599-8a0f99bbd0a3",
                    "label": null,
                    "content":
                    {
                        "template": "%%0",
                        "groups":
                        {
                            "0":
                            {
                                "placeholder": "Insert product",
                                "text": null
                            }
                        }
                    },
                    "order": 0,
                    "typ": "Standard"
                },
                {
                    "id": "7da2bee6-3f86-43ac-afa2-455d52a28a89",
                    "label": null,
                    "content":
                    {
                        "template": "%%0",
                        "groups":
                        {
                            "0":
                            {
                              "placeholder": "Insert product",
                              "text": null
                          }
                        }
                    },
                    "order": 1,
                    "typ": "Standard"
                },
                {
                    "id": "b773f72c-90b1-468b-a26f-4c10a41fc753",
                    "label": null,
                    "content":
                    {
                        "template": "%%0",
                        "groups":
                        {
                            "0":
                            {
                              "placeholder": "Insert product",
                              "text": null
                          }
                        }
                    },
                    "order": 2,
                    "typ": "Standard"
                },
                {
                    "id": "552fbe8d-1a59-4665-a5ad-75f897c93cc8",
                    "label": null,
                    "content":
                    {
                        "template": "%%0",
                        "groups":
                        {
                            "0":
                            {
                              "placeholder": "Insert product",
                              "text": null
                            }
                        }
                    },
                    "order": 3,
                    "typ": "Standard"
                },
                {
                    "id": "ea567217-8db5-4688-8ba2-f25dc3093e16",
                    "label": null,
                    "content":
                    {
                        "template": "%%0",
                        "groups":
                        {
                            "0":
                            {
                              "placeholder": "Insert product",
                              "text": null
                            }
                        }
                    },
                    "order": 4,
                    "typ": "Standard"
                }
            ]
        }
    ],
    "screeners":
    [],
    "deleted":
    [],
    "sourceTitle": null,
    "createdAt": "2021-11-29T14:25:39.881Z",
    "updatedAt": "2021-11-29T14:25:39.881Z"
  },
  {
    "id": "bb693f1f-6522-403f-93df-7e29670b9ac4",
    "title": "Salesforce Effectiveness",
    "sourceTitle": null,
    "panel": "PhysicianSurvey",
    "status": "Draft",
    "description": null,
    "questions": [
      {
        "id": "310285e5-ca81-41d8-96ba-b05b0a5f2d9a",
        "questionTemplateId": null,
        "order": 0,
        "questionType": "RadioButtonGrid",
        "isExclusivePerRow": false,
        "isRequired": true,
        "isLocked": true,
        "requiredOptions": {
          "strategy": "OnePerColumn"
        },
        "randomizeColumn": false,
        "randomizeRow": true,
        "title": null,
        "content": {
          "template": "Please indicate, on average, how often you meet with a biopharmaceutical sales representative for each of the following products."
        },
        "description": null,  
        "rows": [
          {
            "id": "f08b2754-b5c4-4624-8d0b-a84e9df57b79",
            "order": 0,
            "label": null,
            "content": {
              "template": "Once per week"
            },
            "typ": "Standard"
          },
          {
            "id": "917a8a33-9237-4b35-94df-30933c537c40",
            "order": 1,
            "label": null,
            "content": {
              "template": "Once per month"
            },
            "typ": "Standard"
          },          
          {
            "id": "ec26e13a-e163-4071-ba33-33ed22eb98d1",
            "order": 2,
            "label": null,
            "content": {
              "template": "Once every quarter"
            },
            "typ": "Standard"
          },          
          {
            "id": "528eda8e-05c8-4639-8c13-db211acca942",
            "order": 3,
            "label": null,
            "content": {
              "template": "Once or twice per year"
            },
            "typ": "Standard"
          },          
          {
            "id": "e6192d81-ec23-46b1-9515-bb49580bc123",
            "order": 4,
            "label": null,
            "content": {
              "template": "Not in the past 12 months"
            },
            "typ": "Standard"
          }          
        ],
        "columns": [
          {
            "id": "e7d584da-2bd4-46f7-8f3b-683e2f5c9350",
            "order": 0,
            "label": null,
            "content": {
              "template": "%%0",
              "groups": {
                "0": {
                  "placeholder": "Product (Company)",
                  "text": null
                }
              }
            },
            "typ": "Standard"            
          },
          {
            "id": "9b0c5470-7c4c-4a77-8772-58b1fb25ebb8",
            "order": 1,
            "label": null,
            "content": {
              "template": "%%0",
              "groups": {
                "0": {
                  "placeholder": "Product (Company)",
                  "text": null
                }
              }
            },
            "typ": "Standard"            
          },
          {
            "id": "861228b8-8edd-4f2c-b9a1-6403af3db08e",
            "order": 2,
            "label": null,
            "content": {
              "template": "%%0",
              "groups": {
                "0": {
                  "placeholder": "Product (Company)",
                  "text": null
                }
              }
            },
            "typ": "Standard"            
          },  
          {
            "id": "448d8530-5a04-4f2f-8dd8-5da95b7b7ca6",
            "order": 3,
            "label": null,
            "content": {
              "template": "%%0",
              "groups": {
                "0": {
                  "placeholder": "Product (Company)",
                  "text": null
                }
              }
            },
            "typ": "Standard"            
          },   
          {
            "id": "2af88b54-bf5d-40d0-87a0-b15bf23b73fe",
            "order": 4,
            "label": null,
            "content": {
              "template": "%%0",
              "groups": {
                "0": {
                  "placeholder": "Product (Company)",
                  "text": null
                }
              }
            },
            "typ": "Standard"            
          }                                         
        ]      
      },
      {
        "id": "a57cb4c6-6cae-43e5-9cc9-2fbf07a4a2d5",
        "questionTemplateId": null,
        "order": 1,
        "questionType": "RatingList",
        "isExclusivePerRow": null,
        "isRequired": true,
        "isLocked": true,
        "requiredOptions": {
          "strategy": "OnePerRow"
        },
        "randomizeColumn": false,
        "randomizeRow": true,
        "title": null,
        "content": {
          "template": "Please rate your preference for policies that restrict access of pharmaceutical sales representatives."
        },
        "description": null,
        "columns": [
          {
            "id": "8a2e1cbc-f871-49a7-9760-3c6a11118ca9",
            "order": 0,
            "label": "1",
            "content": {
              "template": "Unnecessary"
            },
            "typ": "Standard"
          },
          {
            "id": "51c86ae1-78fa-4bac-8e1a-0bce47e1f1fa",
            "order": 1,
            "label": "2",
            "content": { "template": "" },
            "typ": "Standard"
          },
          {
            "id": "512587c6-0f58-4de8-8527-1d6b316a26e0",
            "order": 2,
            "label": "3",
            "content": { "template": "" },
            "typ": "Standard"
          },
          {
            "id": "c5e3c0b9-f857-4727-b4aa-6755cfd4ae31",
            "order": 3,
            "label": "4",
            "content": { "template": "" },
            "typ": "Standard"
          },
          {
            "id": "745bba92-2785-43ea-9986-330b49e5be9a",
            "order": 4,
            "label": "5",
            "content": { "template": "" },
            "typ": "Standard"
          },
          {
            "id": "07281360-6e37-4552-9971-5e1f9a70dcd9",
            "order": 5,
            "label": "6",
            "content": { "template": "" },
            "typ": "Standard"
          },
          {
            "id": "96e8b85c-281f-4294-9c8f-b71bf7c32b0b",
            "order": 6,
            "label": "7",
            "content": { "template": "Should be strictly enforced" },
            "typ": "Standard"
          }
        ],
        "rows": [
          {
            "id": "7ecda0ce-a9fe-4b46-95de-873b63c781c6",
            "order": 0,
            "label": null,
            "content": { "template": "Representatives must sign in or register with office staff or certain department within the facility" },
            "typ": "Standard"
          },
          {
            "id": "a0ea94b7-80a2-4c0b-bc7c-cef07b5722c3",
            "order": 1,
            "label": null,
            "content": { "template": "Representatives can only visit physicians or departments on certain days or times" },
            "typ": "Standard"
          },
          {
            "id": "e05bc190-d341-4fef-a82e-799a48b901ea",
            "order": 2,
            "label": null,
            "content": { "template": "Representatives must make appointments to visit a physician and/or department - (drop-in visits not allowed)" },
            "typ": "Standard"
          },
          {
            "id": "96761785-62ab-472f-b46f-1131c37b874e",
            "order": 3,
            "label": null,
            "content": { "template": "Certain areas of the facility are off-limits to representatives" },
            "typ": "Standard"
          },
          {
            "id": "233c29f2-4def-4dd4-a188-37cb8f3e9f3d",
            "order": 4,
            "label": null,
            "content": { "template": "Representatives must be registered with credentialing department or company" },
            "typ": "Standard"
          }                                 
        ]
      },
      {
        "id": "b39335db-e64f-4245-9c7b-d7563fe0ad33",
        "questionTemplateId": null,
        "order": 2,
        "questionType": "RadioButtonGrid",
        "isExclusivePerRow": false,
        "isRequired": true,
        "requiredOptions": {
            "strategy": "OnePerColumn"
        },
        "isLocked": true,
        "randomizeColumn": false,
        "randomizeRow": true,
        "title": null,
        "content": {
          "template": "Using descriptions below, please select which best describes the relationship between your practice or facility and each company with whom you interact.\n\n-Partner: Multiple, productive interactions occur between the company and my practice or facility. The relationship is consistently well-managed, and resources and support offered are valuable and timely. My practice or facility views this company as a high-quality provider support. The company is viewed as a trusted source of information.\n\n-Collaborative: Interactions are less frequent but productive when they occur. Although the relationship is well managed, room for improvement exists. My practice or facility views this company as a quality source of support. We would consider opportunities to collaborate shared initiatives.\n\n-Transactional: Few interactions with this company have occurred within the previous year. The relationship is mostly limited to indirect communication. We have other sources of support and information we value more, but we welcome opportunities to work more closely with this company.\n\n-Stressed: Most interactions with this company are non-productive. Our relationship is strained due to recent or past interactions. The process for me to interact with this company is difficult and confrontational. The goals of this company seem to be in direct conflict with my practice or facility."
        },
        "description": null,
        "rows": [
          {
            "id": "2d1b96a2-c82c-4d0f-93f5-c6a93d8c1bb0",
            "label": null,
            "content": {
              "template": "Partner"
            },
            "order": 0,
            "typ": "Standard"
          },
          {
            "id": "064d5906-67e3-40d7-b8ab-537001e5873a",
            "label": null,
            "content": {
              "template": "Collaborative"
            },
            "order": 1,
            "typ": "Standard"
          },
          {
            "id": "a01cd100-1808-4d15-90ee-6e2457fe28d6",
            "label": null,
            "content": {
              "template": "Transactional"
            },
            "order": 2,
            "typ": "Standard"
          },
          {
            "id": "635e371e-9c58-4941-b825-71e322467d70",
            "label": null,
            "content": {
                "template": "Stressed"
            },
            "order": 3,
            "typ": "Standard"
          },
          { 
            "id":"6b57b291-1d15-47fc-929d-8f3eabb9778d",
            "typ":"NA",
            "label":null,
            "order":4,
            "content":{ 
              "template": "NA – No relationship"
            }
          }
        ],
        "columns": [
          {
            "id": "e09575bb-ea87-43b3-beea-6612be2c845a",
            "order": 0,
            "label": null,
            "content": {
              "template": "%%0",
              "groups": {
                "0": {
                  "placeholder": "Product (Company)",
                  "text": null
                }
              }
            },
            "typ": "Standard"            
          },
          {
            "id": "15d1bd7f-df5a-4173-b63a-9547f8005b2e",
            "order": 1,
            "label": null,
            "content": {
              "template": "%%0",
              "groups": {
                "0": {
                  "placeholder": "Product (Company)",
                  "text": null
                }
              }
            },
            "typ": "Standard"            
          },
          {
            "id": "70ee601b-94d7-4a41-a297-ef6bc230fc9a",
            "order": 2,
            "label": null,
            "content": {
              "template": "%%0",
              "groups": {
                "0": {
                  "placeholder": "Product (Company)",
                  "text": null
                }
              }
            },
            "typ": "Standard"            
          },
          {
            "id": "89d56197-5080-4735-b494-9f93a62a212a",
            "order": 3,
            "label": null,
            "content": {
              "template": "%%0",
              "groups": {
                "0": {
                  "placeholder": "Product (Company)",
                  "text": null
                }
              }
            },
            "typ": "Standard"            
          },
          {
            "id": "21950305-8e3d-44d2-aaeb-dab183bdd87c",
            "order": 4,
            "label": null,
            "content": {
              "template": "%%0",
              "groups": {
                "0": {
                  "placeholder": "Product (Company)",
                  "text": null
                }
              }
            },
            "typ": "Standard"            
          }                                        
        ]
      },
      {
        "id": "37c605a3-fb4e-4b03-878d-9cfbdf93457c",
        "questionTemplateId": null,
        "order": 3,
        "questionType": "RatingList",
        "isExclusivePerRow": false,
        "isRequired": true,
        "requiredOptions":
        {
            "strategy": "OnePerRow"
        },
        "isLocked": true,
        "randomizeColumn": false,
        "randomizeRow": true,
        "title": null,
        "content": 
        {
          "template": "Please indicate how valuable your interactions are with each pharmaceutical sales representative."
        },
        "description": null,
        "columns":
        [
          {
            "id": "8049daf7-59b1-4358-97e1-95ab8309eee3",
            "label": "1",
            "content":
            {
              "template": "Not at all valuable"
            },
            "order": 0,
            "typ": "Standard"
          },
          {
            "id": "92987fd7-d62a-497a-83af-39c614ff289d",
            "label": "2",
            "content":
            {
              "template": ""
            },
            "order": 1,
            "typ": "Standard"
          },
          {
            "id": "eeebf75b-c682-4b8b-acfa-a3966e74d62f",
            "label": "3",
            "content":
            {
              "template": ""
            },
            "order": 2,
            "typ": "Standard"
          },
          {
            "id": "7301e1e5-c124-4acb-a08a-1b39cbcf3642",
            "label": "4",
            "content":
            {
              "template": ""
            },
            "order": 3,
            "typ": "Standard"
          },
          {
            "id": "13ba1bc4-d4b9-449d-8840-46c0d8906aef",
            "label": "5",
            "content":
            {
              "template": ""
            },
            "order": 4,
            "typ": "Standard"
          },
          {
            "id": "5fcde508-0e42-4fbb-9861-4f011b4dc440",
            "label": "6",
            "content":
            {
              "template": ""
            },
            "order": 5,
            "typ": "Standard"
          },
          {
            "id": "83590677-13e4-44e0-9004-04753164cc8e",
            "label": "7",
            "content":
            {
              "template": "Extremely valuable"
            },
            "order": 6,
            "typ": "Standard"
          }                                                                
        ],
        "rows": [
          {
            "id": "cc7d220d-0076-4553-a5ec-1457f53e1f9a",
            "order": 0,
            "label": null,
            "content": {
              "template": "%%0",
              "groups": {
                "0": {
                  "placeholder": "Product (Company)",
                  "text": null
                }
              }
            },
            "typ": "Standard"            
          },
          {
            "id": "cc8ef229-6e6f-4e49-965c-8b6bc85bcd71",
            "order": 1,
            "label": null,
            "content": {
              "template": "%%0",
              "groups": {
                "0": {
                  "placeholder": "Product (Company)",
                  "text": null
                }
              }
            },
            "typ": "Standard"            
          },
          {
            "id": "7c0191c0-a6b4-493b-af20-b93afd36b9a2",
            "order": 2,
            "label": null,
            "content": {
              "template": "%%0",
              "groups": {
                "0": {
                  "placeholder": "Product (Company)",
                  "text": null
                }
              }
            },
            "typ": "Standard"            
          },
          {
            "id": "8fe9e3b9-d8fe-4356-af10-924fbc02e57f",
            "order": 3,
            "label": null,
            "content": {
              "template": "%%0",
              "groups": {
                "0": {
                  "placeholder": "Product (Company)",
                  "text": null
                }
              }
            },
            "typ": "Standard"            
          },
          {
            "id": "d0940971-8d72-40dd-bedd-075988981f35",
            "order": 4,
            "label": null,
            "content": {
              "template": "%%0",
              "groups": {
                "0": {
                  "placeholder": "Product (Company)",
                  "text": null
                }
              }
            },
            "typ": "Standard"            
          }                     
        ]
      },
      {
        "id": "a8d57bc0-3d3b-4eff-932f-5f8a38267fad",
        "questionTemplateId": null,
        "order": 4,
        "questionType": "OpenEndedText",
        "isRequired": true,
        "isLocked": true,
        "title": null,
        "content": {
          "template": "How could the representative for %%0 improve their interactions with you?",
          "groups": {
            "0": {
              "placeholder": "Insert Product (Company)",
              "text": null
            }
          }
        },
        "description": null
      },
      {
        "id": "3d3ec9b3-4a4c-4978-904f-ffe74669b9f3",
        "questionTemplateId": null,
        "order": 5,
        "questionType": "CheckboxList",
        "isRequired": true,
        "isLocked": true,
        "randomize": true,
        "requiredOptions": null,        
        "title": null,
        "content": {
          "template": "Which discussion topics provide the most value to you?"
        },
        "description": null,
        "answerOptions": [
          {
            "id": "b6a29d35-bf05-45b0-9f7a-f93cc658814b",
            "order": 0,
            "label": null,
            "content": {
              "template": "Product information, including dosing and administration"
            },
            "typ": "Standard"
          },
          {
            "id": "a877a7ec-a66d-457c-b2cb-962ac4daaef2",
            "order": 1,
            "label": null,
            "content": {
              "template": "Treatment paradigms and how his/her product fits in"
            },
            "typ": "Standard"
          },
          {
            "id": "2b54f43f-91ac-4c5b-945c-abb8e89500f6",
            "order": 2,
            "label": null,
            "content": {
              "template": "Healthcare resource utilization and where his/her product fits"
            },
            "typ": "Standard"
          },
          {
            "id": "cbcece09-8cf3-482d-8250-41b9109d75f3",
            "order": 3,
            "label": null,
            "content": {
              "template": "Published clinical data of interest to me"
            },
            "typ": "Standard"
          },
          {
            "id": "9f49f32d-4599-4895-a4af-6aea176173f1",
            "order": 4,
            "label": null,
            "content": {
              "template": "Other: [Specify]"
            },
            "typ": "ParticipantDefined"
          }                                        
        ]
      },
      {
        "id": "74a128c8-731f-4a08-89a8-af2669f68a9a",
        "questionTemplateId": null,
        "order": 6,   
        "questionType": "RatingList",
        "isExclusivePerRow": null,
        "isRequired": true,
        "isLocked": true,
        "requiredOptions": {
          "strategy": "OnePerRow"
        },
        "randomizeColumn": false,
        "randomizeRow": true,
        "title": null,   
        "content": {
          "template": "Please rate the value of the following resources that pharmaceutical representatives may offer you."
        },
        "description": null,   
        "columns": [
          {
            "id": "779d2d21-70c0-4fcd-9c39-bef8f54a64aa",
            "order": 0,
            "label": "1",
            "content": {
              "template": "Not at all valuable"
            },
            "typ": "Standard"
          },
          {
            "id": "10f80c3a-d7c9-497b-91a2-19ca76fbc50e",
            "order": 1,
            "label": "2",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "b61ddc51-6559-422c-95c9-41c423815de6",
            "order": 2,
            "label": "3",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "a2154501-23bb-4974-b231-4a4917814727",
            "order": 3,
            "label": "4",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "d4318a22-9209-44c5-830d-b54b281432aa",
            "order": 4,
            "label": "5",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "5101dc2d-2ad3-4caf-b80f-808221c30b16",
            "order": 5,
            "label": "6",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "b8a36854-a654-4c8b-b3cb-1c611f8661ef",
            "order": 6,
            "label": "7",
            "content": {
              "template": "Extremely valuable"
            },
            "typ": "Standard"
          }                                                                     
        ],
        "rows": [
          {
            "id": "625c0a76-4920-4ba2-bda0-d3131343057e",
            "order": 0,
            "label": null,
            "content": {
              "template": "Product information kit/formulary review kit that representatives provide during their interactions with you"
            },
            "typ": "Standard"
          },
          {
            "id": "bc25aaa1-08b4-4269-8f23-7fb9670e5338",
            "order": 1,
            "label": null,
            "content": {
              "template": "Promotional materials such as visual aids and clinical studies/reprints that representatives use in product discussions (excluding patient education materials)"
            },
            "typ": "Standard"
          },
          {
            "id": "ee8d9ce8-956b-4df2-ab57-3b6ac6687956",
            "order": 2,
            "label": null,
            "content": {
              "template": "Patient education materials that representatives provide to you and your staff"
            },
            "typ": "Standard"
          },
          {
            "id": "38a5e1ac-7f2b-47c8-8002-90b6fae00be0",
            "order": 3,
            "label": null,
            "content": {
              "template": "Ability to provide access to the company's medical team for off-label data or clinical questions that representatives cannot answer"
            },
            "typ": "Standard"
          },
          {
            "id": "949956ba-6ca1-459b-93a0-e2df654639f0",
            "order": 4,
            "label": null,
            "content": {
              "template": "Contract information (GPO and direct)"
            },
            "typ": "Standard"
          }                                                           
        ]                  
      },
      {
        "id": "5d1de614-1835-40b5-80bc-a7d65fd9e3ba",
        "questionTemplateId": null,
        "order": 7,        
        "questionType": "CheckboxList",
        "isRequired": true,
        "isLocked": true,
        "randomize": true,
        "requiredOptions": null,
        "title": null,
        "content": {
          "template": "Please select the attributes you consider most important for pharmaceutical representatives."
        },
        "description": null,   
        "answerOptions": [
          {
            "id": "86eddbc0-6241-4d19-bcc9-fa9847428454",
            "order": 0,
            "label": null,
            "content": {
              "template": "Offers information and resources that genuinely interest me"
            },
            "typ": "Standard"            
          },
          {
            "id": "c14edb15-7291-42be-80c1-4a9a914b2562",
            "order": 1,
            "label": null,
            "content": {
              "template": "Discusses positive and negative aspects of product"
            },
            "typ": "Standard"            
          },
          {
            "id": "d138ab21-5377-4df0-9077-3127897fa74e",
            "order": 2,
            "label": null,
            "content": {
              "template": "Uses visual aids and clinical studies to support discussion"
            },
            "typ": "Standard"            
          },
          {
            "id": "ffbefc3e-d986-49ce-af3b-4f1e642f39d6",
            "order": 3,
            "label": null,
            "content": {
              "template": "Respects the value of my time by avoiding lower-priority topics"
            },
            "typ": "Standard"            
          },
          {
            "id": "f9a9a0f6-d774-41ea-88b7-e9ec1ea66f0a",
            "order": 4,
            "label": null,
            "content": {
              "template": "Is an expert on the disease state/treatment area for which their product is indicated"
            },
            "typ": "Standard"            
          }                                                   
        ]
      },
      {
        "id": "953de0a4-5882-49f9-9c7d-73e3e8f453b8",
        "questionTemplateId": null,
        "order": 8,
        "questionType": "RatingList",
        "isExclusivePerRow": null,
        "isRequired": true,
        "isLocked": true,
        "requiredOptions": {
          "strategy": "OnePerRow"
        },
        "randomizeColumn": false,
        "randomizeRow": true,
        "title": null,        
        "content": {
          "template": "Please rate how well the subsequent statements describe each pharmaceutical sales representative from %%0",
          "groups": {
            "0": {
              "placeholder": "Insert Product (Company)",
              "text": null
            }
          }
        },
        "description": null,
        "columns": [
          {
            "id": "12da55d0-a6d5-483d-84d8-6c9dc37709d8",
            "order": 0,
            "label": "1",
            "content": {
              "template": "Does not describe representative at all"
            },
            "typ": "Standard"
          },
          {
            "id": "43e24ccd-5e85-4f5e-8651-7d5ea2527e7f",
            "order": 1,
            "label": "2",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "b81c5579-5fb7-4919-9347-089d073b5799",
            "order": 2,
            "label": "3",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "c1897803-6b9c-4326-9994-58a47d922b49",
            "order": 3,
            "label": "4",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "75b4877f-0b36-4173-a9d2-c71aea5d8426",
            "order": 4,
            "label": "5",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "5126e101-de48-4e90-8ac3-1ad289e6b2e4",
            "order": 5,
            "label": "6",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "775ab431-cdd3-4a96-8494-32f0d59a5445",
            "order": 6,
            "label": "7",
            "content": {
              "template": "Describes representative perfectly"
            },
            "typ": "Standard"
          }                                                            
        ],
        "rows": [
          {
            "id": "563bac21-903e-4d62-9d6e-ac8fdf04f391",
            "order": 0,
            "label": null,
            "content": {
              "template": "Offers information and resources that genuinely interest me"
            },
            "typ": "Standard"
          },
          {
            "id": "9e876f9e-13e4-4c18-ac20-ed00f2312b53",
            "order": 1,
            "label": null,
            "content": {
              "template": "Discusses positive and negative aspects of product"
            },
            "typ": "Standard"
          },
          {
            "id": "ea73d9d4-6efe-40c4-a4a8-1442d1e6f1ef",
            "order": 2,
            "label": null,
            "content": {
              "template": "Uses visual aids and clinical studies to support discussion"
            },
            "typ": "Standard"
          },
          {
            "id": "ef3d6836-d8fd-48d6-a154-1e3bddb7a647",
            "order": 3,
            "label": null,
            "content": {
              "template": "Respects the value of my time by avoiding lower-priority topics"
            },
            "typ": "Standard"
          },
          {
            "id": "2ce3a4a0-36f0-44f5-9740-7ad7356837d3",
            "order": 4,
            "label": null,
            "content": {
              "template": "Is an expert on the disease state/treatment area for which their product is indicated"
            },
            "typ": "Standard"
          }                              
        ]
      }
    ],
    "screeners": [],
    "deleted": []        
  },
  {
    "id": "315257e4-4128-40b2-8a51-11342e0babc8",
    "title": "Access Express Physician Pricing",
    "sourceTitle": null,
    "panel": "PhysicianSurvey",
    "status": "Draft",
    "description": null,
    "questions": [
      {
        "id": "fc55569a-7f5c-470e-bc05-04e4425db794",
        "questionTemplateId": null,
        "order": 0,
        "questionType": "RadioButtonGrid",        
        "isExclusivePerRow": false,
        "isRequired": true,
        "isLocked": true,
        "requiredOptions": {
          "strategy": "OnePerColumn"
        },
        "randomizeRow": true,
        "randomizeColumn": false,        
        "title": null,
        "content": {
          "template": "Are you aware of the prices of the following products to treat %%0",
          "groups": {
            "0": {
              "placeholder": "insert disease area",
              "text": null
            }
          }
        },
        "description": null,
        "columns": [
          {
            "id": "2bc3fd70-d29c-4962-884a-c0cfcd43caff",
            "order": 0,
            "label": null,
            "content": {
              "template": "%%0",
              "groups": {
                "0": {
                  "placeholder": "Insert brand",
                  "text": null
                }
              }
            }, 
            "typ": "Standard"
          },
          {
            "id": "31e74acb-b889-43ac-a90a-f12513c69d18",
            "order": 1,
            "label": null,
            "content": {
              "template": "%%0",
              "groups": {
                "0": {
                  "placeholder": "Insert brand",
                  "text": null
                }
              }
            }, 
            "typ": "Standard"
          },
          {
            "id": "39a92e79-c3f7-4203-95be-9507831a6009",
            "order": 2,
            "label": null,
            "content": {
              "template": "%%0",
              "groups": {
                "0": {
                  "placeholder": "Insert brand",
                  "text": null
                }
              }
            }, 
            "typ": "Standard"
          },
          {
            "id": "73bfe7f2-5e74-410c-8288-0df68128db7e",
            "order": 3,
            "label": null,
            "content": {
              "template": "%%0",
              "groups": {
                "0": {
                  "placeholder": "Insert brand",
                  "text": null
                }
              }
            }, 
            "typ": "Standard"
          }                                                                    
        ],
        "rows": [
          {
            "id": "03ce33d0-9813-4a53-8662-10bd098c1430",
            "order": 0,
            "label": null,
            "content": {
              "template": "Yes"
            },
            "typ": "Standard"
          },
          {
            "id": "01225245-4a5d-4a53-807d-3a050fab9eee",
            "order": 1,
            "label": null,
            "content": {
              "template": "No"
            },
            "typ": "Standard"
          }          
        ]
      },
      {
        "id": "1604facc-5e44-47ea-8501-aa48958c7eb1",
        "questionTemplateId": null,
        "order": 1,
        "questionType": "TextboxListNumeric",
        "isRequired": true,
        "isLocked": true,
        "requiredOptions": {
        },                        
        "title": true,
        "randomize": true,
        "description": null,
        "content": {
          "template": "What is the total monthly cost to treat one patient with each of the following products?\n\nIndicate $"
        },
        "answerOptions": [
          { 
            "id":"819b6fa1-6c88-449d-909b-85a5077753ed",
            "typ":"Standard",
            "label":null,
            "order":0,
            "content": {
              "template":
                "%%0",
              "groups": {
                "0": {
                  "placeholder":
                    "Insert brand",
                  "text": null
                }
              }
            }
          },
          { 
            "id":"53525249-6b1c-40c2-93d9-8d675a66468e",
            "typ":"Standard",
            "label":null,
            "order":1,
            "content": {
              "template":
                "%%0",
              "groups": {
                "0": {
                  "placeholder":
                    "Insert brand",
                  "text": null
                }
              }
            }
          },
          { 
            "id":"34078130-697c-4239-96d0-7d877eac24e3",
            "typ":"Standard",
            "label":null,
            "order":2,
            "content": {
              "template":
                "%%0",
              "groups": {
                "0": {
                  "placeholder":
                    "Insert brand",
                  "text": null
                }
              }
            }
          },
          { 
            "id":"428a825d-c901-4836-a0ca-f4a037e3cff5",
            "typ":"Standard",
            "label":null,
            "order":3,
            "content": {
              "template":
                "%%0",
              "groups": {
                "0": {
                  "placeholder":
                    "Insert brand",
                  "text": null
                }
              }
            }
          },
          { 
            "id":"c9fa8da1-0966-4baf-943f-c8fd6cf478b9",
            "typ":"Standard",
            "label":null,
            "order":4,
            "content": {
              "template":
                "%%0",
              "groups": {
                "0": {
                  "placeholder":
                    "Insert brand",
                  "text": null
                }
              }
            }
          }                                                  
        ]
      },
      {
        "id": "a5d285e3-372d-455a-9b45-ac3bb787632d",
        "questionTemplateId": null,
        "order": 2,
        "questionType": "TextboxListNumeric", 
        "isRequired": true,
        "isLocked": true,
        "requiredOptions": {
        },                        
        "title": true,
        "description": null,
        "randomize": true,
        "content": {
          "template": "Assuming the product(s) are proven safe and effective, what is the maximum monthly cost of each product that would not prompt you to switch to an alternative product?\n\nIndicate $"
        },    
        "answerOptions": [
          { 
            "id":"f48883c3-bf4e-47af-a910-b032c63fd25b",
            "typ":"Standard",
            "label":null,
            "order":0,
            "content": {
              "template":
                "%%0",
              "groups": {
                "0": {
                  "placeholder":
                    "Insert brand",
                  "text": null
                }
              }
            }
          },
          { 
            "id":"570a9e3b-cd14-4219-a02a-d312cac80bd3",
            "typ":"Standard",
            "label":null,
            "order":1,
            "content": {
              "template":
                "%%0",
              "groups": {
                "0": {
                  "placeholder":
                    "Insert brand",
                  "text": null
                }
              }
            }
          },
          { 
            "id":"08705a68-d3cd-4367-8388-ec47458da276",
            "typ":"Standard",
            "label":null,
            "order":2,
            "content": {
              "template":
                "%%0",
              "groups": {
                "0": {
                  "placeholder":
                    "Insert brand",
                  "text": null
                }
              }
            }
          },
          { 
            "id":"9ce18073-2ed6-459c-be37-70812c86656a",
            "typ":"Standard",
            "label":null,
            "order":3,
            "content": {
              "template":
                "%%0",
              "groups": {
                "0": {
                  "placeholder":
                    "Insert brand",
                  "text": null
                }
              }
            }
          },
          { 
            "id":"373e5b1a-1eb6-42af-9c69-f86bc003165c",
            "typ":"Standard",
            "label":null,
            "order":4,
            "content": {
              "template":
                "%%0",
              "groups": {
                "0": {
                  "placeholder":
                    "Insert brand",
                  "text": null
                }
              }
            }
          }                  
        ]           
      },
      {
        "id": "17a7afff-c2c2-489b-a655-e626f4afe1ea",
        "questionTemplateId": null,
        "order": 3,
        "questionType": "RadioButtonList",      
        "isRequired": true,
        "isLocked": true,
        "randomize": false,
        "requiredOptions": null,
        "title": null,
        "content": {
          "template":
            "We would now like to ask you a few questions about your willingness to prescribe %%0.\n\n If the monthly cost were to exceed %%1, how would this change your prescribing decision for new patients?",
            "groups": {
              "0": {
                "placeholder": "Insert brand",
                "text": null
              },
              "1": {
                "placeholder": "Insert $ amount",
                "text": null
              }              
            }            
        },
        "description": null,
        "answerOptions": [
          {
            "id": "8b602c4a-95b3-4a64-a522-c379e1d927c2",
            "typ":"Standard",
            "label":null,
            "order":0,            
            "content": {
              "template": "Prescribe a less expensive generic with inferior efficacy"
            }            
          },
          {
            "id": "8d14d60a-3a8d-4406-a4f0-c9b717fed008",
            "typ":"Standard",
            "label":null,
            "order":1,            
            "content": {
              "template": "Prescribe a less expensive brand with similar efficacy"
            }            
          },
          {
            "id": "70dc2a1d-5558-4362-a3ca-aee010d7a7a0",
            "typ":"Standard",
            "label":null,
            "order":2,            
            "content": {
              "template": "Discuss costs and alternatives with the patient before prescribing"
            }            
          },
          {
            "id": "d4a7dd1a-2ec6-484d-8fe4-98f1b41bca27",
            "typ":"Standard",
            "label":null,
            "order":3,            
            "content": {
              "template": "Prescribe what I believe the patient needs and not be concerned about cost"
            }            
          },
          {
            "id": "eff461e9-01f4-4b23-8b23-efc8ba454e81",
            "typ":"ParticipantDefined",
            "label":null,
            "order":4,            
            "content": {
              "template":"Other: [Specify]"
            }            
          }                                                 
        ]        
      },
      {
        "id": "754fd056-deb4-42a5-975d-27d6a4599b39",
        "questionTemplateId": null,
        "order": 4,
        "questionType": "RadioButtonGrid",   
        "isExclusivePerRow": false,
        "isRequired": true,
        "isLocked": true,
        "requiredOptions": {
          "strategy": "OnePerColumn"
        },
        "randomizeRow": true,
        "randomizeColumn": false,     
        "title": null,
        "content": {
          "template": "Are you aware of the average out-of-pocket cost for following products to treat %%0 for a monthly course of therapy?",
          "groups": {
            "0": {
              "placeholder": "Insert disease area",
              "text": null
            }
          }
        },
        "description": null,
        "columns": [
          {
            "id": "5fc57751-520a-4c06-b78a-27ceb08ade7d",
            "order": 0,
            "label": null,
            "content": {
              "template": "%%0",
              "groups": {
                "0": {
                  "placeholder": "Insert brand",
                  "text": null
                }
              }
            },
            "typ": "Standard"
          },
          {
            "id": "73e1c6f5-3630-4837-a7c8-9da3367c099e",
            "order": 1,
            "label": null,
            "content": {
              "template": "%%0",
              "groups": {
                "0": {
                  "placeholder": "Insert brand",
                  "text": null
                }
              }
            },
            "typ": "Standard"
          },
          {
            "id": "d7752b9c-ec6f-43ef-beae-0d955cb60e8f",
            "order": 2,
            "label": null,
            "content": {
              "template": "%%0",
              "groups": {
                "0": {
                  "placeholder": "Insert brand",
                  "text": null
                }
              }
            },
            "typ": "Standard"
          },
          {
            "id": "974006ca-df9d-4c29-bc22-9007fffde02a",
            "order": 3,
            "label": null,
            "content": {
              "template": "%%0",
              "groups": {
                "0": {
                  "placeholder": "Insert brand",
                  "text": null
                }
              }
            },
            "typ": "Standard"
          }                           
        ],
        "rows": [
          {
            "id": "762c8b9f-d56d-45aa-b4dc-c9d87e53f69a",
            "order": 0,
            "label": null,
            "content": {
              "template": "Yes"
            },
            "typ": "Standard"
          },
          {
            "id": "3ad87632-1152-4aa3-b85b-75cff2c929a5",
            "order": 1,
            "label": null,
            "content": {
              "template": "No"
            },
            "typ": "Standard"
          }          
        ]
      },
      {
        "id": "30251cbd-6db4-4634-a991-a8c4eaa049a6",
        "questionTemplateId": null,
        "order": 5,
        "questionType": "CheckboxList",        
        "isRequired": true,
        "isLocked": true,
        "randomize": true,
        "requiredOptions": null,
        "title": null,
        "content": {
          "template": "What source(s) of information do you reference to learn the patient’s out-of-pocket costs?"
        },
        "description": null,        
        "answerOptions": [
          {
            "id": "5f8b3fe7-800a-4bfa-adf1-57b535849877",
            "order": 0,
            "label": null,
            "content": {
              "template": "Discussions regarding out-of-pocket costs directly with the patient"
            },
            "typ": "Standard"
          },
          {
            "id": "f2acf479-fc20-4c78-834c-2606f7f197dc",
            "order": 1,
            "label": null,
            "content": {
              "template": "Computerized physician order entry system (CPOE) or electronic health record (EHR) system"
            },
            "typ": "Standard"
          },
          {
            "id": "3f216aad-9ffc-4348-94e6-2e352b6ce126",
            "order": 2,
            "label": null,
            "content": {
              "template": "Information shared by patient’s insurance provider"
            },
            "typ": "Standard"
          },
          {
            "id": "e6640097-b543-4f37-8854-091da2240593",
            "order": 3,
            "label": null,
            "content": {
              "template": "Office staff"
            },
            "typ": "Standard"
          },
          {
            "id": "",
            "order": 4,
            "label": null,
            "content": {
              "template": "Information shared by the biopharmaceutical company"
            },
            "typ": "Standard"
          },
          {
            "id": "fad1f763-db15-4faa-8c6a-96abf9e214e7",
            "order": 5,
            "label": null,
            "content": {
              "template": "Other: [Specify]"
            },
            "typ": "ParticipantDefined"
          }                                                                    
        ]
      },
      {
        "id": "6d4c9c01-31c4-42c0-ba12-9d953636ff47",
        "questionTemplateId": null,
        "order": 6,
        "questionType": "RatingList",    
        "isExclusivePerRow": null,
        "isRequired": true,
        "isLocked": true,
        "requiredOptions": {
          "strategy": "OnePerRow"
        },
        "randomizeColumn": false,
        "randomizeRow": false,
        "title": null,    
        "content": {
          "template": "How does your knowledge of patient out-of-pocket costs impact your prescribing decisions?"
        },
        "description": null,    
        "columns": [
          {
            "id": "46f2e66a-bca6-473c-9139-b8902236fd0a",
            "order": 0,
            "label": "1",
            "content": {
              "template": "No impact"
            },
            "typ": "Standard"
          },
          {
            "id": "011a9432-1127-43c3-8dd3-64cdf56fbf5f",
            "order": 1,
            "label": "2",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "c1f012db-4050-4b09-8b78-b9af4d4e0ea7",
            "order": 2,
            "label": "3",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "f6120212-1ae0-4af1-8000-14e45657e537",
            "order": 3,
            "label": "4",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "57f77223-1ee7-4520-8fad-2de12ce3e0bc",
            "order": 4,
            "label": "5",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "910207c4-8319-4d27-9f11-36e6f576e457",
            "order": 5,
            "label": "6",
            "content": {
              "template": ""
            },
            "typ": "Standard"
          },
          {
            "id": "b0c383b3-98cd-4e30-8d0c-2ee24db8413c",
            "order": 6,
            "label": "7",
            "content": {
              "template": "High impact"
            },
            "typ": "Standard"
          }
        ],
        "rows": [
          {
            "id": "29a19b87-24cc-41a0-8ce1-06b9a63e3254",
            "order": 0,
            "label": null,
            "content": {
              "template": ""
            },
            "typ": "Standard"
          }          
        ]       
      },
      {
        "id": "8f8fab18-15fe-48d5-80bc-b0a9f9ed348f",
        "questionTemplateId": null,
        "order": 7,
        "questionType": "RadioButtonList",      
        "isRequired": true,
        "isLocked": true,
        "randomize": false,
        "requiredOptions": null,
        "title": null,
        "content": {
          "template": "We would now like to ask you a few questions about your willingness to prescribe %%0 if the patient had to pay different out-of-pocket price points.\n\nWould you prescribe %%1 if a patient’s out-of-pocket costs were %%2 for a monthly course of therapy?",
          "groups": {
            "0": {
              "placeholder": "insert brand",
              "text": null
            },
            "1": {
              "placeholder": "insert brand",
              "text": null
            },
            "2": {
              "placeholder": "insert price",
              "text": null              
            }
          }
        },      
        "description": null,
        "answerOptions": [
          {
            "id": "f8e62e57-f65e-4f5b-a68c-4579357d4431",
            "order": 0,
            "label": null,
            "content": {
              "template": "Yes"
            },
            "typ": "Standard"            
          },
          {
            "id": "7d984151-9d36-41f8-95fe-55e13efcd6da",
            "order": 1,
            "label": null,
            "content": {
              "template": "No"
            },
            "typ": "Standard"            
          }          
        ]
      }                                          
    ],
    "screeners": [],
    "deleted": []    
  }  
] as unknown as SurveySchema[];


export const getMockedSurvey = (): SurveySchema => ({ 
  "id":"5f0574a2-d4de-4523-bd69-9dec9be49c14",
  "title":"Demo Survey",
  "status":"Active",
  "panel":"OncologyCenter",
  "description":null,
  "questions":[ 
    { 
      "isRequired":true,
      "questionType":"RatingList",
      "order":0,
      "createdAt":"2020-01-16T08:22:59.908Z",
      "id":"c8bf7ed8-45b5-41e7-a485-acb9f7a43786",
      "rows":[ 
        { 
          "id":"825ac92c-5f30-4c41-aec9-4e18c96d7213",
          "typ":"Standard",
          "label":null,
          "order":0,
          "content":{ 
            "template":"Improved clinical efficacy or outcomes compared to standard of care"
          }
        },
        { 
          "id":"c54a30bc-60b4-44b1-b875-4ba6a1f0c102",
          "typ":"Standard",
          "label":null,
          "order":1,
          "content":{ 
            "template":"Increased patient compliance with therapy"
          }
        },
        { 
          "id":"08811eab-2c04-47b1-aea0-150e99d0c5cd",
          "typ":"Standard",
          "label":null,
          "order":3,
          "content":{ 
            "template":"Reduced adverse events"
          }
        },
        { 
          "id":"4a19e1d7-454a-4d72-b941-546ac49d21e4",
          "typ":"Standard",
          "label":null,
          "order":4,
          "content":{ 
            "template":"Reduced healthcare resource utilization compared to standard of care"
          }
        }
      ],
      "title":null,
      "columns":[ 
        { 
          "id":"117ef226-3144-44d7-8b9a-45c79d0ac5ec",
          "typ":"Standard",
          "label":"1",
          "order":0,
          "content":{ 
            "template":"Very Low"
          }
        },
        { 
          "id":"ef79f86a-f97b-43c2-8556-efc338486cef",
          "typ":"Standard",
          "label":"2",
          "order":1,
          "content":{ 
            "template":""
          }
        },
        { 
          "id":"6628d700-edda-464b-847e-7e98920ca419",
          "typ":"Standard",
          "label":"3",
          "order":2,
          "content":{ 
            "template":""
          }
        },
        { 
          "id":"05c6df66-bae8-4006-a5e3-dae9d9f3978a",
          "typ":"Standard",
          "label":"4",
          "order":3,
          "content":{ 
            "template":""
          }
        },
        { 
          "id":"96646fe7-a2bf-41c8-8320-b4633b074868",
          "typ":"Standard",
          "label":"5",
          "order":4,
          "content":{ 
            "template":""
          }
        },
        { 
          "id":"29962fd0-6082-4d6b-af00-d901263100cf",
          "typ":"Standard",
          "label":"6",
          "order":5,
          "content":{ 
            "template":""
          }
        },
        { 
          "id":"70219833-b86f-4107-ac9e-8b5cfa29960b",
          "typ":"Standard",
          "label":"7",
          "order":6,
          "content":{ 
            "template":"Very high need"
          }
        }
      ],
      "content":{ 
        "groups":{ 
          "0":{ 
            "text":"Test Area",
            "placeholder":"Insert therapeutic area"
          }
        },
        "template":"Please rate each of the following needs as they apply to the treatment of %%0."
      },
      "isLocked":true,
      "isScreener":false,
      "description":null,
      "randomizeRow":true,
      "randomizeColumn":false,
      "requiredOptions":{ 
        "strategy":"OnePerRow"
      },
      "isExclusivePerRow":null,
      "questionTemplateId":"ecec5d79-b034-4fd4-8d78-5adfa49b8c11"
    },
    { 
      "isRequired":true,
      "questionType":"RadioButtonGrid",
      "order":1,
      "createdAt":"2020-01-16T08:22:59.908Z",
      "id":"85d63812-f261-4fcf-8e35-812bb3433638",
      "rows":[ 
        { 
          "id":"3316d325-cc3f-4d4b-8190-83a7087fa577",
          "typ":"Standard",
          "label":null,
          "order":0,
          "content":{ 
            "template":"Preferred tier"
          }
        },
        { 
          "id":"d83b4fc9-571c-4296-89b9-fcd02620bc5b",
          "typ":"Standard",
          "label":null,
          "order":1,
          "content":{ 
            "template":"Non-preferred tier"
          }
        },
        { 
          "id":"e3ae62c5-d0e3-4e95-ac8b-4e1df0ad6324",
          "typ":"Standard",
          "label":null,
          "order":2,
          "content":{ 
            "template":"Specialty tier"
          }
        },
        { 
          "id":"b29577ba-c520-4a7d-b2ed-60315a5db23b",
          "typ":"Standard",
          "label":null,
          "order":3,
          "content":{ 
            "template":"Not covered"
          }
        },
        { 
          "id":"9575b67f-96e6-4011-b68b-16e45e80c755",
          "typ":"NA",
          "label":null,
          "order":4,
          "content":{ 
            "template":"Don’t know"
          }
        }
      ],
      "title":null,
      "columns":[ 
        { 
          "id":"e5dd3fcb-ed2f-46cc-99f5-38debb0d2a21",
          "typ":"Standard",
          "label":null,
          "order":0,
          "content":{ 
            "groups":{ 
              "0":{ 
                "text":"Product A",
                "placeholder":"Insert product"
              }
            },
            "template":"%%0"
          }
        },
        { 
          "id":"9230ec12-c6f9-4bd2-af09-6aacf90507dc",
          "typ":"Standard",
          "label":null,
          "order":1,
          "content":{ 
            "groups":{ 
              "0":{ 
                "text":"Product B",
                "placeholder":"Insert text"
              }
            },
            "template":"%%0"
          }
        },
        { 
          "id":"3dfffa34-d50b-4309-bcd8-9c42dc5ada8c",
          "typ":"Standard",
          "label":null,
          "order":2,
          "content":{ 
            "groups":{ 
              "0":{ 
                "text":"Product C",
                "placeholder":"Insert text"
              }
            },
            "template":"%%0"
          }
        }
      ],
      "content":{ 
        "template":"How is your organization covering the products below on your organization’s most common formulary (e.g., commercial, Medicare/Part D, Medicaid)? "
      },
      "isLocked":true,
      "isScreener":false,
      "description":null,
      "randomizeRow":false,
      "randomizeColumn":true,
      "requiredOptions":{ 
        "strategy":"OnePerColumn"
      },
      "isExclusivePerRow":false,
      "questionTemplateId":"aff5c25e-359e-4584-a870-f22d4b302041"
    },
    { 
      "isRequired":true,
      "questionType":"CheckboxGrid",
      "order":2,
      "createdAt":"2020-01-16T08:22:59.908Z",
      "id":"811d4622-883b-4342-92eb-d46167e7111d",
      "rows":[ 
        { 
          "id":"7d2e439a-2d21-491e-9dce-32dd6b5ba73c",
          "typ":"Standard",
          "label":null,
          "order":0,
          "content":{ 
            "template":"Prior authorization"
          }
        },
        { 
          "id":"56e961b3-5512-45b4-83ca-e49ae90ee00f",
          "typ":"Standard",
          "label":null,
          "order":1,
          "content":{ 
            "template":"Step through generic"
          }
        },
        { 
          "id":"4199e2b4-a081-4704-94e6-24032046aa60",
          "typ":"Standard",
          "label":null,
          "order":2,
          "content":{ 
            "template":"Step through preferred brand"
          }
        },
        { 
          "id":"a8bc126c-e32b-496c-b0a4-5f1585640592",
          "typ":"Standard",
          "label":null,
          "order":3,
          "content":{ 
            "template":"Quantity limit"
          }
        },
        { 
          "id":"9035611b-14a6-4d92-9361-d9dec6006766",
          "typ":"ParticipantDefined",
          "label":null,
          "order":4,
          "content":{ 
            "template":"Other: [Specify]"
          }
        },
        { 
          "id":"04840396-83fe-4816-9713-c6149cc868c0",
          "typ":"NA",
          "label":null,
          "order":5,
          "content":{ 
            "template":"No restrictions"
          }
        }
      ],
      "title":null,
      "columns":[ 
        { 
          "id":"5bf84d94-2e2e-42bb-a9de-5c58e25aaae0",
          "typ":"Standard",
          "label":null,
          "order":0,
          "content":{ 
            "groups":{ 
              "0":{ 
                "text":"Product A",
                "placeholder":"Insert product"
              }
            },
            "template":"%%0"
          }
        },
        { 
          "id":"349fadc0-fcf6-4fe8-8369-fffcc2b3ddc1",
          "typ":"Standard",
          "label":null,
          "order":1,
          "content":{ 
            "groups":{ 
              "0":{ 
                "text":"Product B",
                "placeholder":"Insert text"
              }
            },
            "template":"%%0"
          }
        },
        { 
          "id":"ce3ba859-6d81-4051-afea-186e3042a47d",
          "typ":"Standard",
          "label":null,
          "order":2,
          "content":{ 
            "groups":{ 
              "0":{ 
                "text":"Product C",
                "placeholder":"Insert text"
              }
            },
            "template":"%%0"
          }
        }
      ],
      "content":{ 
        "template":"What restrictions, if any, does your organization place on these products on your most common formulary (e.g., commercial, Medicare/Part D, Medicaid)?"
      },
      "isLocked":true,
      "isScreener":false,
      "description":null,
      "randomizeRow":true,
      "randomizeColumn":true,
      "requiredOptions":{ 
        "strategy":"AtLeastOnePerColumn"
      },
      "isExclusivePerRow":false,
      "questionTemplateId":"f65f5f36-4444-4490-b4d4-c9e1114b5b5a"
    },
    { 
      "isRequired":true,
      "questionType":"ContinuousSumList",
      "order":3,
      "createdAt":"2020-01-16T08:22:59.909Z",
      "id":"bbc42fe2-3a45-40e9-b944-09576e8a275b",
      "title":null,
      "content":{ 
        "groups":{ 
          "0":{ 
            "text":"Area",
            "placeholder":"Insert therapeutic area"
          }
        },
        "template":"What factors will most impact your organization’s decision to provide favorable access to new-to-market or existing %%0 agents over the next year?\n\nPlease distribute 100 points across the factors below to assign value to each in your organization’s decision-making process (the higher the number, the more important the factor is considered)."
      },
      "isLocked":true,
      "randomize":true,
      "isScreener":false,
      "description":null,
      "answerOptions":[ 
        { 
          "id":"734068e6-ef4f-4feb-9774-f962b6cb7d5c",
          "typ":"Standard",
          "label":null,
          "order":0,
          "content":{ 
            "template":"Easier dosing or administration"
          }
        },
        { 
          "id":"ebba7a51-c8da-4f70-9ab1-6cc7e69fb918",
          "typ":"Standard",
          "label":null,
          "order":1,
          "content":{ 
            "template":"Indication breadth"
          }
        },
        { 
          "id":"4572fcc1-1b3c-44cc-a168-7a315cb4140f",
          "typ":"Standard",
          "label":null,
          "order":2,
          "content":{ 
            "template":"Comparative data documenting higher efficacy versus competitors"
          }
        },
        { 
          "id":"c2b7981f-c38d-4867-9bcb-8d612ef96c29",
          "typ":"Standard",
          "label":null,
          "order":3,
          "content":{ 
            "template":"Comparative data documenting fewer safety risks versus competitors"
          }
        },
        { 
          "id":"4a19a308-39fb-4bde-958f-7ac7ed71a2eb",
          "typ":"Standard",
          "label":null,
          "order":4,
          "content":{ 
            "template":"Experience/comfort with product (length of time on market)"
          }
        },
        { 
          "id":"a313ebd4-6893-42c1-af6c-856b1165206c",
          "typ":"Standard",
          "label":null,
          "order":5,
          "content":{ 
            "template":"Net cost differential between brands"
          }
        },
        { 
          "id":"ffcca954-a991-4bf4-ba15-0eea9e9dd779",
          "typ":"Standard",
          "label":null,
          "order":6,
          "content":{ 
            "template":"Considerable demand from KOLs, members, and providers"
          }
        },
        { 
          "id":"f9e24751-f829-410c-88ca-b39cb0f9174a",
          "typ":"Standard",
          "label":null,
          "order":7,
          "content":{ 
            "template":"Health economic outcomes research (HEOR) data"
          }
        }
      ],
      "requiredOptions":null,
      "questionTemplateId":"e2c5c4e8-8f70-4aa8-9e15-7f00f94766b8"
    },
    { 
      "isRequired":true,
      "questionType":"OpenEndedText",
      "order":4,
      "createdAt":"2020-01-16T08:22:59.909Z",
      "id":"11faf69c-b9c2-4cdc-8321-241906753bf9",
      "title":null,
      "content":{ 
        "groups":{ 
          "0":{ 
            "text":"Some Test Profile There",
            "placeholder":"Insert product profile"
          }
        },
        "template":"Here is a description of a treatment currently in development. Please take a moment to review the profile.\n%%0\nWhat is your initial reaction to this product profile?"
      },
      "isLocked":true,
      "isScreener":false,
      "description":null,
      "questionTemplateId":"72516fb9-eeae-46b2-96d2-5408687ecf57"
    },
    { 
      "isRequired":true,
      "questionType":"RatingList",
      "order":5,
      "createdAt":"2020-01-16T08:22:59.909Z",
      "id":"2d3e5b7a-6544-4d0e-9bd1-e0935424ee18",
      "rows":[ 
        { 
          "id":"b9a08ca7-e010-4ddb-aa2d-ad3ce957fa7f",
          "typ":"Standard",
          "label":null,
          "order":0,
          "content":{ 
            "template":"Efficacy"
          }
        },
        { 
          "id":"6bfd0467-bfbb-433a-8b60-91d194d31ade",
          "typ":"Standard",
          "label":null,
          "order":1,
          "content":{ 
            "template":"Safety"
          }
        },
        { 
          "id":"6fb1a43e-caca-49cc-b77b-e6d5c84970c3",
          "typ":"Standard",
          "label":null,
          "order":3,
          "content":{ 
            "template":"Adverse events"
          }
        },
        { 
          "id":"39dadbf8-ebfb-4844-956e-8cf42f4b1761",
          "typ":"Standard",
          "label":null,
          "order":3,
          "content":{ 
            "template":"Dosing"
          }
        },
        { 
          "id":"08b5f90e-f1d3-467a-a7b9-b206cc6353a1",
          "typ":"Standard",
          "label":null,
          "order":3,
          "content":{ 
            "template":"Mode of administration"
          }
        }
      ],
      "title":null,
      "columns":[ 
        { 
          "id":"117ef226-3144-44d7-8b9a-45c79d0ac5ec",
          "typ":"Standard",
          "label":"1",
          "order":0,
          "content":{ 
            "template":"Highly inferior to existing treatments"
          }
        },
        { 
          "id":"5e86c8ac-d8ae-45f6-988b-308eaa6e5156",
          "typ":"Standard",
          "label":"2",
          "order":1,
          "content":{ 
            "template":""
          }
        },
        { 
          "id":"a74848b9-6d4b-4ea7-bd67-6394edb9131b",
          "typ":"Standard",
          "label":"3",
          "order":2,
          "content":{ 
            "template":""
          }
        },
        { 
          "id":"90c05265-7e27-4962-a90d-10051c5bbc11",
          "typ":"Standard",
          "label":"4",
          "order":3,
          "content":{ 
            "template":""
          }
        },
        { 
          "id":"6e92e280-9961-4886-b87f-d6ef33aff1c6",
          "typ":"Standard",
          "label":"5",
          "order":4,
          "content":{ 
            "template":""
          }
        },
        { 
          "id":"ebf0a6b6-eb6b-42c6-892d-6944e8a88f1b",
          "typ":"Standard",
          "label":"6",
          "order":5,
          "content":{ 
            "template":""
          }
        },
        { 
          "id":"ded4367f-cd3c-4d08-8819-8806de8829fe",
          "typ":"Standard",
          "label":"7",
          "order":6,
          "content":{ 
            "template":"Highly superior to existing treatments"
          }
        }
      ],
      "content":{ 
        "groups":{ 
          "0":{ 
            "text":"Test Profile",
            "placeholder":"Insert product profile"
          }
        },
        "template":"%%0\nPlease rate each of the following attributes from the profile as they compare to other existing treatments with this indication."
      },
      "isLocked":true,
      "isScreener":false,
      "description":null,
      "randomizeRow":true,
      "randomizeColumn":false,
      "requiredOptions":{ 
        "strategy":"OnePerRow"
      },
      "isExclusivePerRow":null,
      "questionTemplateId":"5d5fbdab-4d09-4b14-9d7d-331022862aa8"
    },
    { 
      "isRequired":true,
      "questionType":"RadioButtonList",
      "order":6,
      "createdAt":"2020-01-16T08:22:59.909Z",
      "id":"eef5001e-59b9-405c-a3c7-d99a65334ee9",
      "title":null,
      "content":{ 
        "groups":{ 
          "0":{ 
            "text":"Test product Profile",
            "placeholder":"Insert product profile"
          }
        },
        "template":"%%0\nHow long after this product is approved by the FDA will you make a coverage decision?"
      },
      "isLocked":true,
      "randomize":false,
      "isScreener":false,
      "description":null,
      "answerOptions":[ 
        { 
          "id":"ea9c52bb-c9e3-418d-8458-3646ed80d197",
          "typ":"Standard",
          "label":null,
          "order":0,
          "content":{ 
            "template":"As soon as possible - Product review would be triggered by FDA approval"
          }
        },
        { 
          "id":"dcf7a11f-ee88-4feb-980d-fabe5aa0b5f4",
          "typ":"Standard",
          "label":null,
          "order":1,
          "content":{ 
            "template":"Not immediately but within 3 months"
          }
        },
        { 
          "id":"9e577da2-35ec-4562-a540-446a88d66e59",
          "typ":"Standard",
          "label":null,
          "order":2,
          "content":{ 
            "template":"More than 3 months but within 6 months"
          }
        },
        { 
          "id":"5db90297-1c33-4a6f-9f9b-eb5b2d3fbfd3",
          "typ":"Standard",
          "label":null,
          "order":3,
          "content":{ 
            "template":"More than 6 months but within a year"
          }
        },
        { 
          "id":"ef57e721-8d03-4fef-854e-f3aedd4b1cae",
          "typ":"Standard",
          "label":null,
          "order":4,
          "content":{ 
            "template":"More than a year after approval"
          }
        },
        { 
          "id":"34173afc-0244-40b6-ad3c-a1914abd4d27",
          "typ":"ParticipantDefined",
          "label":null,
          "order":5,
          "content":{ 
            "template":"Other: [Specify]"
          }
        }
      ],
      "requiredOptions":null,
      "questionTemplateId":"970b49e5-59ac-409e-b527-a5c7a6143fe9"
    },
    { 
      "isRequired":true,
      "questionType":"RadioButtonList",
      "order":7,
      "createdAt":"2020-01-16T08:22:59.909Z",
      "id":"e4ab5e7c-c9c0-44a6-b6ab-f48ba84296c6",
      "title":null,
      "content":{ 
        "template":"How is your organization likely to cover this product on your organization’s most common formulary (e.g., commercial, Medicare/Part D, Medicaid)?"
      },
      "isLocked":true,
      "randomize":false,
      "isScreener":false,
      "description":null,
      "answerOptions":[ 
        { 
          "id":"5a4b3e00-0cd6-4ee9-aac7-20db8f734bff",
          "typ":"Standard",
          "label":null,
          "order":0,
          "content":{ 
            "template":"Preferred tier"
          }
        },
        { 
          "id":"b5aafc1f-eaa6-40f4-9f4c-43cc4fb90dd9",
          "typ":"Standard",
          "label":null,
          "order":1,
          "content":{ 
            "template":"Non-preferred tier"
          }
        },
        { 
          "id":"350e661f-4bdd-4bb6-9cef-a8d9ec582828",
          "typ":"Standard",
          "label":null,
          "order":2,
          "content":{ 
            "template":"Specialty tier"
          }
        },
        { 
          "id":"1cabd902-8e16-48a1-95a7-555ab47d213b",
          "typ":"Standard",
          "label":null,
          "order":3,
          "content":{ 
            "template":"Not covered"
          }
        },
        { 
          "id":"d0ffd0e7-b0b5-4cf3-821c-6c4491d009bb",
          "typ":"NA",
          "label":null,
          "order":4,
          "content":{ 
            "template":"Don’t know"
          }
        }
      ],
      "requiredOptions":null,
      "questionTemplateId":"0590652a-7572-46e9-a956-5044c16c2f68"
    },
    { 
      "isRequired":true,
      "questionType":"OpenEndedText",
      "order":8,
      "createdAt":"2020-01-16T08:22:59.909Z",
      "id":"0d895e12-46ec-4dfd-8bda-561d281215f5",
      "title":null,
      "content":{ 
        "groups":{ 
          "0":{ 
            "text":"Test Product Profile",
            "placeholder":"Insert product profile"
          }
        },
        "template":"%%0\nWhat additional information or data would you need to see for this product to make it a preferred product?"
      },
      "isLocked":true,
      "isScreener":false,
      "description":null,
      "questionTemplateId":"a923a546-9e4d-419e-9972-9d7cb3648c00"
    },
    { 
      "isRequired":true,
      "questionType":"CheckboxList",
      "order":9,
      "createdAt":"2020-01-16T08:22:59.909Z",
      "id":"016764da-cad6-47b3-a16a-90d3e834a7f7",
      "title":null,
      "content":{ 
        "template":"What restrictions, if any, is your organization likely to place on this product on your most common formulary (e.g., commercial, Medicare/Part D, Medicaid)?"
      },
      "isLocked":true,
      "randomize":true,
      "isScreener":false,
      "description":null,
      "answerOptions":[ 
        { 
          "id":"9c026938-5331-4437-9a8c-31dc1bb9f6fe",
          "typ":"Standard",
          "label":null,
          "order":0,
          "content":{ 
            "template":"Prior authorization"
          }
        },
        { 
          "id":"9619af70-6ae5-4bf9-a5d5-b3ad1e1b11ef",
          "typ":"Standard",
          "label":null,
          "order":1,
          "content":{ 
            "template":"Step through generic"
          }
        },
        { 
          "id":"deab0c22-82d9-4a10-a038-9a470bf16ce7",
          "typ":"Standard",
          "label":null,
          "order":2,
          "content":{ 
            "template":"Step through preferred brand"
          }
        },
        { 
          "id":"6c121bcd-f6ef-4b6b-a99b-e892451d007e",
          "typ":"Standard",
          "label":null,
          "order":3,
          "content":{ 
            "template":"Quantity limit"
          }
        },
        { 
          "id":"447e4c33-e926-4a85-952a-491fbf6af617",
          "typ":"ParticipantDefined",
          "label":null,
          "order":4,
          "content":{ 
            "template":"Other: [Specify]"
          }
        },
        { 
          "id":"c5d423fa-e302-40e7-86be-8dc3ec18fdcf",
          "typ":"NA",
          "label":null,
          "order":5,
          "content":{ 
            "template":"No restrictions"
          }
        }
      ],
      "requiredOptions":null,
      "questionTemplateId":"b880b4b3-e902-4497-af3e-e59c1dc2e14c"
    }
  ],
  "screeners":[ 

  ],
  "deleted":[ 

  ],
  "sourceTitle":"Formulary receptivity and potential restrictions"
}) as unknown as SurveySchema;

export const getMockedSurveyResults = () => ([
	{
		"questionId":"c8bf7ed8-45b5-41e7-a485-acb9f7a43786",
		"listResults":null,
		"gridResults":{
			"rowLabels":[
				"Improved clinical efficacy or outcomes compared to standard of care",
				"Increased patient compliance with therapy",
				"Reduced adverse events",
				"Reduced healthcare resource utilization compared to standard of care"
			],
			"columnLabels":[
				"Very Low",
				"2",
				"3",
				"4",
				"5",
				"6",
				"Very high need"
			],
			"data":[
				{
					"rowIdx":0,
					"columnIdx":0,
					"count":0,
					"rowPercent":0.0
				},
				{
					"rowIdx":0,
					"columnIdx":1,
					"count":0,
					"rowPercent":0.0
				},
				{
					"rowIdx":0,
					"columnIdx":2,
					"count":2,
					"rowPercent":66.67
				},
				{
					"rowIdx":0,
					"columnIdx":3,
					"count":0,
					"rowPercent":0.0
				},
				{
					"rowIdx":0,
					"columnIdx":4,
					"count":0,
					"rowPercent":0.0
				},
				{
					"rowIdx":0,
					"columnIdx":5,
					"count":0,
					"rowPercent":0.0
				},
				{
					"rowIdx":0,
					"columnIdx":6,
					"count":1,
					"rowPercent":33.33
				},
				{
					"rowIdx":1,
					"columnIdx":0,
					"count":0,
					"rowPercent":0.0
				},
				{
					"rowIdx":1,
					"columnIdx":1,
					"count":0,
					"rowPercent":0.0
				},
				{
					"rowIdx":1,
					"columnIdx":2,
					"count":0,
					"rowPercent":0.0
				},
				{
					"rowIdx":1,
					"columnIdx":3,
					"count":3,
					"rowPercent":100.0
				},
				{
					"rowIdx":1,
					"columnIdx":4,
					"count":0,
					"rowPercent":0.0
				},
				{
					"rowIdx":1,
					"columnIdx":5,
					"count":0,
					"rowPercent":0.0
				},
				{
					"rowIdx":1,
					"columnIdx":6,
					"count":0,
					"rowPercent":0.0
				},
				{
					"rowIdx":2,
					"columnIdx":0,
					"count":0,
					"rowPercent":0.0
				},
				{
					"rowIdx":2,
					"columnIdx":1,
					"count":2,
					"rowPercent":66.67
				},
				{
					"rowIdx":2,
					"columnIdx":2,
					"count":0,
					"rowPercent":0.0
				},
				{
					"rowIdx":2,
					"columnIdx":3,
					"count":1,
					"rowPercent":33.33
				},
				{
					"rowIdx":2,
					"columnIdx":4,
					"count":0,
					"rowPercent":0.0
				},
				{
					"rowIdx":2,
					"columnIdx":5,
					"count":0,
					"rowPercent":0.0
				},
				{
					"rowIdx":2,
					"columnIdx":6,
					"count":0,
					"rowPercent":0.0
				},
				{
					"rowIdx":3,
					"columnIdx":0,
					"count":0,
					"rowPercent":0.0
				},
				{
					"rowIdx":3,
					"columnIdx":1,
					"count":0,
					"rowPercent":0.0
				},
				{
					"rowIdx":3,
					"columnIdx":2,
					"count":1,
					"rowPercent":33.33
				},
				{
					"rowIdx":3,
					"columnIdx":3,
					"count":0,
					"rowPercent":0.0
				},
				{
					"rowIdx":3,
					"columnIdx":4,
					"count":0,
					"rowPercent":0.0
				},
				{
					"rowIdx":3,
					"columnIdx":5,
					"count":1,
					"rowPercent":33.33
				},
				{
					"rowIdx":3,
					"columnIdx":6,
					"count":1,
					"rowPercent":33.33
				}
			]
		},
		"statisticsTableResults":null,
		"responseByCountResults":[

		]
	},
	{
		"questionId":"85d63812-f261-4fcf-8e35-812bb3433638",
		"listResults":null,
		"gridResults":{
			"rowLabels":[
				"Preferred tier",
				"Non-preferred tier",
				"Specialty tier",
				"Not covered",
				"Don’t know"
			],
			"columnLabels":[
				"Product A",
				"Product B",
				"Product C"
			],
			"data":[
				{
					"rowIdx":0,
					"columnIdx":0,
					"count":0,
					"rowPercent":0.0
				},
				{
					"rowIdx":0,
					"columnIdx":1,
					"count":2,
					"rowPercent":66.67
				},
				{
					"rowIdx":0,
					"columnIdx":2,
					"count":1,
					"rowPercent":33.33
				},
				{
					"rowIdx":1,
					"columnIdx":0,
					"count":2,
					"rowPercent":100.0
				},
				{
					"rowIdx":1,
					"columnIdx":1,
					"count":0,
					"rowPercent":0.0
				},
				{
					"rowIdx":1,
					"columnIdx":2,
					"count":0,
					"rowPercent":0.0
				},
				{
					"rowIdx":2,
					"columnIdx":0,
					"count":0,
					"rowPercent":0.0
				},
				{
					"rowIdx":2,
					"columnIdx":1,
					"count":1,
					"rowPercent":50.0
				},
				{
					"rowIdx":2,
					"columnIdx":2,
					"count":1,
					"rowPercent":50.0
				},
				{
					"rowIdx":3,
					"columnIdx":0,
					"count":0,
					"rowPercent":0.0
				},
				{
					"rowIdx":3,
					"columnIdx":1,
					"count":0,
					"rowPercent":0.0
				},
				{
					"rowIdx":3,
					"columnIdx":2,
					"count":1,
					"rowPercent":100.0
				},
				{
					"rowIdx":4,
					"columnIdx":0,
					"count":1,
					"rowPercent":100.0
				},
				{
					"rowIdx":4,
					"columnIdx":1,
					"count":0,
					"rowPercent":0.0
				},
				{
					"rowIdx":4,
					"columnIdx":2,
					"count":0,
					"rowPercent":0.0
				}
			]
		},
		"statisticsTableResults":null,
		"responseByCountResults":[

		]
	},
	{
		"questionId":"811d4622-883b-4342-92eb-d46167e7111d",
		"listResults":null,
		"gridResults":{
			"rowLabels":[
				"Prior authorization",
				"Step through generic",
				"Step through preferred brand",
				"Quantity limit",
				"Other: [Specify]",
				"No restrictions"
			],
			"columnLabels":[
				"Product A",
				"Product B",
				"Product C"
			],
			"data":[
				{
					"rowIdx":0,
					"columnIdx":0,
					"count":1,
					"rowPercent":50.0
				},
				{
					"rowIdx":0,
					"columnIdx":1,
					"count":0,
					"rowPercent":0.0
				},
				{
					"rowIdx":0,
					"columnIdx":2,
					"count":1,
					"rowPercent":50.0
				},
				{
					"rowIdx":1,
					"columnIdx":0,
					"count":1,
					"rowPercent":100.0
				},
				{
					"rowIdx":1,
					"columnIdx":1,
					"count":0,
					"rowPercent":0.0
				},
				{
					"rowIdx":1,
					"columnIdx":2,
					"count":0,
					"rowPercent":0.0
				},
				{
					"rowIdx":2,
					"columnIdx":0,
					"count":0,
					"rowPercent":0.0
				},
				{
					"rowIdx":2,
					"columnIdx":1,
					"count":1,
					"rowPercent":50.0
				},
				{
					"rowIdx":2,
					"columnIdx":2,
					"count":1,
					"rowPercent":50.0
				},
				{
					"rowIdx":3,
					"columnIdx":0,
					"count":0,
					"rowPercent":0.0
				},
				{
					"rowIdx":3,
					"columnIdx":1,
					"count":2,
					"rowPercent":66.67
				},
				{
					"rowIdx":3,
					"columnIdx":2,
					"count":1,
					"rowPercent":33.33
				},
				{
					"rowIdx":4,
					"columnIdx":0,
					"count":1,
					"rowPercent":50.0
				},
				{
					"rowIdx":4,
					"columnIdx":1,
					"count":0,
					"rowPercent":0.0
				},
				{
					"rowIdx":4,
					"columnIdx":2,
					"count":1,
					"rowPercent":50.0
				},
				{
					"rowIdx":5,
					"columnIdx":0,
					"count":1,
					"rowPercent":100.0
				},
				{
					"rowIdx":5,
					"columnIdx":1,
					"count":0,
					"rowPercent":0.0
				},
				{
					"rowIdx":5,
					"columnIdx":2,
					"count":0,
					"rowPercent":0.0
				}
			]
		},
		"statisticsTableResults":null,
		"responseByCountResults":[

		]
	},
	{
		"questionId":"bbc42fe2-3a45-40e9-b944-09576e8a275b",
		"listResults":null,
		"gridResults":null,
		"statisticsTableResults":{
			"labels":[
				"Easier dosing or administration",
				"Indication breadth",
				"Comparative data documenting higher efficacy versus competitors",
				"Comparative data documenting fewer safety risks versus competitors",
				"Experience/comfort with product (length of time on market)",
				"Net cost differential between brands",
				"Considerable demand from KOLs, members, and providers",
				"Health economic outcomes research (HEOR) data"
			],
			"data":[
				{
					"index":0,
					"avg":10.33,
					"min":10.0,
					"max":11.0,
					"totalResponses":3
				},
				{
					"index":1,
					"avg":13.67,
					"min":10.0,
					"max":20.0,
					"totalResponses":3
				},
				{
					"index":2,
					"avg":8.67,
					"min":5.0,
					"max":11.0,
					"totalResponses":3
				},
				{
					"index":3,
					"avg":10.33,
					"min":10.0,
					"max":11.0,
					"totalResponses":3
				},
				{
					"index":4,
					"avg":24.33,
					"min":20.0,
					"max":30.0,
					"totalResponses":3
				},
				{
					"index":5,
					"avg":10.33,
					"min":10.0,
					"max":11.0,
					"totalResponses":3
				},
				{
					"index":6,
					"avg":13.67,
					"min":10.0,
					"max":20.0,
					"totalResponses":3
				},
				{
					"index":7,
					"avg":8.67,
					"min":5.0,
					"max":11.0,
					"totalResponses":3
				}
			]
		},
		"responseByCountResults":[

		]
	},
	{
		"questionId":"11faf69c-b9c2-4cdc-8321-241906753bf9",
		"listResults":null,
		"gridResults":null,
		"statisticsTableResults":null,
		"responseByCountResults":[
			{
				"index":0,
				"count":2,
				"response":"test"
			},
			{
				"index":1,
				"count":1,
				"response":"teeest"
			}
		]
	},
	{
		"questionId":"2d3e5b7a-6544-4d0e-9bd1-e0935424ee18",
		"listResults":null,
		"gridResults":{
			"rowLabels":[
				"Efficacy",
				"Safety",
				"Adverse events",
				"Dosing",
				"Mode of administration"
			],
			"columnLabels":[
				"Highly inferior to existing treatments",
				"2",
				"3",
				"4",
				"5",
				"6",
				"Highly superior to existing treatments"
			],
			"data":[
				{
					"rowIdx":0,
					"columnIdx":0,
					"count":0,
					"rowPercent":0.0
				},
				{
					"rowIdx":0,
					"columnIdx":1,
					"count":1,
					"rowPercent":33.33
				},
				{
					"rowIdx":0,
					"columnIdx":2,
					"count":0,
					"rowPercent":0.0
				},
				{
					"rowIdx":0,
					"columnIdx":3,
					"count":0,
					"rowPercent":0.0
				},
				{
					"rowIdx":0,
					"columnIdx":4,
					"count":1,
					"rowPercent":33.33
				},
				{
					"rowIdx":0,
					"columnIdx":5,
					"count":0,
					"rowPercent":0.0
				},
				{
					"rowIdx":0,
					"columnIdx":6,
					"count":1,
					"rowPercent":33.33
				},
				{
					"rowIdx":1,
					"columnIdx":0,
					"count":1,
					"rowPercent":33.33
				},
				{
					"rowIdx":1,
					"columnIdx":1,
					"count":1,
					"rowPercent":33.33
				},
				{
					"rowIdx":1,
					"columnIdx":2,
					"count":1,
					"rowPercent":33.33
				},
				{
					"rowIdx":1,
					"columnIdx":3,
					"count":0,
					"rowPercent":0.0
				},
				{
					"rowIdx":1,
					"columnIdx":4,
					"count":0,
					"rowPercent":0.0
				},
				{
					"rowIdx":1,
					"columnIdx":5,
					"count":0,
					"rowPercent":0.0
				},
				{
					"rowIdx":1,
					"columnIdx":6,
					"count":0,
					"rowPercent":0.0
				},
				{
					"rowIdx":2,
					"columnIdx":0,
					"count":1,
					"rowPercent":33.33
				},
				{
					"rowIdx":2,
					"columnIdx":1,
					"count":0,
					"rowPercent":0.0
				},
				{
					"rowIdx":2,
					"columnIdx":2,
					"count":0,
					"rowPercent":0.0
				},
				{
					"rowIdx":2,
					"columnIdx":3,
					"count":1,
					"rowPercent":33.33
				},
				{
					"rowIdx":2,
					"columnIdx":4,
					"count":1,
					"rowPercent":33.33
				},
				{
					"rowIdx":2,
					"columnIdx":5,
					"count":0,
					"rowPercent":0.0
				},
				{
					"rowIdx":2,
					"columnIdx":6,
					"count":0,
					"rowPercent":0.0
				},
				{
					"rowIdx":3,
					"columnIdx":0,
					"count":0,
					"rowPercent":0.0
				},
				{
					"rowIdx":3,
					"columnIdx":1,
					"count":1,
					"rowPercent":33.33
				},
				{
					"rowIdx":3,
					"columnIdx":2,
					"count":1,
					"rowPercent":33.33
				},
				{
					"rowIdx":3,
					"columnIdx":3,
					"count":1,
					"rowPercent":33.33
				},
				{
					"rowIdx":3,
					"columnIdx":4,
					"count":0,
					"rowPercent":0.0
				},
				{
					"rowIdx":3,
					"columnIdx":5,
					"count":0,
					"rowPercent":0.0
				},
				{
					"rowIdx":3,
					"columnIdx":6,
					"count":0,
					"rowPercent":0.0
				},
				{
					"rowIdx":4,
					"columnIdx":0,
					"count":0,
					"rowPercent":0.0
				},
				{
					"rowIdx":4,
					"columnIdx":1,
					"count":0,
					"rowPercent":0.0
				},
				{
					"rowIdx":4,
					"columnIdx":2,
					"count":0,
					"rowPercent":0.0
				},
				{
					"rowIdx":4,
					"columnIdx":3,
					"count":1,
					"rowPercent":33.33
				},
				{
					"rowIdx":4,
					"columnIdx":4,
					"count":1,
					"rowPercent":33.33
				},
				{
					"rowIdx":4,
					"columnIdx":5,
					"count":1,
					"rowPercent":33.33
				},
				{
					"rowIdx":4,
					"columnIdx":6,
					"count":0,
					"rowPercent":0.0
				}
			]
		},
		"statisticsTableResults":null,
		"responseByCountResults":[

		]
	},
	{
		"questionId":"eef5001e-59b9-405c-a3c7-d99a65334ee9",
		"listResults":{
			"labels":[
				"As soon as possible - Product review would be triggered by FDA approval",
				"Not immediately but within 3 months",
				"More than 3 months but within 6 months",
				"More than 6 months but within a year",
				"More than a year after approval",
				"Other: [Specify]"
			],
			"data":[
				{
					"index":0,
					"count":1,
					"percent":33.33
				},
				{
					"index":1,
					"count":0,
					"percent":0.0
				},
				{
					"index":2,
					"count":0,
					"percent":0.0
				},
				{
					"index":3,
					"count":0,
					"percent":0.0
				},
				{
					"index":4,
					"count":0,
					"percent":0.0
				},
				{
					"index":5,
					"count":2,
					"percent":66.67
				}
			]
		},
		"gridResults":null,
		"statisticsTableResults":null,
		"responseByCountResults":[

		]
	},
	{
		"questionId":"e4ab5e7c-c9c0-44a6-b6ab-f48ba84296c6",
		"listResults":{
			"labels":[
				"Preferred tier",
				"Non-preferred tier",
				"Specialty tier",
				"Not covered",
				"Don’t know"
			],
			"data":[
				{
					"index":0,
					"count":1,
					"percent":33.33
				},
				{
					"index":1,
					"count":0,
					"percent":0.0
				},
				{
					"index":2,
					"count":0,
					"percent":0.0
				},
				{
					"index":3,
					"count":2,
					"percent":66.67
				},
				{
					"index":4,
					"count":0,
					"percent":0.0
				}
			]
		},
		"gridResults":null,
		"statisticsTableResults":null,
		"responseByCountResults":[

		]
	},
	{
		"questionId":"0d895e12-46ec-4dfd-8bda-561d281215f5",
		"listResults":null,
		"gridResults":null,
		"statisticsTableResults":null,
		"responseByCountResults":[
			{
				"index":0,
				"count":2,
				"response":"test"
			},
			{
				"index":1,
				"count":1,
				"response":"text"
			}
		]
	},
	{
		"questionId":"016764da-cad6-47b3-a16a-90d3e834a7f7",
		"listResults":{
			"labels":[
				"Prior authorization",
				"Step through generic",
				"Step through preferred brand",
				"Quantity limit",
				"Other: [Specify]",
				"No restrictions"
			],
			"data":[
				{
					"index":0,
					"count":2,
					"percent":50.0
				},
				{
					"index":1,
					"count":2,
					"percent":50.0
				},
				{
					"index":2,
					"count":0,
					"percent":0.0
				},
				{
					"index":3,
					"count":0,
					"percent":0.0
				},
				{
					"index":4,
					"count":0,
					"percent":0.0
				},
				{
					"index":5,
					"count":0,
					"percent":0.0
				}
			]
		},
		"gridResults":null,
		"statisticsTableResults":null,
		"responseByCountResults":[

		]
	}
] as unknown as QuestionResults[]);

export const getMockedAnswerCount = () => ({"current":3,"total":15}) as unknown as AnswersCount;